// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../node_modules/react-slideshow-image/dist/styles.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%2386b7fe%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23212529%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23052c65%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%236ea8fe%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("./assets/font/Lexend-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("./assets/font/Lexend-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("./assets/font/Lexend-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("./assets/font/Lexend-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("./assets/font/Inter-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("./assets/images/background_scan.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("./assets/images/scan_frame.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("./assets/icon/keyboard_arrow_down_green_20x20.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("./assets/icon/attachment.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("./assets/icon/date_range.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("data:image/svg+xml,%3csvg width=%27100%25%27 height=%27100%25%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3crect width=%27100%25%27 height=%27100%25%27 fill=%27none%27 rx=%274%27 ry=%274%27 stroke=%27%233B927DFF%27 stroke-width=%274%27 stroke-dasharray=%273%2c 11%27 stroke-dashoffset=%270%27 stroke-linecap=%27square%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
   * Bootstrap  v5.3.6 (https://getbootstrap.com/)
   * Copyright 2011-2025 The Bootstrap Authors
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   */
:root,
[data-bs-theme="light"] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 13, 110, 253;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 25, 135, 84;
  --bs-info-rgb: 13, 202, 240;
  --bs-warning-rgb: 255, 193, 7;
  --bs-danger-rgb: 220, 53, 69;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 33, 37, 41;
  --bs-primary-text-emphasis: #052c65;
  --bs-secondary-text-emphasis: #2b2f32;
  --bs-success-text-emphasis: #0a3622;
  --bs-info-text-emphasis: #055160;
  --bs-warning-text-emphasis: #664d03;
  --bs-danger-text-emphasis: #58151c;
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: #cfe2ff;
  --bs-secondary-bg-subtle: #e2e3e5;
  --bs-success-bg-subtle: #d1e7dd;
  --bs-info-bg-subtle: #cff4fc;
  --bs-warning-bg-subtle: #fff3cd;
  --bs-danger-bg-subtle: #f8d7da;
  --bs-light-bg-subtle: #fcfcfd;
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: #9ec5fe;
  --bs-secondary-border-subtle: #c4c8cb;
  --bs-success-border-subtle: #a3cfbb;
  --bs-info-border-subtle: #9eeaf9;
  --bs-warning-border-subtle: #ffe69c;
  --bs-danger-border-subtle: #f1aeb5;
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg: #fff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #0d6efd;
  --bs-link-color-rgb: 13, 110, 253;
  --bs-link-decoration: underline;
  --bs-link-hover-color: #0a58ca;
  --bs-link-hover-color-rgb: 10, 88, 202;
  --bs-code-color: #d63384;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: #fff3cd;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545; }

[data-bs-theme="dark"] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: #2b3035;
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: #6ea8fe;
  --bs-secondary-text-emphasis: #a7acb1;
  --bs-success-text-emphasis: #75b798;
  --bs-info-text-emphasis: #6edff6;
  --bs-warning-text-emphasis: #ffda6a;
  --bs-danger-text-emphasis: #ea868f;
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: #031633;
  --bs-secondary-bg-subtle: #161719;
  --bs-success-bg-subtle: #051b11;
  --bs-info-bg-subtle: #032830;
  --bs-warning-bg-subtle: #332701;
  --bs-danger-bg-subtle: #2c0b0e;
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: #084298;
  --bs-secondary-border-subtle: #41464b;
  --bs-success-border-subtle: #0f5132;
  --bs-info-border-subtle: #087990;
  --bs-warning-border-subtle: #997404;
  --bs-danger-border-subtle: #842029;
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: #6ea8fe;
  --bs-link-hover-color: #8bb9fe;
  --bs-link-color-rgb: 110, 168, 254;
  --bs-link-hover-color-rgb: 139, 185, 254;
  --bs-code-color: #e685b5;
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: #664d03;
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: #75b798;
  --bs-form-valid-border-color: #75b798;
  --bs-form-invalid-color: #ea868f;
  --bs-form-invalid-border-color: #ea868f; }

*,
*::before,
*::after {
  box-sizing: border-box; }

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth; } }

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); }

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25; }

h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color); }

h1, .h1 {
  font-size: calc(1.375rem + 1.5vw); }
  @media (min-width: 1200px) {
    h1, .h1 {
      font-size: 2.5rem; } }

h2, .h2 {
  font-size: calc(1.325rem + 0.9vw); }
  @media (min-width: 1200px) {
    h2, .h2 {
      font-size: 2rem; } }

h3, .h3 {
  font-size: calc(1.3rem + 0.6vw); }
  @media (min-width: 1200px) {
    h3, .h3 {
      font-size: 1.75rem; } }

h4, .h4 {
  font-size: calc(1.275rem + 0.3vw); }
  @media (min-width: 1200px) {
    h4, .h4 {
      font-size: 1.5rem; } }

h5, .h5 {
  font-size: 1.25rem; }

h6, .h6 {
  font-size: 1rem; }

p {
  margin-top: 0;
  margin-bottom: 1rem; }

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none; }

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit; }

ol,
ul {
  padding-left: 2rem; }

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem; }

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0; }

dt {
  font-weight: 700; }

dd {
  margin-bottom: .5rem;
  margin-left: 0; }

blockquote {
  margin: 0 0 1rem; }

b,
strong {
  font-weight: bolder; }

small, .small {
  font-size: 0.875em; }

mark, .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg); }

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline; }

sub {
  bottom: -.25em; }

sup {
  top: -.5em; }

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline; }
  a:hover {
    --bs-link-color-rgb: var(--bs-link-hover-color-rgb); }

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none; }

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em; }

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em; }
  pre code {
    font-size: inherit;
    color: inherit;
    word-break: normal; }

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word; }
  a > code {
    color: inherit; }

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem; }
  kbd kbd {
    padding: 0;
    font-size: 1em; }

figure {
  margin: 0 0 1rem; }

img,
svg {
  vertical-align: middle; }

table {
  caption-side: bottom;
  border-collapse: collapse; }

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
  text-align: left; }

th {
  text-align: inherit;
  text-align: -webkit-match-parent; }

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0; }

label {
  display: inline-block; }

button {
  border-radius: 0; }

button:focus:not(:focus-visible) {
  outline: 0; }

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit; }

button,
select {
  text-transform: none; }

[role="button"] {
  cursor: pointer; }

select {
  word-wrap: normal; }
  select:disabled {
    opacity: 1; }

[list]:not([type="date"]):not([type="datetime-local"]):not([type="month"]):not([type="week"]):not([type="time"])::-webkit-calendar-picker-indicator {
  display: none !important; }

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button; }
  button:not(:disabled),
  [type="button"]:not(:disabled),
  [type="reset"]:not(:disabled),
  [type="submit"]:not(:disabled) {
    cursor: pointer; }

::-moz-focus-inner {
  padding: 0;
  border-style: none; }

textarea {
  resize: vertical; }

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0; }

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  line-height: inherit;
  font-size: calc(1.275rem + 0.3vw); }
  @media (min-width: 1200px) {
    legend {
      font-size: 1.5rem; } }
  legend + * {
    clear: left; }

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0; }

::-webkit-inner-spin-button {
  height: auto; }

[type="search"] {
  -webkit-appearance: textfield;
  outline-offset: -2px; }

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none; }

::-webkit-color-swatch-wrapper {
  padding: 0; }

::file-selector-button {
  font: inherit;
  -webkit-appearance: button; }

output {
  display: inline-block; }

iframe {
  border: 0; }

summary {
  display: list-item;
  cursor: pointer; }

progress {
  vertical-align: baseline; }

[hidden] {
  display: none !important; }

.lead {
  font-size: 1.25rem;
  font-weight: 300; }

.display-1 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.625rem + 4.5vw); }
  @media (min-width: 1200px) {
    .display-1 {
      font-size: 5rem; } }

.display-2 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.575rem + 3.9vw); }
  @media (min-width: 1200px) {
    .display-2 {
      font-size: 4.5rem; } }

.display-3 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.525rem + 3.3vw); }
  @media (min-width: 1200px) {
    .display-3 {
      font-size: 4rem; } }

.display-4 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.475rem + 2.7vw); }
  @media (min-width: 1200px) {
    .display-4 {
      font-size: 3.5rem; } }

.display-5 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.425rem + 2.1vw); }
  @media (min-width: 1200px) {
    .display-5 {
      font-size: 3rem; } }

.display-6 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.375rem + 1.5vw); }
  @media (min-width: 1200px) {
    .display-6 {
      font-size: 2.5rem; } }

.list-unstyled {
  padding-left: 0;
  list-style: none; }

.list-inline {
  padding-left: 0;
  list-style: none; }

.list-inline-item {
  display: inline-block; }
  .list-inline-item:not(:last-child) {
    margin-right: 0.5rem; }

.initialism {
  font-size: 0.875em;
  text-transform: uppercase; }

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem; }
  .blockquote > :last-child {
    margin-bottom: 0; }

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d; }
  .blockquote-footer::before {
    content: "\\2014\\00A0"; }

.img-fluid {
  max-width: 100%;
  height: auto; }

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto; }

.figure {
  display: inline-block; }

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1; }

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color); }

.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl,
.container-xxl {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * .5);
  padding-left: calc(var(--bs-gutter-x) * .5);
  margin-right: auto;
  margin-left: auto; }

@media (min-width: 576px) {
  .container, .container-sm {
    max-width: 540px; } }

@media (min-width: 768px) {
  .container, .container-sm, .container-md {
    max-width: 720px; } }

@media (min-width: 992px) {
  .container, .container-sm, .container-md, .container-lg {
    max-width: 960px; } }

@media (min-width: 1200px) {
  .container, .container-sm, .container-md, .container-lg, .container-xl {
    max-width: 1140px; } }

@media (min-width: 1400px) {
  .container, .container-sm, .container-md, .container-lg, .container-xl, .container-xxl {
    max-width: 1320px; } }

:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px; }

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-.5 * var(--bs-gutter-x));
  margin-left: calc(-.5 * var(--bs-gutter-x)); }
  .row > * {
    flex-shrink: 0;
    width: 100%;
    max-width: 100%;
    padding-right: calc(var(--bs-gutter-x) * .5);
    padding-left: calc(var(--bs-gutter-x) * .5);
    margin-top: var(--bs-gutter-y); }

.col {
  flex: 1 0; }

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto; }

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%; }

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%; }

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333%; }

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%; }

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%; }

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66667%; }

.col-auto {
  flex: 0 0 auto;
  width: auto; }

.col-1 {
  flex: 0 0 auto;
  width: 8.33333%; }

.col-2 {
  flex: 0 0 auto;
  width: 16.66667%; }

.col-3 {
  flex: 0 0 auto;
  width: 25%; }

.col-4 {
  flex: 0 0 auto;
  width: 33.33333%; }

.col-5 {
  flex: 0 0 auto;
  width: 41.66667%; }

.col-6 {
  flex: 0 0 auto;
  width: 50%; }

.col-7 {
  flex: 0 0 auto;
  width: 58.33333%; }

.col-8 {
  flex: 0 0 auto;
  width: 66.66667%; }

.col-9 {
  flex: 0 0 auto;
  width: 75%; }

.col-10 {
  flex: 0 0 auto;
  width: 83.33333%; }

.col-11 {
  flex: 0 0 auto;
  width: 91.66667%; }

.col-12 {
  flex: 0 0 auto;
  width: 100%; }

.offset-1 {
  margin-left: 8.33333%; }

.offset-2 {
  margin-left: 16.66667%; }

.offset-3 {
  margin-left: 25%; }

.offset-4 {
  margin-left: 33.33333%; }

.offset-5 {
  margin-left: 41.66667%; }

.offset-6 {
  margin-left: 50%; }

.offset-7 {
  margin-left: 58.33333%; }

.offset-8 {
  margin-left: 66.66667%; }

.offset-9 {
  margin-left: 75%; }

.offset-10 {
  margin-left: 83.33333%; }

.offset-11 {
  margin-left: 91.66667%; }

.g-0,
.gx-0 {
  --bs-gutter-x: 0; }

.g-0,
.gy-0 {
  --bs-gutter-y: 0; }

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem; }

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem; }

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem; }

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem; }

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem; }

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem; }

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem; }

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem; }

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem; }

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem; }

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0; }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%; }
  .offset-sm-0 {
    margin-left: 0; }
  .offset-sm-1 {
    margin-left: 8.33333%; }
  .offset-sm-2 {
    margin-left: 16.66667%; }
  .offset-sm-3 {
    margin-left: 25%; }
  .offset-sm-4 {
    margin-left: 33.33333%; }
  .offset-sm-5 {
    margin-left: 41.66667%; }
  .offset-sm-6 {
    margin-left: 50%; }
  .offset-sm-7 {
    margin-left: 58.33333%; }
  .offset-sm-8 {
    margin-left: 66.66667%; }
  .offset-sm-9 {
    margin-left: 75%; }
  .offset-sm-10 {
    margin-left: 83.33333%; }
  .offset-sm-11 {
    margin-left: 91.66667%; }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0; }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0; }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem; }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem; }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem; }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem; }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem; }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem; }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem; }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem; }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem; }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem; } }

@media (min-width: 768px) {
  .col-md {
    flex: 1 0; }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%; }
  .offset-md-0 {
    margin-left: 0; }
  .offset-md-1 {
    margin-left: 8.33333%; }
  .offset-md-2 {
    margin-left: 16.66667%; }
  .offset-md-3 {
    margin-left: 25%; }
  .offset-md-4 {
    margin-left: 33.33333%; }
  .offset-md-5 {
    margin-left: 41.66667%; }
  .offset-md-6 {
    margin-left: 50%; }
  .offset-md-7 {
    margin-left: 58.33333%; }
  .offset-md-8 {
    margin-left: 66.66667%; }
  .offset-md-9 {
    margin-left: 75%; }
  .offset-md-10 {
    margin-left: 83.33333%; }
  .offset-md-11 {
    margin-left: 91.66667%; }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0; }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0; }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem; }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem; }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem; }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem; }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem; }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem; }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem; }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem; }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem; }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem; } }

@media (min-width: 992px) {
  .col-lg {
    flex: 1 0; }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%; }
  .offset-lg-0 {
    margin-left: 0; }
  .offset-lg-1 {
    margin-left: 8.33333%; }
  .offset-lg-2 {
    margin-left: 16.66667%; }
  .offset-lg-3 {
    margin-left: 25%; }
  .offset-lg-4 {
    margin-left: 33.33333%; }
  .offset-lg-5 {
    margin-left: 41.66667%; }
  .offset-lg-6 {
    margin-left: 50%; }
  .offset-lg-7 {
    margin-left: 58.33333%; }
  .offset-lg-8 {
    margin-left: 66.66667%; }
  .offset-lg-9 {
    margin-left: 75%; }
  .offset-lg-10 {
    margin-left: 83.33333%; }
  .offset-lg-11 {
    margin-left: 91.66667%; }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0; }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0; }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem; }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem; }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem; }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem; }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem; }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem; }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem; }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem; }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem; }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem; } }

@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0; }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%; }
  .offset-xl-0 {
    margin-left: 0; }
  .offset-xl-1 {
    margin-left: 8.33333%; }
  .offset-xl-2 {
    margin-left: 16.66667%; }
  .offset-xl-3 {
    margin-left: 25%; }
  .offset-xl-4 {
    margin-left: 33.33333%; }
  .offset-xl-5 {
    margin-left: 41.66667%; }
  .offset-xl-6 {
    margin-left: 50%; }
  .offset-xl-7 {
    margin-left: 58.33333%; }
  .offset-xl-8 {
    margin-left: 66.66667%; }
  .offset-xl-9 {
    margin-left: 75%; }
  .offset-xl-10 {
    margin-left: 83.33333%; }
  .offset-xl-11 {
    margin-left: 91.66667%; }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0; }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0; }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem; }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem; }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem; }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem; }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem; }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem; }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem; }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem; }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem; }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem; } }

@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0; }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%; }
  .offset-xxl-0 {
    margin-left: 0; }
  .offset-xxl-1 {
    margin-left: 8.33333%; }
  .offset-xxl-2 {
    margin-left: 16.66667%; }
  .offset-xxl-3 {
    margin-left: 25%; }
  .offset-xxl-4 {
    margin-left: 33.33333%; }
  .offset-xxl-5 {
    margin-left: 41.66667%; }
  .offset-xxl-6 {
    margin-left: 50%; }
  .offset-xxl-7 {
    margin-left: 58.33333%; }
  .offset-xxl-8 {
    margin-left: 66.66667%; }
  .offset-xxl-9 {
    margin-left: 75%; }
  .offset-xxl-10 {
    margin-left: 83.33333%; }
  .offset-xxl-11 {
    margin-left: 91.66667%; }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0; }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0; }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem; }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem; }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem; }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem; }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem; }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem; }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem; }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem; }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem; }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem; } }

.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color); }
  .table > :not(caption) > * > * {
    padding: 0.5rem 0.5rem;
    color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
    background-color: var(--bs-table-bg);
    border-bottom-width: var(--bs-border-width);
    box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg))); }
  .table > tbody {
    vertical-align: inherit; }
  .table > thead {
    vertical-align: bottom; }

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor; }

.caption-top {
  caption-side: top; }

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem; }

.table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0; }
  .table-bordered > :not(caption) > * > * {
    border-width: 0 var(--bs-border-width); }

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0; }

.table-borderless > :not(:first-child) {
  border-top-width: 0; }

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg); }

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg); }

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg); }

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg); }

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: #cfe2ff;
  --bs-table-border-color: #a6b5cc;
  --bs-table-striped-bg: #c5d7f2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bacbe6;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfd1ec;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: #e2e3e5;
  --bs-table-border-color: #b5b6b7;
  --bs-table-striped-bg: #d7d8da;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #cbccce;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #d1d2d4;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: #d1e7dd;
  --bs-table-border-color: #a7b9b1;
  --bs-table-striped-bg: #c7dbd2;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #bcd0c7;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #c1d6cc;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: #cff4fc;
  --bs-table-border-color: #a6c3ca;
  --bs-table-striped-bg: #c5e8ef;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #badce3;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #bfe2e9;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: #fff3cd;
  --bs-table-border-color: #ccc2a4;
  --bs-table-striped-bg: #f2e7c3;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #e6dbb9;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #ece1be;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: #f8d7da;
  --bs-table-border-color: #c6acae;
  --bs-table-striped-bg: #eccccf;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfc2c4;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5c7ca;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #f8f9fa;
  --bs-table-border-color: #c6c7c8;
  --bs-table-striped-bg: #ecedee;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: #dfe0e1;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: #e5e6e7;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #212529;
  --bs-table-border-color: #4d5154;
  --bs-table-striped-bg: #2c3034;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: #373b3e;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: #323539;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; }

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

.form-label {
  margin-bottom: 0.5rem; }

.col-form-label {
  padding-top: calc(0.375rem + var(--bs-border-width));
  padding-bottom: calc(0.375rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5; }

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: 1.25rem; }

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.875rem; }

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-secondary-color); }

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .form-control {
      transition: none; } }
  .form-control[type="file"] {
    overflow: hidden; }
    .form-control[type="file"]:not(:disabled):not([readonly]) {
      cursor: pointer; }
  .form-control:focus {
    color: var(--bs-body-color);
    background-color: var(--bs-body-bg);
    border-color: #86b7fe;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25); }
  .form-control::-webkit-date-and-time-value {
    min-width: 85px;
    height: 1.5em;
    margin: 0; }
  .form-control::-webkit-datetime-edit {
    display: block;
    padding: 0; }
  .form-control::placeholder {
    color: var(--bs-secondary-color);
    opacity: 1; }
  .form-control:disabled {
    background-color: var(--bs-secondary-bg);
    opacity: 1; }
  .form-control::file-selector-button {
    padding: 0.375rem 0.75rem;
    margin: -0.375rem -0.75rem;
    margin-inline-end: 0.75rem;
    color: var(--bs-body-color);
    background-color: var(--bs-tertiary-bg);
    pointer-events: none;
    border-color: inherit;
    border-style: solid;
    border-width: 0;
    border-inline-end-width: var(--bs-border-width);
    border-radius: 0;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-control::file-selector-button {
        transition: none; } }
  .form-control:hover:not(:disabled):not([readonly])::file-selector-button {
    background-color: var(--bs-secondary-bg); }

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0; }
  .form-control-plaintext:focus {
    outline: 0; }
  .form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
    padding-right: 0;
    padding-left: 0; }

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm); }
  .form-control-sm::file-selector-button {
    padding: 0.25rem 0.5rem;
    margin: -0.25rem -0.5rem;
    margin-inline-end: 0.5rem; }

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg); }
  .form-control-lg::file-selector-button {
    padding: 0.5rem 1rem;
    margin: -0.5rem -1rem;
    margin-inline-end: 1rem; }

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2)); }

textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2)); }

textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2)); }

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
  padding: 0.375rem; }
  .form-control-color:not(:disabled):not([readonly]) {
    cursor: pointer; }
  .form-control-color::-moz-color-swatch {
    border: 0 !important;
    border-radius: var(--bs-border-radius); }
  .form-control-color::-webkit-color-swatch {
    border: 0 !important;
    border-radius: var(--bs-border-radius); }
  .form-control-color.form-control-sm {
    height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2)); }
  .form-control-color.form-control-lg {
    height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2)); }

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .form-select {
      transition: none; } }
  .form-select:focus {
    border-color: #86b7fe;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25); }
  .form-select[multiple], .form-select[size]:not([size="1"]) {
    padding-right: 0.75rem;
    background-image: none; }
  .form-select:disabled {
    background-color: var(--bs-secondary-bg); }
  .form-select:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 var(--bs-body-color); }

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm); }

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg); }

[data-bs-theme="dark"] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___}); }

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem; }
  .form-check .form-check-input {
    float: left;
    margin-left: -1.5em; }

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right; }
  .form-check-reverse .form-check-input {
    float: right;
    margin-right: -1.5em;
    margin-left: 0; }

.form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color);
  print-color-adjust: exact; }
  .form-check-input[type="checkbox"] {
    border-radius: 0.25em; }
  .form-check-input[type="radio"] {
    border-radius: 50%; }
  .form-check-input:active {
    filter: brightness(90%); }
  .form-check-input:focus {
    border-color: #86b7fe;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25); }
  .form-check-input:checked {
    background-color: #0d6efd;
    border-color: #0d6efd; }
    .form-check-input:checked[type="checkbox"] {
      --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}); }
    .form-check-input:checked[type="radio"] {
      --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___}); }
  .form-check-input[type="checkbox"]:indeterminate {
    background-color: #0d6efd;
    border-color: #0d6efd;
    --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___}); }
  .form-check-input:disabled {
    pointer-events: none;
    filter: none;
    opacity: 0.5; }
  .form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
    cursor: default;
    opacity: 0.5; }

.form-switch {
  padding-left: 2.5em; }
  .form-switch .form-check-input {
    --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
    width: 2em;
    margin-left: -2.5em;
    background-image: var(--bs-form-switch-bg);
    background-position: left center;
    border-radius: 2em;
    transition: background-position 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-switch .form-check-input {
        transition: none; } }
    .form-switch .form-check-input:focus {
      --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___}); }
    .form-switch .form-check-input:checked {
      background-position: right center;
      --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___}); }
  .form-switch.form-check-reverse {
    padding-right: 2.5em;
    padding-left: 0; }
    .form-switch.form-check-reverse .form-check-input {
      margin-right: -2.5em;
      margin-left: 0; }

.form-check-inline {
  display: inline-block;
  margin-right: 1rem; }

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none; }
  .btn-check[disabled] + .btn, .btn-check:disabled + .btn {
    pointer-events: none;
    filter: none;
    opacity: 0.65; }

[data-bs-theme="dark"] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___}); }

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent; }
  .form-range:focus {
    outline: 0; }
    .form-range:focus::-webkit-slider-thumb {
      box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25); }
    .form-range:focus::-moz-range-thumb {
      box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25); }
  .form-range::-moz-focus-outer {
    border: 0; }
  .form-range::-webkit-slider-thumb {
    width: 1rem;
    height: 1rem;
    margin-top: -0.25rem;
    appearance: none;
    background-color: #0d6efd;
    border: 0;
    border-radius: 1rem;
    -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-range::-webkit-slider-thumb {
        -webkit-transition: none;
        transition: none; } }
    .form-range::-webkit-slider-thumb:active {
      background-color: #b6d4fe; }
  .form-range::-webkit-slider-runnable-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    background-color: var(--bs-secondary-bg);
    border-color: transparent;
    border-radius: 1rem; }
  .form-range::-moz-range-thumb {
    width: 1rem;
    height: 1rem;
    appearance: none;
    background-color: #0d6efd;
    border: 0;
    border-radius: 1rem;
    -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-range::-moz-range-thumb {
        -moz-transition: none;
        transition: none; } }
    .form-range::-moz-range-thumb:active {
      background-color: #b6d4fe; }
  .form-range::-moz-range-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    background-color: var(--bs-secondary-bg);
    border-color: transparent;
    border-radius: 1rem; }
  .form-range:disabled {
    pointer-events: none; }
    .form-range:disabled::-webkit-slider-thumb {
      background-color: var(--bs-secondary-color); }
    .form-range:disabled::-moz-range-thumb {
      background-color: var(--bs-secondary-color); }

.form-floating {
  position: relative; }
  .form-floating > .form-control,
  .form-floating > .form-control-plaintext,
  .form-floating > .form-select {
    height: calc(3.5rem + calc(var(--bs-border-width) * 2));
    min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
    line-height: 1.25; }
  .form-floating > label {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    max-width: 100%;
    height: 100%;
    padding: 1rem 0.75rem;
    overflow: hidden;
    color: rgba(var(--bs-body-color-rgb), 0.65);
    text-align: start;
    text-overflow: ellipsis;
    white-space: nowrap;
    pointer-events: none;
    border: var(--bs-border-width) solid transparent;
    transform-origin: 0 0;
    transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-floating > label {
        transition: none; } }
  .form-floating > .form-control,
  .form-floating > .form-control-plaintext {
    padding: 1rem 0.75rem; }
    .form-floating > .form-control::placeholder,
    .form-floating > .form-control-plaintext::placeholder {
      color: transparent; }
    .form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
    .form-floating > .form-control-plaintext:focus,
    .form-floating > .form-control-plaintext:not(:placeholder-shown) {
      padding-top: 1.625rem;
      padding-bottom: 0.625rem; }
    .form-floating > .form-control:-webkit-autofill,
    .form-floating > .form-control-plaintext:-webkit-autofill {
      padding-top: 1.625rem;
      padding-bottom: 0.625rem; }
  .form-floating > .form-select {
    padding-top: 1.625rem;
    padding-bottom: 0.625rem;
    padding-left: 0.75rem; }
  .form-floating > .form-control:focus ~ label,
  .form-floating > .form-control:not(:placeholder-shown) ~ label,
  .form-floating > .form-control-plaintext ~ label,
  .form-floating > .form-select ~ label {
    transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem); }
  .form-floating > .form-control:-webkit-autofill ~ label {
    transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem); }
  .form-floating > textarea:focus ~ label::after,
  .form-floating > textarea:not(:placeholder-shown) ~ label::after {
    position: absolute;
    inset: 1rem 0.375rem;
    z-index: -1;
    height: 1.5em;
    content: "";
    background-color: var(--bs-body-bg);
    border-radius: var(--bs-border-radius); }
  .form-floating > textarea:disabled ~ label::after {
    background-color: var(--bs-secondary-bg); }
  .form-floating > .form-control-plaintext ~ label {
    border-width: var(--bs-border-width) 0; }
  .form-floating > :disabled ~ label,
  .form-floating > .form-control:disabled ~ label {
    color: #6c757d; }

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%; }
  .input-group > .form-control,
  .input-group > .form-select,
  .input-group > .form-floating {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0; }
  .input-group > .form-control:focus,
  .input-group > .form-select:focus,
  .input-group > .form-floating:focus-within {
    z-index: 5; }
  .input-group .btn {
    position: relative;
    z-index: 2; }
    .input-group .btn:focus {
      z-index: 5; }

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius); }

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg); }

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm); }

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3rem; }

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n + 3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

.input-group.has-validation > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n + 4),
.input-group.has-validation > .form-floating:nth-last-child(n + 3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n + 3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(-1 * var(--bs-border-width));
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-valid-color); }

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: .1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius); }

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block; }

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }
  .was-validated .form-control:valid:focus, .form-control.is-valid:focus {
    border-color: var(--bs-form-valid-border-color);
    box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25); }

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem); }

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color); }
  .was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
    --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
    padding-right: 4.125rem;
    background-position: right 0.75rem center, center right 2.25rem;
    background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }
  .was-validated .form-select:valid:focus, .form-select.is-valid:focus {
    border-color: var(--bs-form-valid-border-color);
    box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25); }

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem)); }

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color); }
  .was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
    background-color: var(--bs-form-valid-color); }
  .was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
    box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25); }
  .was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
    color: var(--bs-form-valid-color); }

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: .5em; }

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid, .was-validated
.input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid, .was-validated
.input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3; }

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color); }

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: .1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius); }

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block; }

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }
  .was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
    border-color: var(--bs-form-invalid-border-color);
    box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25); }

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem); }

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color); }
  .was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
    --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
    padding-right: 4.125rem;
    background-position: right 0.75rem center, center right 2.25rem;
    background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem); }
  .was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
    border-color: var(--bs-form-invalid-border-color);
    box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25); }

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem)); }

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color); }
  .was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
    background-color: var(--bs-form-invalid-color); }
  .was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
    box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25); }
  .was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
    color: var(--bs-form-invalid-color); }

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: .5em; }

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid, .was-validated
.input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid, .was-validated
.input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4; }

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .btn {
      transition: none; } }
  .btn:hover {
    color: var(--bs-btn-hover-color);
    background-color: var(--bs-btn-hover-bg);
    border-color: var(--bs-btn-hover-border-color); }
  .btn-check + .btn:hover {
    color: var(--bs-btn-color);
    background-color: var(--bs-btn-bg);
    border-color: var(--bs-btn-border-color); }
  .btn:focus-visible {
    color: var(--bs-btn-hover-color);
    background-color: var(--bs-btn-hover-bg);
    border-color: var(--bs-btn-hover-border-color);
    outline: 0;
    box-shadow: var(--bs-btn-focus-box-shadow); }
  .btn-check:focus-visible + .btn {
    border-color: var(--bs-btn-hover-border-color);
    outline: 0;
    box-shadow: var(--bs-btn-focus-box-shadow); }
  .btn-check:checked + .btn,
  :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
    color: var(--bs-btn-active-color);
    background-color: var(--bs-btn-active-bg);
    border-color: var(--bs-btn-active-border-color); }
    .btn-check:checked + .btn:focus-visible,
    :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
      box-shadow: var(--bs-btn-focus-box-shadow); }
  .btn-check:checked:focus-visible + .btn {
    box-shadow: var(--bs-btn-focus-box-shadow); }
  .btn:disabled, .btn.disabled,
  fieldset:disabled .btn {
    color: var(--bs-btn-disabled-color);
    pointer-events: none;
    background-color: var(--bs-btn-disabled-bg);
    border-color: var(--bs-btn-disabled-border-color);
    opacity: var(--bs-btn-disabled-opacity); }

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0b5ed7;
  --bs-btn-hover-border-color: #0a58ca;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0a58ca;
  --bs-btn-active-border-color: #0a53be;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0d6efd;
  --bs-btn-disabled-border-color: #0d6efd; }

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #5c636a;
  --bs-btn-hover-border-color: #565e64;
  --bs-btn-focus-shadow-rgb: 130, 138, 145;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #565e64;
  --bs-btn-active-border-color: #51585e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6c757d;
  --bs-btn-disabled-border-color: #6c757d; }

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #157347;
  --bs-btn-hover-border-color: #146c43;
  --bs-btn-focus-shadow-rgb: 60, 153, 110;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #146c43;
  --bs-btn-active-border-color: #13653f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #198754;
  --bs-btn-disabled-border-color: #198754; }

.btn-info {
  --bs-btn-color: #000;
  --bs-btn-bg: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #31d2f2;
  --bs-btn-hover-border-color: #25cff2;
  --bs-btn-focus-shadow-rgb: 11, 172, 204;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #3dd5f3;
  --bs-btn-active-border-color: #25cff2;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #0dcaf0;
  --bs-btn-disabled-border-color: #0dcaf0; }

.btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffca2c;
  --bs-btn-hover-border-color: #ffc720;
  --bs-btn-focus-shadow-rgb: 217, 164, 6;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffcd39;
  --bs-btn-active-border-color: #ffc720;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ffc107;
  --bs-btn-disabled-border-color: #ffc107; }

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #bb2d3b;
  --bs-btn-hover-border-color: #b02a37;
  --bs-btn-focus-shadow-rgb: 225, 83, 97;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #b02a37;
  --bs-btn-active-border-color: #a52834;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #dc3545;
  --bs-btn-disabled-border-color: #dc3545; }

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #d3d4d5;
  --bs-btn-hover-border-color: #c6c7c8;
  --bs-btn-focus-shadow-rgb: 211, 212, 213;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #c6c7c8;
  --bs-btn-active-border-color: #babbbc;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f8f9fa;
  --bs-btn-disabled-border-color: #f8f9fa; }

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #424649;
  --bs-btn-hover-border-color: #373b3e;
  --bs-btn-focus-shadow-rgb: 66, 70, 73;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4d5154;
  --bs-btn-active-border-color: #373b3e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #212529;
  --bs-btn-disabled-border-color: #212529; }

.btn-outline-primary {
  --bs-btn-color: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0d6efd;
  --bs-btn-hover-border-color: #0d6efd;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0d6efd;
  --bs-btn-active-border-color: #0d6efd;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0d6efd;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0d6efd;
  --bs-gradient: none; }

.btn-outline-secondary {
  --bs-btn-color: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6c757d;
  --bs-btn-hover-border-color: #6c757d;
  --bs-btn-focus-shadow-rgb: 108, 117, 125;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6c757d;
  --bs-btn-active-border-color: #6c757d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6c757d;
  --bs-gradient: none; }

.btn-outline-success {
  --bs-btn-color: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #198754;
  --bs-btn-hover-border-color: #198754;
  --bs-btn-focus-shadow-rgb: 25, 135, 84;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #198754;
  --bs-btn-active-border-color: #198754;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #198754;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #198754;
  --bs-gradient: none; }

.btn-outline-info {
  --bs-btn-color: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #0dcaf0;
  --bs-btn-hover-border-color: #0dcaf0;
  --bs-btn-focus-shadow-rgb: 13, 202, 240;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #0dcaf0;
  --bs-btn-active-border-color: #0dcaf0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0dcaf0;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0dcaf0;
  --bs-gradient: none; }

.btn-outline-warning {
  --bs-btn-color: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffc107;
  --bs-btn-hover-border-color: #ffc107;
  --bs-btn-focus-shadow-rgb: 255, 193, 7;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffc107;
  --bs-btn-active-border-color: #ffc107;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffc107;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffc107;
  --bs-gradient: none; }

.btn-outline-danger {
  --bs-btn-color: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #dc3545;
  --bs-btn-hover-border-color: #dc3545;
  --bs-btn-focus-shadow-rgb: 220, 53, 69;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #dc3545;
  --bs-btn-active-border-color: #dc3545;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #dc3545;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #dc3545;
  --bs-gradient: none; }

.btn-outline-light {
  --bs-btn-color: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f8f9fa;
  --bs-btn-hover-border-color: #f8f9fa;
  --bs-btn-focus-shadow-rgb: 248, 249, 250;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f8f9fa;
  --bs-btn-active-border-color: #f8f9fa;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f8f9fa;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f8f9fa;
  --bs-gradient: none; }

.btn-outline-dark {
  --bs-btn-color: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #212529;
  --bs-btn-hover-border-color: #212529;
  --bs-btn-focus-shadow-rgb: 33, 37, 41;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #212529;
  --bs-btn-active-border-color: #212529;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #212529;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #212529;
  --bs-gradient: none; }

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: underline; }
  .btn-link:focus-visible {
    color: var(--bs-btn-color); }
  .btn-link:hover {
    color: var(--bs-btn-hover-color); }

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.25rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg); }

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm); }

.fade {
  transition: opacity 0.15s linear; }
  @media (prefers-reduced-motion: reduce) {
    .fade {
      transition: none; } }
  .fade:not(.show) {
    opacity: 0; }

.collapse:not(.show) {
  display: none; }

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease; }
  @media (prefers-reduced-motion: reduce) {
    .collapsing {
      transition: none; } }
  .collapsing.collapse-horizontal {
    width: 0;
    height: auto;
    transition: width 0.35s ease; }
    @media (prefers-reduced-motion: reduce) {
      .collapsing.collapse-horizontal {
        transition: none; } }

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative; }

.dropdown-toggle {
  white-space: nowrap; }
  .dropdown-toggle::after {
    display: inline-block;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent; }
  .dropdown-toggle:empty::after {
    margin-left: 0; }

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: var(--bs-border-radius);
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: var(--bs-box-shadow);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #6c757d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius); }
  .dropdown-menu[data-bs-popper] {
    top: 100%;
    left: 0;
    margin-top: var(--bs-dropdown-spacer); }

.dropdown-menu-start {
  --bs-position: start; }
  .dropdown-menu-start[data-bs-popper] {
    right: auto;
    left: 0; }

.dropdown-menu-end {
  --bs-position: end; }
  .dropdown-menu-end[data-bs-popper] {
    right: 0;
    left: auto; }

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start; }
    .dropdown-menu-sm-start[data-bs-popper] {
      right: auto;
      left: 0; }
  .dropdown-menu-sm-end {
    --bs-position: end; }
    .dropdown-menu-sm-end[data-bs-popper] {
      right: 0;
      left: auto; } }

@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start; }
    .dropdown-menu-md-start[data-bs-popper] {
      right: auto;
      left: 0; }
  .dropdown-menu-md-end {
    --bs-position: end; }
    .dropdown-menu-md-end[data-bs-popper] {
      right: 0;
      left: auto; } }

@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start; }
    .dropdown-menu-lg-start[data-bs-popper] {
      right: auto;
      left: 0; }
  .dropdown-menu-lg-end {
    --bs-position: end; }
    .dropdown-menu-lg-end[data-bs-popper] {
      right: 0;
      left: auto; } }

@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start; }
    .dropdown-menu-xl-start[data-bs-popper] {
      right: auto;
      left: 0; }
  .dropdown-menu-xl-end {
    --bs-position: end; }
    .dropdown-menu-xl-end[data-bs-popper] {
      right: 0;
      left: auto; } }

@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start; }
    .dropdown-menu-xxl-start[data-bs-popper] {
      right: auto;
      left: 0; }
  .dropdown-menu-xxl-end {
    --bs-position: end; }
    .dropdown-menu-xxl-end[data-bs-popper] {
      right: 0;
      left: auto; } }

.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer); }

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent; }

.dropup .dropdown-toggle:empty::after {
  margin-left: 0; }

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer); }

.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid; }

.dropend .dropdown-toggle:empty::after {
  margin-left: 0; }

.dropend .dropdown-toggle::after {
  vertical-align: 0; }

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer); }

.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: ""; }

.dropstart .dropdown-toggle::after {
  display: none; }

.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent; }

.dropstart .dropdown-toggle:empty::after {
  margin-left: 0; }

.dropstart .dropdown-toggle::before {
  vertical-align: 0; }

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1; }

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0); }
  .dropdown-item:hover, .dropdown-item:focus {
    color: var(--bs-dropdown-link-hover-color);
    background-color: var(--bs-dropdown-link-hover-bg); }
  .dropdown-item.active, .dropdown-item:active {
    color: var(--bs-dropdown-link-active-color);
    text-decoration: none;
    background-color: var(--bs-dropdown-link-active-bg); }
  .dropdown-item.disabled, .dropdown-item:disabled {
    color: var(--bs-dropdown-link-disabled-color);
    pointer-events: none;
    background-color: transparent; }

.dropdown-menu.show {
  display: block; }

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap; }

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color); }

.dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd; }

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle; }
  .btn-group > .btn,
  .btn-group-vertical > .btn {
    position: relative;
    flex: 1 1 auto; }
  .btn-group > .btn-check:checked + .btn,
  .btn-group > .btn-check:focus + .btn,
  .btn-group > .btn:hover,
  .btn-group > .btn:focus,
  .btn-group > .btn:active,
  .btn-group > .btn.active,
  .btn-group-vertical > .btn-check:checked + .btn,
  .btn-group-vertical > .btn-check:focus + .btn,
  .btn-group-vertical > .btn:hover,
  .btn-group-vertical > .btn:focus,
  .btn-group-vertical > .btn:active,
  .btn-group-vertical > .btn.active {
    z-index: 1; }

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; }
  .btn-toolbar .input-group {
    width: auto; }

.btn-group {
  border-radius: var(--bs-border-radius); }
  .btn-group > :not(.btn-check:first-child) + .btn,
  .btn-group > .btn-group:not(:first-child) {
    margin-left: calc(-1 * var(--bs-border-width)); }
  .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
  .btn-group > .btn.dropdown-toggle-split:first-child,
  .btn-group > .btn-group:not(:last-child) > .btn {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0; }
  .btn-group > .btn:nth-child(n + 3),
  .btn-group > :not(.btn-check) + .btn,
  .btn-group > .btn-group:not(:first-child) > .btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0; }

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem; }
  .dropdown-toggle-split::after,
  .dropup .dropdown-toggle-split::after,
  .dropend .dropdown-toggle-split::after {
    margin-left: 0; }
  .dropstart .dropdown-toggle-split::before {
    margin-right: 0; }

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem; }

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem; }

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center; }
  .btn-group-vertical > .btn,
  .btn-group-vertical > .btn-group {
    width: 100%; }
  .btn-group-vertical > .btn:not(:first-child),
  .btn-group-vertical > .btn-group:not(:first-child) {
    margin-top: calc(-1 * var(--bs-border-width)); }
  .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
  .btn-group-vertical > .btn-group:not(:last-child) > .btn {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0; }
  .btn-group-vertical > .btn:nth-child(n + 3),
  .btn-group-vertical > :not(.btn-check) + .btn,
  .btn-group-vertical > .btn-group:not(:first-child) > .btn {
    border-top-left-radius: 0;
    border-top-right-radius: 0; }

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none; }

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .nav-link {
      transition: none; } }
  .nav-link:hover, .nav-link:focus {
    color: var(--bs-nav-link-hover-color); }
  .nav-link:focus-visible {
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25); }
  .nav-link.disabled, .nav-link:disabled {
    color: var(--bs-nav-link-disabled-color);
    pointer-events: none;
    cursor: default; }

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color); }
  .nav-tabs .nav-link {
    margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
    border: var(--bs-nav-tabs-border-width) solid transparent;
    border-top-left-radius: var(--bs-nav-tabs-border-radius);
    border-top-right-radius: var(--bs-nav-tabs-border-radius); }
    .nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
      isolation: isolate;
      border-color: var(--bs-nav-tabs-link-hover-border-color); }
  .nav-tabs .nav-link.active,
  .nav-tabs .nav-item.show .nav-link {
    color: var(--bs-nav-tabs-link-active-color);
    background-color: var(--bs-nav-tabs-link-active-bg);
    border-color: var(--bs-nav-tabs-link-active-border-color); }
  .nav-tabs .dropdown-menu {
    margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
    border-top-left-radius: 0;
    border-top-right-radius: 0; }

.nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #0d6efd; }
  .nav-pills .nav-link {
    border-radius: var(--bs-nav-pills-border-radius); }
  .nav-pills .nav-link.active,
  .nav-pills .show > .nav-link {
    color: var(--bs-nav-pills-link-active-color);
    background-color: var(--bs-nav-pills-link-active-bg); }

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap); }
  .nav-underline .nav-link {
    padding-right: 0;
    padding-left: 0;
    border-bottom: var(--bs-nav-underline-border-width) solid transparent; }
    .nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
      border-bottom-color: currentcolor; }
  .nav-underline .nav-link.active,
  .nav-underline .show > .nav-link {
    font-weight: 700;
    color: var(--bs-nav-underline-link-active-color);
    border-bottom-color: currentcolor; }

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center; }

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-grow: 1;
  flex-basis: 0;
  text-align: center; }

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%; }

.tab-content > .tab-pane {
  display: none; }

.tab-content > .active {
  display: block; }

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.3125rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.25rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.25rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x); }
  .navbar > .container,
  .navbar > .container-fluid, .navbar > .container-sm, .navbar > .container-md, .navbar > .container-lg, .navbar > .container-xl, .navbar > .container-xxl {
    display: flex;
    flex-wrap: inherit;
    align-items: center;
    justify-content: space-between; }

.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap; }
  .navbar-brand:hover, .navbar-brand:focus {
    color: var(--bs-navbar-brand-hover-color); }

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none; }
  .navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
    color: var(--bs-navbar-active-color); }
  .navbar-nav .dropdown-menu {
    position: static; }

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color); }
  .navbar-text a,
  .navbar-text a:hover,
  .navbar-text a:focus {
    color: var(--bs-navbar-active-color); }

.navbar-collapse {
  flex-grow: 1;
  flex-basis: 100%;
  align-items: center; }

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition); }
  @media (prefers-reduced-motion: reduce) {
    .navbar-toggler {
      transition: none; } }
  .navbar-toggler:hover {
    text-decoration: none; }
  .navbar-toggler:focus {
    text-decoration: none;
    outline: 0;
    box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width); }

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%; }

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto; }

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-sm .navbar-nav {
      flex-direction: row; }
      .navbar-expand-sm .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-sm .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x); }
    .navbar-expand-sm .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-sm .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-sm .navbar-toggler {
      display: none; }
    .navbar-expand-sm .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-sm .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-sm .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-md .navbar-nav {
      flex-direction: row; }
      .navbar-expand-md .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-md .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x); }
    .navbar-expand-md .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-md .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-md .navbar-toggler {
      display: none; }
    .navbar-expand-md .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-md .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-md .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-lg .navbar-nav {
      flex-direction: row; }
      .navbar-expand-lg .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-lg .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x); }
    .navbar-expand-lg .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-lg .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-lg .navbar-toggler {
      display: none; }
    .navbar-expand-lg .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-lg .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-lg .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-xl .navbar-nav {
      flex-direction: row; }
      .navbar-expand-xl .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-xl .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x); }
    .navbar-expand-xl .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-xl .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-xl .navbar-toggler {
      display: none; }
    .navbar-expand-xl .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-xl .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-xl .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-xxl .navbar-nav {
      flex-direction: row; }
      .navbar-expand-xxl .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-xxl .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x); }
    .navbar-expand-xxl .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-xxl .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-xxl .navbar-toggler {
      display: none; }
    .navbar-expand-xxl .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-xxl .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-xxl .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start; }
  .navbar-expand .navbar-nav {
    flex-direction: row; }
    .navbar-expand .navbar-nav .dropdown-menu {
      position: absolute; }
    .navbar-expand .navbar-nav .nav-link {
      padding-right: var(--bs-navbar-nav-link-padding-x);
      padding-left: var(--bs-navbar-nav-link-padding-x); }
  .navbar-expand .navbar-nav-scroll {
    overflow: visible; }
  .navbar-expand .navbar-collapse {
    display: flex !important;
    flex-basis: auto; }
  .navbar-expand .navbar-toggler {
    display: none; }
  .navbar-expand .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none; }
    .navbar-expand .offcanvas .offcanvas-header {
      display: none; }
    .navbar-expand .offcanvas .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible; }

.navbar-dark,
.navbar[data-bs-theme="dark"] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___}); }

[data-bs-theme="dark"] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___}); }

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius); }
  .card > hr {
    margin-right: 0;
    margin-left: 0; }
  .card > .list-group {
    border-top: inherit;
    border-bottom: inherit; }
    .card > .list-group:first-child {
      border-top-width: 0;
      border-top-left-radius: var(--bs-card-inner-border-radius);
      border-top-right-radius: var(--bs-card-inner-border-radius); }
    .card > .list-group:last-child {
      border-bottom-width: 0;
      border-bottom-right-radius: var(--bs-card-inner-border-radius);
      border-bottom-left-radius: var(--bs-card-inner-border-radius); }
  .card > .card-header + .list-group,
  .card > .list-group + .card-footer {
    border-top: 0; }

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color); }

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color); }

.card-subtitle {
  margin-top: calc(-.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color); }

.card-text:last-child {
  margin-bottom: 0; }

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x); }

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color); }
  .card-header:first-child {
    border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0; }

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color); }
  .card-footer:last-child {
    border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius); }

.card-header-tabs {
  margin-right: calc(-.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0; }
  .card-header-tabs .nav-link.active {
    background-color: var(--bs-card-bg);
    border-bottom-color: var(--bs-card-bg); }

.card-header-pills {
  margin-right: calc(-.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-.5 * var(--bs-card-cap-padding-x)); }

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius); }

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%; }

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius); }

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius); }

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin); }

@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap; }
    .card-group > .card {
      flex: 1 0;
      margin-bottom: 0; }
      .card-group > .card + .card {
        margin-left: 0;
        border-left: 0; }
      .card-group > .card:not(:last-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0; }
        .card-group > .card:not(:last-child) > .card-img-top,
        .card-group > .card:not(:last-child) > .card-header {
          border-top-right-radius: 0; }
        .card-group > .card:not(:last-child) > .card-img-bottom,
        .card-group > .card:not(:last-child) > .card-footer {
          border-bottom-right-radius: 0; }
      .card-group > .card:not(:first-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0; }
        .card-group > .card:not(:first-child) > .card-img-top,
        .card-group > .card:not(:first-child) > .card-header {
          border-top-left-radius: 0; }
        .card-group > .card:not(:first-child) > .card-img-bottom,
        .card-group > .card:not(:first-child) > .card-footer {
          border-bottom-left-radius: 0; } }

.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle); }

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition); }
  @media (prefers-reduced-motion: reduce) {
    .accordion-button {
      transition: none; } }
  .accordion-button:not(.collapsed) {
    color: var(--bs-accordion-active-color);
    background-color: var(--bs-accordion-active-bg);
    box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color); }
    .accordion-button:not(.collapsed)::after {
      background-image: var(--bs-accordion-btn-active-icon);
      transform: var(--bs-accordion-btn-icon-transform); }
  .accordion-button::after {
    flex-shrink: 0;
    width: var(--bs-accordion-btn-icon-width);
    height: var(--bs-accordion-btn-icon-width);
    margin-left: auto;
    content: "";
    background-image: var(--bs-accordion-btn-icon);
    background-repeat: no-repeat;
    background-size: var(--bs-accordion-btn-icon-width);
    transition: var(--bs-accordion-btn-icon-transition); }
    @media (prefers-reduced-motion: reduce) {
      .accordion-button::after {
        transition: none; } }
  .accordion-button:hover {
    z-index: 2; }
  .accordion-button:focus {
    z-index: 3;
    outline: 0;
    box-shadow: var(--bs-accordion-btn-focus-box-shadow); }

.accordion-header {
  margin-bottom: 0; }

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color); }
  .accordion-item:first-of-type {
    border-top-left-radius: var(--bs-accordion-border-radius);
    border-top-right-radius: var(--bs-accordion-border-radius); }
    .accordion-item:first-of-type > .accordion-header .accordion-button {
      border-top-left-radius: var(--bs-accordion-inner-border-radius);
      border-top-right-radius: var(--bs-accordion-inner-border-radius); }
  .accordion-item:not(:first-of-type) {
    border-top: 0; }
  .accordion-item:last-of-type {
    border-bottom-right-radius: var(--bs-accordion-border-radius);
    border-bottom-left-radius: var(--bs-accordion-border-radius); }
    .accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
      border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
      border-bottom-left-radius: var(--bs-accordion-inner-border-radius); }
    .accordion-item:last-of-type > .accordion-collapse {
      border-bottom-right-radius: var(--bs-accordion-border-radius);
      border-bottom-left-radius: var(--bs-accordion-border-radius); }

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x); }

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0; }
  .accordion-flush > .accordion-item:first-child {
    border-top: 0; }
  .accordion-flush > .accordion-item:last-child {
    border-bottom: 0; }
  .accordion-flush > .accordion-item > .accordion-collapse,
  .accordion-flush > .accordion-item > .accordion-header .accordion-button,
  .accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
    border-radius: 0; }

[data-bs-theme="dark"] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___}); }

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius); }

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x); }
  .breadcrumb-item + .breadcrumb-item::before {
    float: left;
    padding-right: var(--bs-breadcrumb-item-padding-x);
    color: var(--bs-breadcrumb-divider-color);
    content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */; }

.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color); }

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-body-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #0d6efd;
  --bs-pagination-active-border-color: #0d6efd;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none; }

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .page-link {
      transition: none; } }
  .page-link:hover {
    z-index: 2;
    color: var(--bs-pagination-hover-color);
    background-color: var(--bs-pagination-hover-bg);
    border-color: var(--bs-pagination-hover-border-color); }
  .page-link:focus {
    z-index: 3;
    color: var(--bs-pagination-focus-color);
    background-color: var(--bs-pagination-focus-bg);
    outline: 0;
    box-shadow: var(--bs-pagination-focus-box-shadow); }
  .page-link.active,
  .active > .page-link {
    z-index: 3;
    color: var(--bs-pagination-active-color);
    background-color: var(--bs-pagination-active-bg);
    border-color: var(--bs-pagination-active-border-color); }
  .page-link.disabled,
  .disabled > .page-link {
    color: var(--bs-pagination-disabled-color);
    pointer-events: none;
    background-color: var(--bs-pagination-disabled-bg);
    border-color: var(--bs-pagination-disabled-border-color); }

.page-item:not(:first-child) .page-link {
  margin-left: calc(-1 * var(--bs-border-width)); }

.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius); }

.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius); }

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.25rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg); }

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm); }

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius); }
  .badge:empty {
    display: none; }

.btn .badge {
  position: relative;
  top: -1px; }

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius); }

.alert-heading {
  color: inherit; }

.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color); }

.alert-dismissible {
  padding-right: 3rem; }
  .alert-dismissible .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    padding: 1.25rem 1rem; }

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis); }

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis); }

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis); }

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis); }

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis); }

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis); }

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis); }

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis); }

@keyframes progress-bar-stripes {
  0% {
    background-position-x: var(--bs-progress-height); } }

.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: var(--bs-secondary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #0d6efd;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius); }

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition); }
  @media (prefers-reduced-motion: reduce) {
    .progress-bar {
      transition: none; } }

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height); }

.progress-stacked > .progress {
  overflow: visible; }

.progress-stacked > .progress > .progress-bar {
  width: 100%; }

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes; }
  @media (prefers-reduced-motion: reduce) {
    .progress-bar-animated {
      animation: none; } }

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #0d6efd;
  --bs-list-group-active-border-color: #0d6efd;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius); }

.list-group-numbered {
  list-style-type: none;
  counter-reset: section; }
  .list-group-numbered > .list-group-item::before {
    content: counters(section, ".") ". ";
    counter-increment: section; }

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color); }
  .list-group-item:first-child {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit; }
  .list-group-item:last-child {
    border-bottom-right-radius: inherit;
    border-bottom-left-radius: inherit; }
  .list-group-item.disabled, .list-group-item:disabled {
    color: var(--bs-list-group-disabled-color);
    pointer-events: none;
    background-color: var(--bs-list-group-disabled-bg); }
  .list-group-item.active {
    z-index: 2;
    color: var(--bs-list-group-active-color);
    background-color: var(--bs-list-group-active-bg);
    border-color: var(--bs-list-group-active-border-color); }
  .list-group-item + .list-group-item {
    border-top-width: 0; }
    .list-group-item + .list-group-item.active {
      margin-top: calc(-1 * var(--bs-list-group-border-width));
      border-top-width: var(--bs-list-group-border-width); }

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit; }
  .list-group-item-action:not(.active):hover, .list-group-item-action:not(.active):focus {
    z-index: 1;
    color: var(--bs-list-group-action-hover-color);
    text-decoration: none;
    background-color: var(--bs-list-group-action-hover-bg); }
  .list-group-item-action:not(.active):active {
    color: var(--bs-list-group-action-active-color);
    background-color: var(--bs-list-group-action-active-bg); }

.list-group-horizontal {
  flex-direction: row; }
  .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0; }
  .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0; }
  .list-group-horizontal > .list-group-item.active {
    margin-top: 0; }
  .list-group-horizontal > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0; }
    .list-group-horizontal > .list-group-item + .list-group-item.active {
      margin-left: calc(-1 * var(--bs-list-group-border-width));
      border-left-width: var(--bs-list-group-border-width); }

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row; }
    .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--bs-list-group-border-radius);
      border-top-right-radius: 0; }
    .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--bs-list-group-border-radius);
      border-bottom-left-radius: 0; }
    .list-group-horizontal-sm > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-sm > .list-group-item + .list-group-item {
      border-top-width: var(--bs-list-group-border-width);
      border-left-width: 0; }
      .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width); } }

@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row; }
    .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--bs-list-group-border-radius);
      border-top-right-radius: 0; }
    .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--bs-list-group-border-radius);
      border-bottom-left-radius: 0; }
    .list-group-horizontal-md > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-md > .list-group-item + .list-group-item {
      border-top-width: var(--bs-list-group-border-width);
      border-left-width: 0; }
      .list-group-horizontal-md > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width); } }

@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row; }
    .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--bs-list-group-border-radius);
      border-top-right-radius: 0; }
    .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--bs-list-group-border-radius);
      border-bottom-left-radius: 0; }
    .list-group-horizontal-lg > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-lg > .list-group-item + .list-group-item {
      border-top-width: var(--bs-list-group-border-width);
      border-left-width: 0; }
      .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width); } }

@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row; }
    .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--bs-list-group-border-radius);
      border-top-right-radius: 0; }
    .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--bs-list-group-border-radius);
      border-bottom-left-radius: 0; }
    .list-group-horizontal-xl > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-xl > .list-group-item + .list-group-item {
      border-top-width: var(--bs-list-group-border-width);
      border-left-width: 0; }
      .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width); } }

@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row; }
    .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--bs-list-group-border-radius);
      border-top-right-radius: 0; }
    .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--bs-list-group-border-radius);
      border-bottom-left-radius: 0; }
    .list-group-horizontal-xxl > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-xxl > .list-group-item + .list-group-item {
      border-top-width: var(--bs-list-group-border-width);
      border-left-width: 0; }
      .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width); } }

.list-group-flush {
  border-radius: 0; }
  .list-group-flush > .list-group-item {
    border-width: 0 0 var(--bs-list-group-border-width); }
    .list-group-flush > .list-group-item:last-child {
      border-bottom-width: 0; }

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis); }

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis); }

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis); }

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis); }

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis); }

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis); }

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis); }

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis); }

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  filter: var(--bs-btn-close-filter);
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity); }
  .btn-close:hover {
    color: var(--bs-btn-close-color);
    text-decoration: none;
    opacity: var(--bs-btn-close-hover-opacity); }
  .btn-close:focus {
    outline: 0;
    box-shadow: var(--bs-btn-close-focus-shadow);
    opacity: var(--bs-btn-close-focus-opacity); }
  .btn-close:disabled, .btn-close.disabled {
    pointer-events: none;
    -webkit-user-select: none;
            user-select: none;
    opacity: var(--bs-btn-close-disabled-opacity); }

.btn-close-white {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%); }

:root,
[data-bs-theme="light"] {
  --bs-btn-close-filter: ; }

[data-bs-theme="dark"] {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%); }

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius); }
  .toast.showing {
    opacity: 0; }
  .toast:not(.show) {
    display: none; }

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none; }
  .toast-container > :not(:last-child) {
    margin-bottom: var(--bs-toast-spacing); }

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width)); }
  .toast-header .btn-close {
    margin-right: calc(-.5 * var(--bs-toast-padding-x));
    margin-left: var(--bs-toast-padding-x); }

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word; }

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: var(--bs-body-color);
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0; }

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none; }
  .modal.fade .modal-dialog {
    transform: translate(0, -50px);
    transition: transform 0.3s ease-out; }
    @media (prefers-reduced-motion: reduce) {
      .modal.fade .modal-dialog {
        transition: none; } }
  .modal.show .modal-dialog {
    transform: none; }
  .modal.modal-static .modal-dialog {
    transform: scale(1.02); }

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2); }
  .modal-dialog-scrollable .modal-content {
    max-height: 100%;
    overflow: hidden; }
  .modal-dialog-scrollable .modal-body {
    overflow-y: auto; }

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2); }

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0; }

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg); }
  .modal-backdrop.fade {
    opacity: 0; }
  .modal-backdrop.show {
    opacity: var(--bs-backdrop-opacity); }

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius); }
  .modal-header .btn-close {
    padding: calc(var(--bs-modal-header-padding-y) * .5) calc(var(--bs-modal-header-padding-x) * .5);
    margin-top: calc(-.5 * var(--bs-modal-header-padding-y));
    margin-right: calc(-.5 * var(--bs-modal-header-padding-x));
    margin-bottom: calc(-.5 * var(--bs-modal-header-padding-y));
    margin-left: auto; }

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height); }

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding); }

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * .5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius); }
  .modal-footer > * {
    margin: calc(var(--bs-modal-footer-gap) * .5); }

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow); }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto; }
  .modal-sm {
    --bs-modal-width: 300px; } }

@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px; } }

@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px; } }

.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0; }
  .modal-fullscreen .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0; }
  .modal-fullscreen .modal-header,
  .modal-fullscreen .modal-footer {
    border-radius: 0; }
  .modal-fullscreen .modal-body {
    overflow-y: auto; }

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-sm-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-sm-down .modal-header,
    .modal-fullscreen-sm-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-sm-down .modal-body {
      overflow-y: auto; } }

@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-md-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-md-down .modal-header,
    .modal-fullscreen-md-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-md-down .modal-body {
      overflow-y: auto; } }

@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-lg-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-lg-down .modal-header,
    .modal-fullscreen-lg-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-lg-down .modal-body {
      overflow-y: auto; } }

@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-xl-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-xl-down .modal-header,
    .modal-fullscreen-xl-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-xl-down .modal-body {
      overflow-y: auto; } }

@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-xxl-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-xxl-down .modal-header,
    .modal-fullscreen-xxl-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-xxl-down .modal-body {
      overflow-y: auto; } }

.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.875rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-emphasis-color);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0; }
  .tooltip.show {
    opacity: var(--bs-tooltip-opacity); }
  .tooltip .tooltip-arrow {
    display: block;
    width: var(--bs-tooltip-arrow-width);
    height: var(--bs-tooltip-arrow-height); }
    .tooltip .tooltip-arrow::before {
      position: absolute;
      content: "";
      border-color: transparent;
      border-style: solid; }

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^="top"] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height)); }
  .bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^="top"] .tooltip-arrow::before {
    top: -1px;
    border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * .5) 0;
    border-top-color: var(--bs-tooltip-bg); }

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^="right"] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width); }
  .bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^="right"] .tooltip-arrow::before {
    right: -1px;
    border-width: calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * .5) 0;
    border-right-color: var(--bs-tooltip-bg); }

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^="bottom"] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height)); }
  .bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^="bottom"] .tooltip-arrow::before {
    bottom: -1px;
    border-width: 0 calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height);
    border-bottom-color: var(--bs-tooltip-bg); }

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^="left"] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width); }
  .bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^="left"] .tooltip-arrow::before {
    left: -1px;
    border-width: calc(var(--bs-tooltip-arrow-width) * .5) 0 calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height);
    border-left-color: var(--bs-tooltip-bg); }

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius); }

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.875rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: var(--bs-box-shadow);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius); }
  .popover .popover-arrow {
    display: block;
    width: var(--bs-popover-arrow-width);
    height: var(--bs-popover-arrow-height); }
    .popover .popover-arrow::before, .popover .popover-arrow::after {
      position: absolute;
      display: block;
      content: "";
      border-color: transparent;
      border-style: solid;
      border-width: 0; }

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width)); }
  .bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::after {
    border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * .5) 0; }
  .bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::before {
    bottom: 0;
    border-top-color: var(--bs-popover-arrow-border); }
  .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::after {
    bottom: var(--bs-popover-border-width);
    border-top-color: var(--bs-popover-bg); }

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width); }
  .bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::after {
    border-width: calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * .5) 0; }
  .bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::before {
    left: 0;
    border-right-color: var(--bs-popover-arrow-border); }
  .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::after {
    left: var(--bs-popover-border-width);
    border-right-color: var(--bs-popover-bg); }

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width)); }
  .bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::after {
    border-width: 0 calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height); }
  .bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::before {
    top: 0;
    border-bottom-color: var(--bs-popover-arrow-border); }
  .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::after {
    top: var(--bs-popover-border-width);
    border-bottom-color: var(--bs-popover-bg); }

.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^="bottom"] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg); }

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width); }
  .bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::after {
    border-width: calc(var(--bs-popover-arrow-width) * .5) 0 calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height); }
  .bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::before {
    right: 0;
    border-left-color: var(--bs-popover-arrow-border); }
  .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::after {
    right: var(--bs-popover-border-width);
    border-left-color: var(--bs-popover-bg); }

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius); }
  .popover-header:empty {
    display: none; }

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color); }

.carousel {
  position: relative; }

.carousel.pointer-event {
  touch-action: pan-y; }

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden; }
  .carousel-inner::after {
    display: block;
    clear: both;
    content: ""; }

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-item {
      transition: none; } }

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block; }

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%); }

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%); }

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none; }

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1; }

.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-fade .active.carousel-item-start,
    .carousel-fade .active.carousel-item-end {
      transition: none; } }

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  filter: var(--bs-carousel-control-icon-filter);
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-control-prev,
    .carousel-control-next {
      transition: none; } }
  .carousel-control-prev:hover, .carousel-control-prev:focus,
  .carousel-control-next:hover,
  .carousel-control-next:focus {
    color: #fff;
    text-decoration: none;
    outline: 0;
    opacity: 0.9; }

.carousel-control-prev {
  left: 0; }

.carousel-control-next {
  right: 0; }

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%; }

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e")*/; }

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/%3e%3c/svg%3e")*/; }

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%; }
  .carousel-indicators [data-bs-target] {
    box-sizing: content-box;
    flex: 0 1 auto;
    width: 30px;
    height: 3px;
    padding: 0;
    margin-right: 3px;
    margin-left: 3px;
    text-indent: -999px;
    cursor: pointer;
    background-color: var(--bs-carousel-indicator-active-bg);
    background-clip: padding-box;
    border: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    opacity: 0.5;
    transition: opacity 0.6s ease; }
    @media (prefers-reduced-motion: reduce) {
      .carousel-indicators [data-bs-target] {
        transition: none; } }
  .carousel-indicators .active {
    opacity: 1; }

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: var(--bs-carousel-caption-color);
  text-align: center; }

.carousel-dark {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100); }

:root,
[data-bs-theme="light"] {
  --bs-carousel-indicator-active-bg: #fff;
  --bs-carousel-caption-color: #fff;
  --bs-carousel-control-icon-filter: ; }

[data-bs-theme="dark"] {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100); }

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name); }

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */; } }

.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent; }

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em; }

@keyframes spinner-grow {
  0% {
    transform: scale(0); }
  50% {
    opacity: 1;
    transform: none; } }

.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0; }

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem; }

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s; } }

.offcanvas-sm, .offcanvas-md, .offcanvas-lg, .offcanvas-xl, .offcanvas-xxl, .offcanvas {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5; }

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition); } }
  @media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-sm {
      transition: none; } }

@media (max-width: 575.98px) {
    .offcanvas-sm.offcanvas-start {
      top: 0;
      left: 0;
      width: var(--bs-offcanvas-width);
      border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(-100%); }
    .offcanvas-sm.offcanvas-end {
      top: 0;
      right: 0;
      width: var(--bs-offcanvas-width);
      border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(100%); }
    .offcanvas-sm.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-sm.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
      transform: none; }
    .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
      visibility: visible; } }

@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-sm .offcanvas-header {
      display: none; }
    .offcanvas-sm .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition); } }
  @media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-md {
      transition: none; } }

@media (max-width: 767.98px) {
    .offcanvas-md.offcanvas-start {
      top: 0;
      left: 0;
      width: var(--bs-offcanvas-width);
      border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(-100%); }
    .offcanvas-md.offcanvas-end {
      top: 0;
      right: 0;
      width: var(--bs-offcanvas-width);
      border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(100%); }
    .offcanvas-md.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-md.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
      transform: none; }
    .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
      visibility: visible; } }

@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-md .offcanvas-header {
      display: none; }
    .offcanvas-md .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition); } }
  @media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-lg {
      transition: none; } }

@media (max-width: 991.98px) {
    .offcanvas-lg.offcanvas-start {
      top: 0;
      left: 0;
      width: var(--bs-offcanvas-width);
      border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(-100%); }
    .offcanvas-lg.offcanvas-end {
      top: 0;
      right: 0;
      width: var(--bs-offcanvas-width);
      border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(100%); }
    .offcanvas-lg.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-lg.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
      transform: none; }
    .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
      visibility: visible; } }

@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-lg .offcanvas-header {
      display: none; }
    .offcanvas-lg .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition); } }
  @media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-xl {
      transition: none; } }

@media (max-width: 1199.98px) {
    .offcanvas-xl.offcanvas-start {
      top: 0;
      left: 0;
      width: var(--bs-offcanvas-width);
      border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(-100%); }
    .offcanvas-xl.offcanvas-end {
      top: 0;
      right: 0;
      width: var(--bs-offcanvas-width);
      border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(100%); }
    .offcanvas-xl.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-xl.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
      transform: none; }
    .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
      visibility: visible; } }

@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-xl .offcanvas-header {
      display: none; }
    .offcanvas-xl .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition); } }
  @media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-xxl {
      transition: none; } }

@media (max-width: 1399.98px) {
    .offcanvas-xxl.offcanvas-start {
      top: 0;
      left: 0;
      width: var(--bs-offcanvas-width);
      border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(-100%); }
    .offcanvas-xxl.offcanvas-end {
      top: 0;
      right: 0;
      width: var(--bs-offcanvas-width);
      border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(100%); }
    .offcanvas-xxl.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-xxl.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
      transform: none; }
    .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
      visibility: visible; } }

@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-xxl .offcanvas-header {
      display: none; }
    .offcanvas-xxl .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition); }
  @media (prefers-reduced-motion: reduce) {
    .offcanvas {
      transition: none; } }
  .offcanvas.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%); }
  .offcanvas.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%); }
  .offcanvas.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%); }
  .offcanvas.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%); }
  .offcanvas.showing, .offcanvas.show:not(.hiding) {
    transform: none; }
  .offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
    visibility: visible; }

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000; }
  .offcanvas-backdrop.fade {
    opacity: 0; }
  .offcanvas-backdrop.show {
    opacity: 0.5; }

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x); }
  .offcanvas-header .btn-close {
    padding: calc(var(--bs-offcanvas-padding-y) * .5) calc(var(--bs-offcanvas-padding-x) * .5);
    margin-top: calc(-.5 * var(--bs-offcanvas-padding-y));
    margin-right: calc(-.5 * var(--bs-offcanvas-padding-x));
    margin-bottom: calc(-.5 * var(--bs-offcanvas-padding-y));
    margin-left: auto; }

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height); }

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto; }

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5; }
  .placeholder.btn::before {
    display: inline-block;
    content: ""; }

.placeholder-xs {
  min-height: .6em; }

.placeholder-sm {
  min-height: .8em; }

.placeholder-lg {
  min-height: 1.2em; }

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite; }

@keyframes placeholder-glow {
  50% {
    opacity: 0.2; } }

.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite; }

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%; } }

.clearfix::after {
  display: block;
  clear: both;
  content: ""; }

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-info {
  color: #000 !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important; }

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important; }

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-primary:hover, .link-primary:focus {
    color: RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important; }

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-secondary:hover, .link-secondary:focus {
    color: RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important; }

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-success:hover, .link-success:focus {
    color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important; }

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-info:hover, .link-info:focus {
    color: RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important; }

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-warning:hover, .link-warning:focus {
    color: RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important; }

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-danger:hover, .link-danger:focus {
    color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important; }

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-light:hover, .link-light:focus {
    color: RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important; }

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-dark:hover, .link-dark:focus {
    color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;
    text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important; }

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important; }
  .link-body-emphasis:hover, .link-body-emphasis:focus {
    color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
    text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important; }

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color); }

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden; }
  .icon-link > .bi {
    flex-shrink: 0;
    width: 1em;
    height: 1em;
    fill: currentcolor;
    transition: 0.2s ease-in-out transform; }
    @media (prefers-reduced-motion: reduce) {
      .icon-link > .bi {
        transition: none; } }

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0)); }

.ratio {
  position: relative;
  width: 100%; }
  .ratio::before {
    display: block;
    padding-top: var(--bs-aspect-ratio);
    content: ""; }
  .ratio > * {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%; }

.ratio-1x1 {
  --bs-aspect-ratio: 100%; }

.ratio-4x3 {
  --bs-aspect-ratio: calc(3 / 4 * 100%); }

.ratio-16x9 {
  --bs-aspect-ratio: calc(9 / 16 * 100%); }

.ratio-21x9 {
  --bs-aspect-ratio: calc(9 / 21 * 100%); }

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030; }

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030; }

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020; }

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020; }

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch; }

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch; }

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important; }
  .visually-hidden:not(caption),
  .visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
    position: absolute !important; }
  .visually-hidden *,
  .visually-hidden-focusable:not(:focus):not(:focus-within) * {
    overflow: hidden !important; }

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: ""; }

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25; }

.align-baseline {
  vertical-align: baseline !important; }

.align-top {
  vertical-align: top !important; }

.align-middle {
  vertical-align: middle !important; }

.align-bottom {
  vertical-align: bottom !important; }

.align-text-bottom {
  vertical-align: text-bottom !important; }

.align-text-top {
  vertical-align: text-top !important; }

.float-start {
  float: left !important; }

.float-end {
  float: right !important; }

.float-none {
  float: none !important; }

.object-fit-contain {
  object-fit: contain !important; }

.object-fit-cover {
  object-fit: cover !important; }

.object-fit-fill {
  object-fit: fill !important; }

.object-fit-scale {
  object-fit: scale-down !important; }

.object-fit-none {
  object-fit: none !important; }

.opacity-0 {
  opacity: 0 !important; }

.opacity-25 {
  opacity: 0.25 !important; }

.opacity-50 {
  opacity: 0.5 !important; }

.opacity-75 {
  opacity: 0.75 !important; }

.opacity-100 {
  opacity: 1 !important; }

.overflow-auto {
  overflow: auto !important; }

.overflow-hidden {
  overflow: hidden !important; }

.overflow-visible {
  overflow: visible !important; }

.overflow-scroll {
  overflow: scroll !important; }

.overflow-x-auto {
  overflow-x: auto !important; }

.overflow-x-hidden {
  overflow-x: hidden !important; }

.overflow-x-visible {
  overflow-x: visible !important; }

.overflow-x-scroll {
  overflow-x: scroll !important; }

.overflow-y-auto {
  overflow-y: auto !important; }

.overflow-y-hidden {
  overflow-y: hidden !important; }

.overflow-y-visible {
  overflow-y: visible !important; }

.overflow-y-scroll {
  overflow-y: scroll !important; }

.d-inline {
  display: inline !important; }

.d-inline-block {
  display: inline-block !important; }

.d-block {
  display: block !important; }

.d-grid {
  display: grid !important; }

.d-inline-grid {
  display: inline-grid !important; }

.d-table {
  display: table !important; }

.d-table-row {
  display: table-row !important; }

.d-table-cell {
  display: table-cell !important; }

.d-flex {
  display: flex !important; }

.d-inline-flex {
  display: inline-flex !important; }

.d-none {
  display: none !important; }

.shadow {
  box-shadow: var(--bs-box-shadow) !important; }

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important; }

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important; }

.shadow-none {
  box-shadow: none !important; }

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity)); }

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity)); }

.position-static {
  position: static !important; }

.position-relative {
  position: relative !important; }

.position-absolute {
  position: absolute !important; }

.position-fixed {
  position: fixed !important; }

.position-sticky {
  position: sticky !important; }

.top-0 {
  top: 0 !important; }

.top-50 {
  top: 50% !important; }

.top-100 {
  top: 100% !important; }

.bottom-0 {
  bottom: 0 !important; }

.bottom-50 {
  bottom: 50% !important; }

.bottom-100 {
  bottom: 100% !important; }

.start-0 {
  left: 0 !important; }

.start-50 {
  left: 50% !important; }

.start-100 {
  left: 100% !important; }

.end-0 {
  right: 0 !important; }

.end-50 {
  right: 50% !important; }

.end-100 {
  right: 100% !important; }

.translate-middle {
  transform: translate(-50%, -50%) !important; }

.translate-middle-x {
  transform: translateX(-50%) !important; }

.translate-middle-y {
  transform: translateY(-50%) !important; }

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important; }

.border-0 {
  border: 0 !important; }

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important; }

.border-top-0 {
  border-top: 0 !important; }

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important; }

.border-end-0 {
  border-right: 0 !important; }

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important; }

.border-bottom-0 {
  border-bottom: 0 !important; }

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important; }

.border-start-0 {
  border-left: 0 !important; }

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important; }

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important; }

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important; }

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important; }

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important; }

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important; }

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important; }

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important; }

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important; }

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important; }

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important; }

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important; }

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important; }

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important; }

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important; }

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important; }

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important; }

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important; }

.border-1 {
  border-width: 1px !important; }

.border-2 {
  border-width: 2px !important; }

.border-3 {
  border-width: 3px !important; }

.border-4 {
  border-width: 4px !important; }

.border-5 {
  border-width: 5px !important; }

.border-opacity-10 {
  --bs-border-opacity: 0.1; }

.border-opacity-25 {
  --bs-border-opacity: 0.25; }

.border-opacity-50 {
  --bs-border-opacity: 0.5; }

.border-opacity-75 {
  --bs-border-opacity: 0.75; }

.border-opacity-100 {
  --bs-border-opacity: 1; }

.w-25 {
  width: 25% !important; }

.w-50 {
  width: 50% !important; }

.w-75 {
  width: 75% !important; }

.w-100 {
  width: 100% !important; }

.w-auto {
  width: auto !important; }

.mw-100 {
  max-width: 100% !important; }

.vw-100 {
  width: 100vw !important; }

.min-vw-100 {
  min-width: 100vw !important; }

.h-25 {
  height: 25% !important; }

.h-50 {
  height: 50% !important; }

.h-75 {
  height: 75% !important; }

.h-100 {
  height: 100% !important; }

.h-auto {
  height: auto !important; }

.mh-100 {
  max-height: 100% !important; }

.vh-100 {
  height: 100vh !important; }

.min-vh-100 {
  min-height: 100vh !important; }

.flex-fill {
  flex: 1 1 auto !important; }

.flex-row {
  flex-direction: row !important; }

.flex-column {
  flex-direction: column !important; }

.flex-row-reverse {
  flex-direction: row-reverse !important; }

.flex-column-reverse {
  flex-direction: column-reverse !important; }

.flex-grow-0 {
  flex-grow: 0 !important; }

.flex-grow-1 {
  flex-grow: 1 !important; }

.flex-shrink-0 {
  flex-shrink: 0 !important; }

.flex-shrink-1 {
  flex-shrink: 1 !important; }

.flex-wrap {
  flex-wrap: wrap !important; }

.flex-nowrap {
  flex-wrap: nowrap !important; }

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important; }

.justify-content-start {
  justify-content: flex-start !important; }

.justify-content-end {
  justify-content: flex-end !important; }

.justify-content-center {
  justify-content: center !important; }

.justify-content-between {
  justify-content: space-between !important; }

.justify-content-around {
  justify-content: space-around !important; }

.justify-content-evenly {
  justify-content: space-evenly !important; }

.align-items-start {
  align-items: flex-start !important; }

.align-items-end {
  align-items: flex-end !important; }

.align-items-center {
  align-items: center !important; }

.align-items-baseline {
  align-items: baseline !important; }

.align-items-stretch {
  align-items: stretch !important; }

.align-content-start {
  align-content: flex-start !important; }

.align-content-end {
  align-content: flex-end !important; }

.align-content-center {
  align-content: center !important; }

.align-content-between {
  align-content: space-between !important; }

.align-content-around {
  align-content: space-around !important; }

.align-content-stretch {
  align-content: stretch !important; }

.align-self-auto {
  align-self: auto !important; }

.align-self-start {
  align-self: flex-start !important; }

.align-self-end {
  align-self: flex-end !important; }

.align-self-center {
  align-self: center !important; }

.align-self-baseline {
  align-self: baseline !important; }

.align-self-stretch {
  align-self: stretch !important; }

.order-first {
  order: -1 !important; }

.order-0 {
  order: 0 !important; }

.order-1 {
  order: 1 !important; }

.order-2 {
  order: 2 !important; }

.order-3 {
  order: 3 !important; }

.order-4 {
  order: 4 !important; }

.order-5 {
  order: 5 !important; }

.order-last {
  order: 6 !important; }

.m-0 {
  margin: 0 !important; }

.m-1 {
  margin: 0.25rem !important; }

.m-2 {
  margin: 0.5rem !important; }

.m-3 {
  margin: 1rem !important; }

.m-4 {
  margin: 1.5rem !important; }

.m-5 {
  margin: 3rem !important; }

.m-auto {
  margin: auto !important; }

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important; }

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important; }

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important; }

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important; }

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important; }

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important; }

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important; }

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important; }

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important; }

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important; }

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important; }

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important; }

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important; }

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important; }

.mt-0 {
  margin-top: 0 !important; }

.mt-1 {
  margin-top: 0.25rem !important; }

.mt-2 {
  margin-top: 0.5rem !important; }

.mt-3 {
  margin-top: 1rem !important; }

.mt-4 {
  margin-top: 1.5rem !important; }

.mt-5 {
  margin-top: 3rem !important; }

.mt-auto {
  margin-top: auto !important; }

.me-0 {
  margin-right: 0 !important; }

.me-1 {
  margin-right: 0.25rem !important; }

.me-2 {
  margin-right: 0.5rem !important; }

.me-3 {
  margin-right: 1rem !important; }

.me-4 {
  margin-right: 1.5rem !important; }

.me-5 {
  margin-right: 3rem !important; }

.me-auto {
  margin-right: auto !important; }

.mb-0 {
  margin-bottom: 0 !important; }

.mb-1 {
  margin-bottom: 0.25rem !important; }

.mb-2 {
  margin-bottom: 0.5rem !important; }

.mb-3 {
  margin-bottom: 1rem !important; }

.mb-4 {
  margin-bottom: 1.5rem !important; }

.mb-5 {
  margin-bottom: 3rem !important; }

.mb-auto {
  margin-bottom: auto !important; }

.ms-0 {
  margin-left: 0 !important; }

.ms-1 {
  margin-left: 0.25rem !important; }

.ms-2 {
  margin-left: 0.5rem !important; }

.ms-3 {
  margin-left: 1rem !important; }

.ms-4 {
  margin-left: 1.5rem !important; }

.ms-5 {
  margin-left: 3rem !important; }

.ms-auto {
  margin-left: auto !important; }

.p-0 {
  padding: 0 !important; }

.p-1 {
  padding: 0.25rem !important; }

.p-2 {
  padding: 0.5rem !important; }

.p-3 {
  padding: 1rem !important; }

.p-4 {
  padding: 1.5rem !important; }

.p-5 {
  padding: 3rem !important; }

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important; }

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important; }

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important; }

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important; }

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important; }

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important; }

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important; }

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important; }

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important; }

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important; }

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important; }

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important; }

.pt-0 {
  padding-top: 0 !important; }

.pt-1 {
  padding-top: 0.25rem !important; }

.pt-2 {
  padding-top: 0.5rem !important; }

.pt-3 {
  padding-top: 1rem !important; }

.pt-4 {
  padding-top: 1.5rem !important; }

.pt-5 {
  padding-top: 3rem !important; }

.pe-0 {
  padding-right: 0 !important; }

.pe-1 {
  padding-right: 0.25rem !important; }

.pe-2 {
  padding-right: 0.5rem !important; }

.pe-3 {
  padding-right: 1rem !important; }

.pe-4 {
  padding-right: 1.5rem !important; }

.pe-5 {
  padding-right: 3rem !important; }

.pb-0 {
  padding-bottom: 0 !important; }

.pb-1 {
  padding-bottom: 0.25rem !important; }

.pb-2 {
  padding-bottom: 0.5rem !important; }

.pb-3 {
  padding-bottom: 1rem !important; }

.pb-4 {
  padding-bottom: 1.5rem !important; }

.pb-5 {
  padding-bottom: 3rem !important; }

.ps-0 {
  padding-left: 0 !important; }

.ps-1 {
  padding-left: 0.25rem !important; }

.ps-2 {
  padding-left: 0.5rem !important; }

.ps-3 {
  padding-left: 1rem !important; }

.ps-4 {
  padding-left: 1.5rem !important; }

.ps-5 {
  padding-left: 3rem !important; }

.gap-0 {
  gap: 0 !important; }

.gap-1 {
  gap: 0.25rem !important; }

.gap-2 {
  gap: 0.5rem !important; }

.gap-3 {
  gap: 1rem !important; }

.gap-4 {
  gap: 1.5rem !important; }

.gap-5 {
  gap: 3rem !important; }

.row-gap-0 {
  row-gap: 0 !important; }

.row-gap-1 {
  row-gap: 0.25rem !important; }

.row-gap-2 {
  row-gap: 0.5rem !important; }

.row-gap-3 {
  row-gap: 1rem !important; }

.row-gap-4 {
  row-gap: 1.5rem !important; }

.row-gap-5 {
  row-gap: 3rem !important; }

.column-gap-0 {
  column-gap: 0 !important; }

.column-gap-1 {
  column-gap: 0.25rem !important; }

.column-gap-2 {
  column-gap: 0.5rem !important; }

.column-gap-3 {
  column-gap: 1rem !important; }

.column-gap-4 {
  column-gap: 1.5rem !important; }

.column-gap-5 {
  column-gap: 3rem !important; }

.font-monospace {
  font-family: var(--bs-font-monospace) !important; }

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important; }

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important; }

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important; }

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important; }

.fs-5 {
  font-size: 1.25rem !important; }

.fs-6 {
  font-size: 1rem !important; }

.fst-italic {
  font-style: italic !important; }

.fst-normal {
  font-style: normal !important; }

.fw-lighter {
  font-weight: lighter !important; }

.fw-light {
  font-weight: 300 !important; }

.fw-normal {
  font-weight: 400 !important; }

.fw-medium {
  font-weight: 500 !important; }

.fw-semibold {
  font-weight: 600 !important; }

.fw-bold {
  font-weight: 700 !important; }

.fw-bolder {
  font-weight: bolder !important; }

.lh-1 {
  line-height: 1 !important; }

.lh-sm {
  line-height: 1.25 !important; }

.lh-base {
  line-height: 1.5 !important; }

.lh-lg {
  line-height: 2 !important; }

.text-start {
  text-align: left !important; }

.text-end {
  text-align: right !important; }

.text-center {
  text-align: center !important; }

.text-decoration-none {
  text-decoration: none !important; }

.text-decoration-underline {
  text-decoration: underline !important; }

.text-decoration-line-through {
  text-decoration: line-through !important; }

.text-lowercase {
  text-transform: lowercase !important; }

.text-uppercase {
  text-transform: uppercase !important; }

.text-capitalize {
  text-transform: capitalize !important; }

.text-wrap {
  white-space: normal !important; }

.text-nowrap {
  white-space: nowrap !important; }

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important; }

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important; }

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important; }

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important; }

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important; }

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important; }

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important; }

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important; }

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important; }

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important; }

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important; }

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important; }

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important; }

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important; }

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important; }

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important; }

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important; }

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important; }

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important; }

.text-opacity-25 {
  --bs-text-opacity: 0.25; }

.text-opacity-50 {
  --bs-text-opacity: 0.5; }

.text-opacity-75 {
  --bs-text-opacity: 0.75; }

.text-opacity-100 {
  --bs-text-opacity: 1; }

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important; }

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important; }

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important; }

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important; }

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important; }

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important; }

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important; }

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important; }

.link-opacity-10 {
  --bs-link-opacity: 0.1; }

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1; }

.link-opacity-25 {
  --bs-link-opacity: 0.25; }

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25; }

.link-opacity-50 {
  --bs-link-opacity: 0.5; }

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5; }

.link-opacity-75 {
  --bs-link-opacity: 0.75; }

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75; }

.link-opacity-100 {
  --bs-link-opacity: 1; }

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1; }

.link-offset-1 {
  text-underline-offset: 0.125em !important; }

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important; }

.link-offset-2 {
  text-underline-offset: 0.25em !important; }

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important; }

.link-offset-3 {
  text-underline-offset: 0.375em !important; }

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important; }

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important; }

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important; }

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0; }

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0; }

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1; }

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1; }

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25; }

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25; }

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5; }

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5; }

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75; }

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75; }

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1; }

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1; }

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important; }

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important; }

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important; }

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important; }

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important; }

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important; }

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important; }

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important; }

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important; }

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important; }

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important; }

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important; }

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important; }

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important; }

.bg-opacity-10 {
  --bs-bg-opacity: 0.1; }

.bg-opacity-25 {
  --bs-bg-opacity: 0.25; }

.bg-opacity-50 {
  --bs-bg-opacity: 0.5; }

.bg-opacity-75 {
  --bs-bg-opacity: 0.75; }

.bg-opacity-100 {
  --bs-bg-opacity: 1; }

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important; }

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important; }

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important; }

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important; }

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important; }

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important; }

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important; }

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important; }

.bg-gradient {
  background-image: var(--bs-gradient) !important; }

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important; }

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important; }

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important; }

.pe-none {
  pointer-events: none !important; }

.pe-auto {
  pointer-events: auto !important; }

.rounded {
  border-radius: var(--bs-border-radius) !important; }

.rounded-0 {
  border-radius: 0 !important; }

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important; }

.rounded-2 {
  border-radius: var(--bs-border-radius) !important; }

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important; }

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important; }

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important; }

.rounded-circle {
  border-radius: 50% !important; }

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important; }

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important; }

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important; }

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important; }

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important; }

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important; }

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important; }

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important; }

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important; }

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important; }

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important; }

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important; }

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important; }

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important; }

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important; }

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important; }

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important; }

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important; }

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important; }

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important; }

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important; }

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important; }

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important; }

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important; }

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important; }

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important; }

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important; }

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important; }

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important; }

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important; }

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important; }

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important; }

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important; }

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important; }

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important; }

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important; }

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important; }

.visible {
  visibility: visible !important; }

.invisible {
  visibility: hidden !important; }

.z-n1 {
  z-index: -1 !important; }

.z-0 {
  z-index: 0 !important; }

.z-1 {
  z-index: 1 !important; }

.z-2 {
  z-index: 2 !important; }

.z-3 {
  z-index: 3 !important; }

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important; }
  .float-sm-end {
    float: right !important; }
  .float-sm-none {
    float: none !important; }
  .object-fit-sm-contain {
    object-fit: contain !important; }
  .object-fit-sm-cover {
    object-fit: cover !important; }
  .object-fit-sm-fill {
    object-fit: fill !important; }
  .object-fit-sm-scale {
    object-fit: scale-down !important; }
  .object-fit-sm-none {
    object-fit: none !important; }
  .d-sm-inline {
    display: inline !important; }
  .d-sm-inline-block {
    display: inline-block !important; }
  .d-sm-block {
    display: block !important; }
  .d-sm-grid {
    display: grid !important; }
  .d-sm-inline-grid {
    display: inline-grid !important; }
  .d-sm-table {
    display: table !important; }
  .d-sm-table-row {
    display: table-row !important; }
  .d-sm-table-cell {
    display: table-cell !important; }
  .d-sm-flex {
    display: flex !important; }
  .d-sm-inline-flex {
    display: inline-flex !important; }
  .d-sm-none {
    display: none !important; }
  .flex-sm-fill {
    flex: 1 1 auto !important; }
  .flex-sm-row {
    flex-direction: row !important; }
  .flex-sm-column {
    flex-direction: column !important; }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-sm-grow-0 {
    flex-grow: 0 !important; }
  .flex-sm-grow-1 {
    flex-grow: 1 !important; }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-sm-wrap {
    flex-wrap: wrap !important; }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important; }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-sm-start {
    justify-content: flex-start !important; }
  .justify-content-sm-end {
    justify-content: flex-end !important; }
  .justify-content-sm-center {
    justify-content: center !important; }
  .justify-content-sm-between {
    justify-content: space-between !important; }
  .justify-content-sm-around {
    justify-content: space-around !important; }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important; }
  .align-items-sm-start {
    align-items: flex-start !important; }
  .align-items-sm-end {
    align-items: flex-end !important; }
  .align-items-sm-center {
    align-items: center !important; }
  .align-items-sm-baseline {
    align-items: baseline !important; }
  .align-items-sm-stretch {
    align-items: stretch !important; }
  .align-content-sm-start {
    align-content: flex-start !important; }
  .align-content-sm-end {
    align-content: flex-end !important; }
  .align-content-sm-center {
    align-content: center !important; }
  .align-content-sm-between {
    align-content: space-between !important; }
  .align-content-sm-around {
    align-content: space-around !important; }
  .align-content-sm-stretch {
    align-content: stretch !important; }
  .align-self-sm-auto {
    align-self: auto !important; }
  .align-self-sm-start {
    align-self: flex-start !important; }
  .align-self-sm-end {
    align-self: flex-end !important; }
  .align-self-sm-center {
    align-self: center !important; }
  .align-self-sm-baseline {
    align-self: baseline !important; }
  .align-self-sm-stretch {
    align-self: stretch !important; }
  .order-sm-first {
    order: -1 !important; }
  .order-sm-0 {
    order: 0 !important; }
  .order-sm-1 {
    order: 1 !important; }
  .order-sm-2 {
    order: 2 !important; }
  .order-sm-3 {
    order: 3 !important; }
  .order-sm-4 {
    order: 4 !important; }
  .order-sm-5 {
    order: 5 !important; }
  .order-sm-last {
    order: 6 !important; }
  .m-sm-0 {
    margin: 0 !important; }
  .m-sm-1 {
    margin: 0.25rem !important; }
  .m-sm-2 {
    margin: 0.5rem !important; }
  .m-sm-3 {
    margin: 1rem !important; }
  .m-sm-4 {
    margin: 1.5rem !important; }
  .m-sm-5 {
    margin: 3rem !important; }
  .m-sm-auto {
    margin: auto !important; }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-sm-0 {
    margin-top: 0 !important; }
  .mt-sm-1 {
    margin-top: 0.25rem !important; }
  .mt-sm-2 {
    margin-top: 0.5rem !important; }
  .mt-sm-3 {
    margin-top: 1rem !important; }
  .mt-sm-4 {
    margin-top: 1.5rem !important; }
  .mt-sm-5 {
    margin-top: 3rem !important; }
  .mt-sm-auto {
    margin-top: auto !important; }
  .me-sm-0 {
    margin-right: 0 !important; }
  .me-sm-1 {
    margin-right: 0.25rem !important; }
  .me-sm-2 {
    margin-right: 0.5rem !important; }
  .me-sm-3 {
    margin-right: 1rem !important; }
  .me-sm-4 {
    margin-right: 1.5rem !important; }
  .me-sm-5 {
    margin-right: 3rem !important; }
  .me-sm-auto {
    margin-right: auto !important; }
  .mb-sm-0 {
    margin-bottom: 0 !important; }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important; }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important; }
  .mb-sm-3 {
    margin-bottom: 1rem !important; }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important; }
  .mb-sm-5 {
    margin-bottom: 3rem !important; }
  .mb-sm-auto {
    margin-bottom: auto !important; }
  .ms-sm-0 {
    margin-left: 0 !important; }
  .ms-sm-1 {
    margin-left: 0.25rem !important; }
  .ms-sm-2 {
    margin-left: 0.5rem !important; }
  .ms-sm-3 {
    margin-left: 1rem !important; }
  .ms-sm-4 {
    margin-left: 1.5rem !important; }
  .ms-sm-5 {
    margin-left: 3rem !important; }
  .ms-sm-auto {
    margin-left: auto !important; }
  .p-sm-0 {
    padding: 0 !important; }
  .p-sm-1 {
    padding: 0.25rem !important; }
  .p-sm-2 {
    padding: 0.5rem !important; }
  .p-sm-3 {
    padding: 1rem !important; }
  .p-sm-4 {
    padding: 1.5rem !important; }
  .p-sm-5 {
    padding: 3rem !important; }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-sm-0 {
    padding-top: 0 !important; }
  .pt-sm-1 {
    padding-top: 0.25rem !important; }
  .pt-sm-2 {
    padding-top: 0.5rem !important; }
  .pt-sm-3 {
    padding-top: 1rem !important; }
  .pt-sm-4 {
    padding-top: 1.5rem !important; }
  .pt-sm-5 {
    padding-top: 3rem !important; }
  .pe-sm-0 {
    padding-right: 0 !important; }
  .pe-sm-1 {
    padding-right: 0.25rem !important; }
  .pe-sm-2 {
    padding-right: 0.5rem !important; }
  .pe-sm-3 {
    padding-right: 1rem !important; }
  .pe-sm-4 {
    padding-right: 1.5rem !important; }
  .pe-sm-5 {
    padding-right: 3rem !important; }
  .pb-sm-0 {
    padding-bottom: 0 !important; }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important; }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important; }
  .pb-sm-3 {
    padding-bottom: 1rem !important; }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important; }
  .pb-sm-5 {
    padding-bottom: 3rem !important; }
  .ps-sm-0 {
    padding-left: 0 !important; }
  .ps-sm-1 {
    padding-left: 0.25rem !important; }
  .ps-sm-2 {
    padding-left: 0.5rem !important; }
  .ps-sm-3 {
    padding-left: 1rem !important; }
  .ps-sm-4 {
    padding-left: 1.5rem !important; }
  .ps-sm-5 {
    padding-left: 3rem !important; }
  .gap-sm-0 {
    gap: 0 !important; }
  .gap-sm-1 {
    gap: 0.25rem !important; }
  .gap-sm-2 {
    gap: 0.5rem !important; }
  .gap-sm-3 {
    gap: 1rem !important; }
  .gap-sm-4 {
    gap: 1.5rem !important; }
  .gap-sm-5 {
    gap: 3rem !important; }
  .row-gap-sm-0 {
    row-gap: 0 !important; }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important; }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important; }
  .row-gap-sm-3 {
    row-gap: 1rem !important; }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important; }
  .row-gap-sm-5 {
    row-gap: 3rem !important; }
  .column-gap-sm-0 {
    column-gap: 0 !important; }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important; }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important; }
  .column-gap-sm-3 {
    column-gap: 1rem !important; }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important; }
  .column-gap-sm-5 {
    column-gap: 3rem !important; }
  .text-sm-start {
    text-align: left !important; }
  .text-sm-end {
    text-align: right !important; }
  .text-sm-center {
    text-align: center !important; } }

@media (min-width: 768px) {
  .float-md-start {
    float: left !important; }
  .float-md-end {
    float: right !important; }
  .float-md-none {
    float: none !important; }
  .object-fit-md-contain {
    object-fit: contain !important; }
  .object-fit-md-cover {
    object-fit: cover !important; }
  .object-fit-md-fill {
    object-fit: fill !important; }
  .object-fit-md-scale {
    object-fit: scale-down !important; }
  .object-fit-md-none {
    object-fit: none !important; }
  .d-md-inline {
    display: inline !important; }
  .d-md-inline-block {
    display: inline-block !important; }
  .d-md-block {
    display: block !important; }
  .d-md-grid {
    display: grid !important; }
  .d-md-inline-grid {
    display: inline-grid !important; }
  .d-md-table {
    display: table !important; }
  .d-md-table-row {
    display: table-row !important; }
  .d-md-table-cell {
    display: table-cell !important; }
  .d-md-flex {
    display: flex !important; }
  .d-md-inline-flex {
    display: inline-flex !important; }
  .d-md-none {
    display: none !important; }
  .flex-md-fill {
    flex: 1 1 auto !important; }
  .flex-md-row {
    flex-direction: row !important; }
  .flex-md-column {
    flex-direction: column !important; }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-md-grow-0 {
    flex-grow: 0 !important; }
  .flex-md-grow-1 {
    flex-grow: 1 !important; }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-md-wrap {
    flex-wrap: wrap !important; }
  .flex-md-nowrap {
    flex-wrap: nowrap !important; }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-md-start {
    justify-content: flex-start !important; }
  .justify-content-md-end {
    justify-content: flex-end !important; }
  .justify-content-md-center {
    justify-content: center !important; }
  .justify-content-md-between {
    justify-content: space-between !important; }
  .justify-content-md-around {
    justify-content: space-around !important; }
  .justify-content-md-evenly {
    justify-content: space-evenly !important; }
  .align-items-md-start {
    align-items: flex-start !important; }
  .align-items-md-end {
    align-items: flex-end !important; }
  .align-items-md-center {
    align-items: center !important; }
  .align-items-md-baseline {
    align-items: baseline !important; }
  .align-items-md-stretch {
    align-items: stretch !important; }
  .align-content-md-start {
    align-content: flex-start !important; }
  .align-content-md-end {
    align-content: flex-end !important; }
  .align-content-md-center {
    align-content: center !important; }
  .align-content-md-between {
    align-content: space-between !important; }
  .align-content-md-around {
    align-content: space-around !important; }
  .align-content-md-stretch {
    align-content: stretch !important; }
  .align-self-md-auto {
    align-self: auto !important; }
  .align-self-md-start {
    align-self: flex-start !important; }
  .align-self-md-end {
    align-self: flex-end !important; }
  .align-self-md-center {
    align-self: center !important; }
  .align-self-md-baseline {
    align-self: baseline !important; }
  .align-self-md-stretch {
    align-self: stretch !important; }
  .order-md-first {
    order: -1 !important; }
  .order-md-0 {
    order: 0 !important; }
  .order-md-1 {
    order: 1 !important; }
  .order-md-2 {
    order: 2 !important; }
  .order-md-3 {
    order: 3 !important; }
  .order-md-4 {
    order: 4 !important; }
  .order-md-5 {
    order: 5 !important; }
  .order-md-last {
    order: 6 !important; }
  .m-md-0 {
    margin: 0 !important; }
  .m-md-1 {
    margin: 0.25rem !important; }
  .m-md-2 {
    margin: 0.5rem !important; }
  .m-md-3 {
    margin: 1rem !important; }
  .m-md-4 {
    margin: 1.5rem !important; }
  .m-md-5 {
    margin: 3rem !important; }
  .m-md-auto {
    margin: auto !important; }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-md-0 {
    margin-top: 0 !important; }
  .mt-md-1 {
    margin-top: 0.25rem !important; }
  .mt-md-2 {
    margin-top: 0.5rem !important; }
  .mt-md-3 {
    margin-top: 1rem !important; }
  .mt-md-4 {
    margin-top: 1.5rem !important; }
  .mt-md-5 {
    margin-top: 3rem !important; }
  .mt-md-auto {
    margin-top: auto !important; }
  .me-md-0 {
    margin-right: 0 !important; }
  .me-md-1 {
    margin-right: 0.25rem !important; }
  .me-md-2 {
    margin-right: 0.5rem !important; }
  .me-md-3 {
    margin-right: 1rem !important; }
  .me-md-4 {
    margin-right: 1.5rem !important; }
  .me-md-5 {
    margin-right: 3rem !important; }
  .me-md-auto {
    margin-right: auto !important; }
  .mb-md-0 {
    margin-bottom: 0 !important; }
  .mb-md-1 {
    margin-bottom: 0.25rem !important; }
  .mb-md-2 {
    margin-bottom: 0.5rem !important; }
  .mb-md-3 {
    margin-bottom: 1rem !important; }
  .mb-md-4 {
    margin-bottom: 1.5rem !important; }
  .mb-md-5 {
    margin-bottom: 3rem !important; }
  .mb-md-auto {
    margin-bottom: auto !important; }
  .ms-md-0 {
    margin-left: 0 !important; }
  .ms-md-1 {
    margin-left: 0.25rem !important; }
  .ms-md-2 {
    margin-left: 0.5rem !important; }
  .ms-md-3 {
    margin-left: 1rem !important; }
  .ms-md-4 {
    margin-left: 1.5rem !important; }
  .ms-md-5 {
    margin-left: 3rem !important; }
  .ms-md-auto {
    margin-left: auto !important; }
  .p-md-0 {
    padding: 0 !important; }
  .p-md-1 {
    padding: 0.25rem !important; }
  .p-md-2 {
    padding: 0.5rem !important; }
  .p-md-3 {
    padding: 1rem !important; }
  .p-md-4 {
    padding: 1.5rem !important; }
  .p-md-5 {
    padding: 3rem !important; }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-md-0 {
    padding-top: 0 !important; }
  .pt-md-1 {
    padding-top: 0.25rem !important; }
  .pt-md-2 {
    padding-top: 0.5rem !important; }
  .pt-md-3 {
    padding-top: 1rem !important; }
  .pt-md-4 {
    padding-top: 1.5rem !important; }
  .pt-md-5 {
    padding-top: 3rem !important; }
  .pe-md-0 {
    padding-right: 0 !important; }
  .pe-md-1 {
    padding-right: 0.25rem !important; }
  .pe-md-2 {
    padding-right: 0.5rem !important; }
  .pe-md-3 {
    padding-right: 1rem !important; }
  .pe-md-4 {
    padding-right: 1.5rem !important; }
  .pe-md-5 {
    padding-right: 3rem !important; }
  .pb-md-0 {
    padding-bottom: 0 !important; }
  .pb-md-1 {
    padding-bottom: 0.25rem !important; }
  .pb-md-2 {
    padding-bottom: 0.5rem !important; }
  .pb-md-3 {
    padding-bottom: 1rem !important; }
  .pb-md-4 {
    padding-bottom: 1.5rem !important; }
  .pb-md-5 {
    padding-bottom: 3rem !important; }
  .ps-md-0 {
    padding-left: 0 !important; }
  .ps-md-1 {
    padding-left: 0.25rem !important; }
  .ps-md-2 {
    padding-left: 0.5rem !important; }
  .ps-md-3 {
    padding-left: 1rem !important; }
  .ps-md-4 {
    padding-left: 1.5rem !important; }
  .ps-md-5 {
    padding-left: 3rem !important; }
  .gap-md-0 {
    gap: 0 !important; }
  .gap-md-1 {
    gap: 0.25rem !important; }
  .gap-md-2 {
    gap: 0.5rem !important; }
  .gap-md-3 {
    gap: 1rem !important; }
  .gap-md-4 {
    gap: 1.5rem !important; }
  .gap-md-5 {
    gap: 3rem !important; }
  .row-gap-md-0 {
    row-gap: 0 !important; }
  .row-gap-md-1 {
    row-gap: 0.25rem !important; }
  .row-gap-md-2 {
    row-gap: 0.5rem !important; }
  .row-gap-md-3 {
    row-gap: 1rem !important; }
  .row-gap-md-4 {
    row-gap: 1.5rem !important; }
  .row-gap-md-5 {
    row-gap: 3rem !important; }
  .column-gap-md-0 {
    column-gap: 0 !important; }
  .column-gap-md-1 {
    column-gap: 0.25rem !important; }
  .column-gap-md-2 {
    column-gap: 0.5rem !important; }
  .column-gap-md-3 {
    column-gap: 1rem !important; }
  .column-gap-md-4 {
    column-gap: 1.5rem !important; }
  .column-gap-md-5 {
    column-gap: 3rem !important; }
  .text-md-start {
    text-align: left !important; }
  .text-md-end {
    text-align: right !important; }
  .text-md-center {
    text-align: center !important; } }

@media (min-width: 992px) {
  .float-lg-start {
    float: left !important; }
  .float-lg-end {
    float: right !important; }
  .float-lg-none {
    float: none !important; }
  .object-fit-lg-contain {
    object-fit: contain !important; }
  .object-fit-lg-cover {
    object-fit: cover !important; }
  .object-fit-lg-fill {
    object-fit: fill !important; }
  .object-fit-lg-scale {
    object-fit: scale-down !important; }
  .object-fit-lg-none {
    object-fit: none !important; }
  .d-lg-inline {
    display: inline !important; }
  .d-lg-inline-block {
    display: inline-block !important; }
  .d-lg-block {
    display: block !important; }
  .d-lg-grid {
    display: grid !important; }
  .d-lg-inline-grid {
    display: inline-grid !important; }
  .d-lg-table {
    display: table !important; }
  .d-lg-table-row {
    display: table-row !important; }
  .d-lg-table-cell {
    display: table-cell !important; }
  .d-lg-flex {
    display: flex !important; }
  .d-lg-inline-flex {
    display: inline-flex !important; }
  .d-lg-none {
    display: none !important; }
  .flex-lg-fill {
    flex: 1 1 auto !important; }
  .flex-lg-row {
    flex-direction: row !important; }
  .flex-lg-column {
    flex-direction: column !important; }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-lg-grow-0 {
    flex-grow: 0 !important; }
  .flex-lg-grow-1 {
    flex-grow: 1 !important; }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-lg-wrap {
    flex-wrap: wrap !important; }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important; }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-lg-start {
    justify-content: flex-start !important; }
  .justify-content-lg-end {
    justify-content: flex-end !important; }
  .justify-content-lg-center {
    justify-content: center !important; }
  .justify-content-lg-between {
    justify-content: space-between !important; }
  .justify-content-lg-around {
    justify-content: space-around !important; }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important; }
  .align-items-lg-start {
    align-items: flex-start !important; }
  .align-items-lg-end {
    align-items: flex-end !important; }
  .align-items-lg-center {
    align-items: center !important; }
  .align-items-lg-baseline {
    align-items: baseline !important; }
  .align-items-lg-stretch {
    align-items: stretch !important; }
  .align-content-lg-start {
    align-content: flex-start !important; }
  .align-content-lg-end {
    align-content: flex-end !important; }
  .align-content-lg-center {
    align-content: center !important; }
  .align-content-lg-between {
    align-content: space-between !important; }
  .align-content-lg-around {
    align-content: space-around !important; }
  .align-content-lg-stretch {
    align-content: stretch !important; }
  .align-self-lg-auto {
    align-self: auto !important; }
  .align-self-lg-start {
    align-self: flex-start !important; }
  .align-self-lg-end {
    align-self: flex-end !important; }
  .align-self-lg-center {
    align-self: center !important; }
  .align-self-lg-baseline {
    align-self: baseline !important; }
  .align-self-lg-stretch {
    align-self: stretch !important; }
  .order-lg-first {
    order: -1 !important; }
  .order-lg-0 {
    order: 0 !important; }
  .order-lg-1 {
    order: 1 !important; }
  .order-lg-2 {
    order: 2 !important; }
  .order-lg-3 {
    order: 3 !important; }
  .order-lg-4 {
    order: 4 !important; }
  .order-lg-5 {
    order: 5 !important; }
  .order-lg-last {
    order: 6 !important; }
  .m-lg-0 {
    margin: 0 !important; }
  .m-lg-1 {
    margin: 0.25rem !important; }
  .m-lg-2 {
    margin: 0.5rem !important; }
  .m-lg-3 {
    margin: 1rem !important; }
  .m-lg-4 {
    margin: 1.5rem !important; }
  .m-lg-5 {
    margin: 3rem !important; }
  .m-lg-auto {
    margin: auto !important; }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-lg-0 {
    margin-top: 0 !important; }
  .mt-lg-1 {
    margin-top: 0.25rem !important; }
  .mt-lg-2 {
    margin-top: 0.5rem !important; }
  .mt-lg-3 {
    margin-top: 1rem !important; }
  .mt-lg-4 {
    margin-top: 1.5rem !important; }
  .mt-lg-5 {
    margin-top: 3rem !important; }
  .mt-lg-auto {
    margin-top: auto !important; }
  .me-lg-0 {
    margin-right: 0 !important; }
  .me-lg-1 {
    margin-right: 0.25rem !important; }
  .me-lg-2 {
    margin-right: 0.5rem !important; }
  .me-lg-3 {
    margin-right: 1rem !important; }
  .me-lg-4 {
    margin-right: 1.5rem !important; }
  .me-lg-5 {
    margin-right: 3rem !important; }
  .me-lg-auto {
    margin-right: auto !important; }
  .mb-lg-0 {
    margin-bottom: 0 !important; }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important; }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important; }
  .mb-lg-3 {
    margin-bottom: 1rem !important; }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important; }
  .mb-lg-5 {
    margin-bottom: 3rem !important; }
  .mb-lg-auto {
    margin-bottom: auto !important; }
  .ms-lg-0 {
    margin-left: 0 !important; }
  .ms-lg-1 {
    margin-left: 0.25rem !important; }
  .ms-lg-2 {
    margin-left: 0.5rem !important; }
  .ms-lg-3 {
    margin-left: 1rem !important; }
  .ms-lg-4 {
    margin-left: 1.5rem !important; }
  .ms-lg-5 {
    margin-left: 3rem !important; }
  .ms-lg-auto {
    margin-left: auto !important; }
  .p-lg-0 {
    padding: 0 !important; }
  .p-lg-1 {
    padding: 0.25rem !important; }
  .p-lg-2 {
    padding: 0.5rem !important; }
  .p-lg-3 {
    padding: 1rem !important; }
  .p-lg-4 {
    padding: 1.5rem !important; }
  .p-lg-5 {
    padding: 3rem !important; }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-lg-0 {
    padding-top: 0 !important; }
  .pt-lg-1 {
    padding-top: 0.25rem !important; }
  .pt-lg-2 {
    padding-top: 0.5rem !important; }
  .pt-lg-3 {
    padding-top: 1rem !important; }
  .pt-lg-4 {
    padding-top: 1.5rem !important; }
  .pt-lg-5 {
    padding-top: 3rem !important; }
  .pe-lg-0 {
    padding-right: 0 !important; }
  .pe-lg-1 {
    padding-right: 0.25rem !important; }
  .pe-lg-2 {
    padding-right: 0.5rem !important; }
  .pe-lg-3 {
    padding-right: 1rem !important; }
  .pe-lg-4 {
    padding-right: 1.5rem !important; }
  .pe-lg-5 {
    padding-right: 3rem !important; }
  .pb-lg-0 {
    padding-bottom: 0 !important; }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important; }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important; }
  .pb-lg-3 {
    padding-bottom: 1rem !important; }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important; }
  .pb-lg-5 {
    padding-bottom: 3rem !important; }
  .ps-lg-0 {
    padding-left: 0 !important; }
  .ps-lg-1 {
    padding-left: 0.25rem !important; }
  .ps-lg-2 {
    padding-left: 0.5rem !important; }
  .ps-lg-3 {
    padding-left: 1rem !important; }
  .ps-lg-4 {
    padding-left: 1.5rem !important; }
  .ps-lg-5 {
    padding-left: 3rem !important; }
  .gap-lg-0 {
    gap: 0 !important; }
  .gap-lg-1 {
    gap: 0.25rem !important; }
  .gap-lg-2 {
    gap: 0.5rem !important; }
  .gap-lg-3 {
    gap: 1rem !important; }
  .gap-lg-4 {
    gap: 1.5rem !important; }
  .gap-lg-5 {
    gap: 3rem !important; }
  .row-gap-lg-0 {
    row-gap: 0 !important; }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important; }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important; }
  .row-gap-lg-3 {
    row-gap: 1rem !important; }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important; }
  .row-gap-lg-5 {
    row-gap: 3rem !important; }
  .column-gap-lg-0 {
    column-gap: 0 !important; }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important; }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important; }
  .column-gap-lg-3 {
    column-gap: 1rem !important; }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important; }
  .column-gap-lg-5 {
    column-gap: 3rem !important; }
  .text-lg-start {
    text-align: left !important; }
  .text-lg-end {
    text-align: right !important; }
  .text-lg-center {
    text-align: center !important; } }

@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important; }
  .float-xl-end {
    float: right !important; }
  .float-xl-none {
    float: none !important; }
  .object-fit-xl-contain {
    object-fit: contain !important; }
  .object-fit-xl-cover {
    object-fit: cover !important; }
  .object-fit-xl-fill {
    object-fit: fill !important; }
  .object-fit-xl-scale {
    object-fit: scale-down !important; }
  .object-fit-xl-none {
    object-fit: none !important; }
  .d-xl-inline {
    display: inline !important; }
  .d-xl-inline-block {
    display: inline-block !important; }
  .d-xl-block {
    display: block !important; }
  .d-xl-grid {
    display: grid !important; }
  .d-xl-inline-grid {
    display: inline-grid !important; }
  .d-xl-table {
    display: table !important; }
  .d-xl-table-row {
    display: table-row !important; }
  .d-xl-table-cell {
    display: table-cell !important; }
  .d-xl-flex {
    display: flex !important; }
  .d-xl-inline-flex {
    display: inline-flex !important; }
  .d-xl-none {
    display: none !important; }
  .flex-xl-fill {
    flex: 1 1 auto !important; }
  .flex-xl-row {
    flex-direction: row !important; }
  .flex-xl-column {
    flex-direction: column !important; }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-xl-grow-0 {
    flex-grow: 0 !important; }
  .flex-xl-grow-1 {
    flex-grow: 1 !important; }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-xl-wrap {
    flex-wrap: wrap !important; }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important; }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-xl-start {
    justify-content: flex-start !important; }
  .justify-content-xl-end {
    justify-content: flex-end !important; }
  .justify-content-xl-center {
    justify-content: center !important; }
  .justify-content-xl-between {
    justify-content: space-between !important; }
  .justify-content-xl-around {
    justify-content: space-around !important; }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important; }
  .align-items-xl-start {
    align-items: flex-start !important; }
  .align-items-xl-end {
    align-items: flex-end !important; }
  .align-items-xl-center {
    align-items: center !important; }
  .align-items-xl-baseline {
    align-items: baseline !important; }
  .align-items-xl-stretch {
    align-items: stretch !important; }
  .align-content-xl-start {
    align-content: flex-start !important; }
  .align-content-xl-end {
    align-content: flex-end !important; }
  .align-content-xl-center {
    align-content: center !important; }
  .align-content-xl-between {
    align-content: space-between !important; }
  .align-content-xl-around {
    align-content: space-around !important; }
  .align-content-xl-stretch {
    align-content: stretch !important; }
  .align-self-xl-auto {
    align-self: auto !important; }
  .align-self-xl-start {
    align-self: flex-start !important; }
  .align-self-xl-end {
    align-self: flex-end !important; }
  .align-self-xl-center {
    align-self: center !important; }
  .align-self-xl-baseline {
    align-self: baseline !important; }
  .align-self-xl-stretch {
    align-self: stretch !important; }
  .order-xl-first {
    order: -1 !important; }
  .order-xl-0 {
    order: 0 !important; }
  .order-xl-1 {
    order: 1 !important; }
  .order-xl-2 {
    order: 2 !important; }
  .order-xl-3 {
    order: 3 !important; }
  .order-xl-4 {
    order: 4 !important; }
  .order-xl-5 {
    order: 5 !important; }
  .order-xl-last {
    order: 6 !important; }
  .m-xl-0 {
    margin: 0 !important; }
  .m-xl-1 {
    margin: 0.25rem !important; }
  .m-xl-2 {
    margin: 0.5rem !important; }
  .m-xl-3 {
    margin: 1rem !important; }
  .m-xl-4 {
    margin: 1.5rem !important; }
  .m-xl-5 {
    margin: 3rem !important; }
  .m-xl-auto {
    margin: auto !important; }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-xl-0 {
    margin-top: 0 !important; }
  .mt-xl-1 {
    margin-top: 0.25rem !important; }
  .mt-xl-2 {
    margin-top: 0.5rem !important; }
  .mt-xl-3 {
    margin-top: 1rem !important; }
  .mt-xl-4 {
    margin-top: 1.5rem !important; }
  .mt-xl-5 {
    margin-top: 3rem !important; }
  .mt-xl-auto {
    margin-top: auto !important; }
  .me-xl-0 {
    margin-right: 0 !important; }
  .me-xl-1 {
    margin-right: 0.25rem !important; }
  .me-xl-2 {
    margin-right: 0.5rem !important; }
  .me-xl-3 {
    margin-right: 1rem !important; }
  .me-xl-4 {
    margin-right: 1.5rem !important; }
  .me-xl-5 {
    margin-right: 3rem !important; }
  .me-xl-auto {
    margin-right: auto !important; }
  .mb-xl-0 {
    margin-bottom: 0 !important; }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important; }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important; }
  .mb-xl-3 {
    margin-bottom: 1rem !important; }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important; }
  .mb-xl-5 {
    margin-bottom: 3rem !important; }
  .mb-xl-auto {
    margin-bottom: auto !important; }
  .ms-xl-0 {
    margin-left: 0 !important; }
  .ms-xl-1 {
    margin-left: 0.25rem !important; }
  .ms-xl-2 {
    margin-left: 0.5rem !important; }
  .ms-xl-3 {
    margin-left: 1rem !important; }
  .ms-xl-4 {
    margin-left: 1.5rem !important; }
  .ms-xl-5 {
    margin-left: 3rem !important; }
  .ms-xl-auto {
    margin-left: auto !important; }
  .p-xl-0 {
    padding: 0 !important; }
  .p-xl-1 {
    padding: 0.25rem !important; }
  .p-xl-2 {
    padding: 0.5rem !important; }
  .p-xl-3 {
    padding: 1rem !important; }
  .p-xl-4 {
    padding: 1.5rem !important; }
  .p-xl-5 {
    padding: 3rem !important; }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-xl-0 {
    padding-top: 0 !important; }
  .pt-xl-1 {
    padding-top: 0.25rem !important; }
  .pt-xl-2 {
    padding-top: 0.5rem !important; }
  .pt-xl-3 {
    padding-top: 1rem !important; }
  .pt-xl-4 {
    padding-top: 1.5rem !important; }
  .pt-xl-5 {
    padding-top: 3rem !important; }
  .pe-xl-0 {
    padding-right: 0 !important; }
  .pe-xl-1 {
    padding-right: 0.25rem !important; }
  .pe-xl-2 {
    padding-right: 0.5rem !important; }
  .pe-xl-3 {
    padding-right: 1rem !important; }
  .pe-xl-4 {
    padding-right: 1.5rem !important; }
  .pe-xl-5 {
    padding-right: 3rem !important; }
  .pb-xl-0 {
    padding-bottom: 0 !important; }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important; }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important; }
  .pb-xl-3 {
    padding-bottom: 1rem !important; }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important; }
  .pb-xl-5 {
    padding-bottom: 3rem !important; }
  .ps-xl-0 {
    padding-left: 0 !important; }
  .ps-xl-1 {
    padding-left: 0.25rem !important; }
  .ps-xl-2 {
    padding-left: 0.5rem !important; }
  .ps-xl-3 {
    padding-left: 1rem !important; }
  .ps-xl-4 {
    padding-left: 1.5rem !important; }
  .ps-xl-5 {
    padding-left: 3rem !important; }
  .gap-xl-0 {
    gap: 0 !important; }
  .gap-xl-1 {
    gap: 0.25rem !important; }
  .gap-xl-2 {
    gap: 0.5rem !important; }
  .gap-xl-3 {
    gap: 1rem !important; }
  .gap-xl-4 {
    gap: 1.5rem !important; }
  .gap-xl-5 {
    gap: 3rem !important; }
  .row-gap-xl-0 {
    row-gap: 0 !important; }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important; }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important; }
  .row-gap-xl-3 {
    row-gap: 1rem !important; }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important; }
  .row-gap-xl-5 {
    row-gap: 3rem !important; }
  .column-gap-xl-0 {
    column-gap: 0 !important; }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important; }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important; }
  .column-gap-xl-3 {
    column-gap: 1rem !important; }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important; }
  .column-gap-xl-5 {
    column-gap: 3rem !important; }
  .text-xl-start {
    text-align: left !important; }
  .text-xl-end {
    text-align: right !important; }
  .text-xl-center {
    text-align: center !important; } }

@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important; }
  .float-xxl-end {
    float: right !important; }
  .float-xxl-none {
    float: none !important; }
  .object-fit-xxl-contain {
    object-fit: contain !important; }
  .object-fit-xxl-cover {
    object-fit: cover !important; }
  .object-fit-xxl-fill {
    object-fit: fill !important; }
  .object-fit-xxl-scale {
    object-fit: scale-down !important; }
  .object-fit-xxl-none {
    object-fit: none !important; }
  .d-xxl-inline {
    display: inline !important; }
  .d-xxl-inline-block {
    display: inline-block !important; }
  .d-xxl-block {
    display: block !important; }
  .d-xxl-grid {
    display: grid !important; }
  .d-xxl-inline-grid {
    display: inline-grid !important; }
  .d-xxl-table {
    display: table !important; }
  .d-xxl-table-row {
    display: table-row !important; }
  .d-xxl-table-cell {
    display: table-cell !important; }
  .d-xxl-flex {
    display: flex !important; }
  .d-xxl-inline-flex {
    display: inline-flex !important; }
  .d-xxl-none {
    display: none !important; }
  .flex-xxl-fill {
    flex: 1 1 auto !important; }
  .flex-xxl-row {
    flex-direction: row !important; }
  .flex-xxl-column {
    flex-direction: column !important; }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important; }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important; }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-xxl-wrap {
    flex-wrap: wrap !important; }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important; }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-xxl-start {
    justify-content: flex-start !important; }
  .justify-content-xxl-end {
    justify-content: flex-end !important; }
  .justify-content-xxl-center {
    justify-content: center !important; }
  .justify-content-xxl-between {
    justify-content: space-between !important; }
  .justify-content-xxl-around {
    justify-content: space-around !important; }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important; }
  .align-items-xxl-start {
    align-items: flex-start !important; }
  .align-items-xxl-end {
    align-items: flex-end !important; }
  .align-items-xxl-center {
    align-items: center !important; }
  .align-items-xxl-baseline {
    align-items: baseline !important; }
  .align-items-xxl-stretch {
    align-items: stretch !important; }
  .align-content-xxl-start {
    align-content: flex-start !important; }
  .align-content-xxl-end {
    align-content: flex-end !important; }
  .align-content-xxl-center {
    align-content: center !important; }
  .align-content-xxl-between {
    align-content: space-between !important; }
  .align-content-xxl-around {
    align-content: space-around !important; }
  .align-content-xxl-stretch {
    align-content: stretch !important; }
  .align-self-xxl-auto {
    align-self: auto !important; }
  .align-self-xxl-start {
    align-self: flex-start !important; }
  .align-self-xxl-end {
    align-self: flex-end !important; }
  .align-self-xxl-center {
    align-self: center !important; }
  .align-self-xxl-baseline {
    align-self: baseline !important; }
  .align-self-xxl-stretch {
    align-self: stretch !important; }
  .order-xxl-first {
    order: -1 !important; }
  .order-xxl-0 {
    order: 0 !important; }
  .order-xxl-1 {
    order: 1 !important; }
  .order-xxl-2 {
    order: 2 !important; }
  .order-xxl-3 {
    order: 3 !important; }
  .order-xxl-4 {
    order: 4 !important; }
  .order-xxl-5 {
    order: 5 !important; }
  .order-xxl-last {
    order: 6 !important; }
  .m-xxl-0 {
    margin: 0 !important; }
  .m-xxl-1 {
    margin: 0.25rem !important; }
  .m-xxl-2 {
    margin: 0.5rem !important; }
  .m-xxl-3 {
    margin: 1rem !important; }
  .m-xxl-4 {
    margin: 1.5rem !important; }
  .m-xxl-5 {
    margin: 3rem !important; }
  .m-xxl-auto {
    margin: auto !important; }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-xxl-0 {
    margin-top: 0 !important; }
  .mt-xxl-1 {
    margin-top: 0.25rem !important; }
  .mt-xxl-2 {
    margin-top: 0.5rem !important; }
  .mt-xxl-3 {
    margin-top: 1rem !important; }
  .mt-xxl-4 {
    margin-top: 1.5rem !important; }
  .mt-xxl-5 {
    margin-top: 3rem !important; }
  .mt-xxl-auto {
    margin-top: auto !important; }
  .me-xxl-0 {
    margin-right: 0 !important; }
  .me-xxl-1 {
    margin-right: 0.25rem !important; }
  .me-xxl-2 {
    margin-right: 0.5rem !important; }
  .me-xxl-3 {
    margin-right: 1rem !important; }
  .me-xxl-4 {
    margin-right: 1.5rem !important; }
  .me-xxl-5 {
    margin-right: 3rem !important; }
  .me-xxl-auto {
    margin-right: auto !important; }
  .mb-xxl-0 {
    margin-bottom: 0 !important; }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important; }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important; }
  .mb-xxl-3 {
    margin-bottom: 1rem !important; }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important; }
  .mb-xxl-5 {
    margin-bottom: 3rem !important; }
  .mb-xxl-auto {
    margin-bottom: auto !important; }
  .ms-xxl-0 {
    margin-left: 0 !important; }
  .ms-xxl-1 {
    margin-left: 0.25rem !important; }
  .ms-xxl-2 {
    margin-left: 0.5rem !important; }
  .ms-xxl-3 {
    margin-left: 1rem !important; }
  .ms-xxl-4 {
    margin-left: 1.5rem !important; }
  .ms-xxl-5 {
    margin-left: 3rem !important; }
  .ms-xxl-auto {
    margin-left: auto !important; }
  .p-xxl-0 {
    padding: 0 !important; }
  .p-xxl-1 {
    padding: 0.25rem !important; }
  .p-xxl-2 {
    padding: 0.5rem !important; }
  .p-xxl-3 {
    padding: 1rem !important; }
  .p-xxl-4 {
    padding: 1.5rem !important; }
  .p-xxl-5 {
    padding: 3rem !important; }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-xxl-0 {
    padding-top: 0 !important; }
  .pt-xxl-1 {
    padding-top: 0.25rem !important; }
  .pt-xxl-2 {
    padding-top: 0.5rem !important; }
  .pt-xxl-3 {
    padding-top: 1rem !important; }
  .pt-xxl-4 {
    padding-top: 1.5rem !important; }
  .pt-xxl-5 {
    padding-top: 3rem !important; }
  .pe-xxl-0 {
    padding-right: 0 !important; }
  .pe-xxl-1 {
    padding-right: 0.25rem !important; }
  .pe-xxl-2 {
    padding-right: 0.5rem !important; }
  .pe-xxl-3 {
    padding-right: 1rem !important; }
  .pe-xxl-4 {
    padding-right: 1.5rem !important; }
  .pe-xxl-5 {
    padding-right: 3rem !important; }
  .pb-xxl-0 {
    padding-bottom: 0 !important; }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important; }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important; }
  .pb-xxl-3 {
    padding-bottom: 1rem !important; }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important; }
  .pb-xxl-5 {
    padding-bottom: 3rem !important; }
  .ps-xxl-0 {
    padding-left: 0 !important; }
  .ps-xxl-1 {
    padding-left: 0.25rem !important; }
  .ps-xxl-2 {
    padding-left: 0.5rem !important; }
  .ps-xxl-3 {
    padding-left: 1rem !important; }
  .ps-xxl-4 {
    padding-left: 1.5rem !important; }
  .ps-xxl-5 {
    padding-left: 3rem !important; }
  .gap-xxl-0 {
    gap: 0 !important; }
  .gap-xxl-1 {
    gap: 0.25rem !important; }
  .gap-xxl-2 {
    gap: 0.5rem !important; }
  .gap-xxl-3 {
    gap: 1rem !important; }
  .gap-xxl-4 {
    gap: 1.5rem !important; }
  .gap-xxl-5 {
    gap: 3rem !important; }
  .row-gap-xxl-0 {
    row-gap: 0 !important; }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important; }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important; }
  .row-gap-xxl-3 {
    row-gap: 1rem !important; }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important; }
  .row-gap-xxl-5 {
    row-gap: 3rem !important; }
  .column-gap-xxl-0 {
    column-gap: 0 !important; }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important; }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important; }
  .column-gap-xxl-3 {
    column-gap: 1rem !important; }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important; }
  .column-gap-xxl-5 {
    column-gap: 3rem !important; }
  .text-xxl-start {
    text-align: left !important; }
  .text-xxl-end {
    text-align: right !important; }
  .text-xxl-center {
    text-align: center !important; } }

@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important; }
  .fs-2 {
    font-size: 2rem !important; }
  .fs-3 {
    font-size: 1.75rem !important; }
  .fs-4 {
    font-size: 1.5rem !important; } }

@media print {
  .d-print-inline {
    display: inline !important; }
  .d-print-inline-block {
    display: inline-block !important; }
  .d-print-block {
    display: block !important; }
  .d-print-grid {
    display: grid !important; }
  .d-print-inline-grid {
    display: inline-grid !important; }
  .d-print-table {
    display: table !important; }
  .d-print-table-row {
    display: table-row !important; }
  .d-print-table-cell {
    display: table-cell !important; }
  .d-print-flex {
    display: flex !important; }
  .d-print-inline-flex {
    display: inline-flex !important; }
  .d-print-none {
    display: none !important; } }

body {
  font-size: 14px;
  font-weight: 400; }

.mt-8px {
  margin-top: 8px; }

.mt-15px {
  margin-top: 15px; }

@media (max-width: 767px) {
  .mt-sm-8px {
    margin-top: 8px; } }

@media (min-width: 768px) and (max-width: 1013px) {
  .mt-md-8px {
    margin-top: 8px; } }

@media (min-width: 1014px) {
  .mt-lg-8px {
    margin-top: 8px; } }

.pt-8px {
  padding-top: 8px; }

.pt-15px {
  padding-top: 15px; }

@font-face {
  font-family: Lexend-SemiBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_19___}); }

@font-face {
  font-family: Lexend-Light;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___}); }

@font-face {
  font-family: Lexend-Regular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_21___}); }

@font-face {
  font-family: Lexend-Medium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___}); }

@font-face {
  font-family: Inter-Medium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_23___}); }

.scan-container {
  height: 100vh;
  width: 100vw;
  margin: 0px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) no-repeat center center;
  background-size: cover;
  background-attachment: fixed; }
  .scan-container .scan-header {
    display: flex;
    flex-direction: column;
    text-align: center;
    height: 100px;
    color: #fff; }
    .scan-container .scan-header__title {
      margin-top: 20px;
      font-weight: 700;
      font-family: "Lexend-SemiBold"; }
    .scan-container .scan-header__sub {
      font-family: "Lexend-Regular";
      font-weight: 400; }
  .scan-container .scan-holder {
    display: flex;
    justify-content: center;
    margin-top: 80px; }
    .scan-container .scan-holder__frame {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 280px;
      height: 280px;
      background: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
      background-repeat: no-repeat;
      background-size: contain; }
    .scan-container .scan-holder__reader {
      width: 220px;
      height: 220px; }

.empty-container {
  height: 100vh;
  background-color: #22493b;
  overflow: hidden; }
  .empty-container .empty-header {
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 1rem; }
    .empty-container .empty-header h5, .empty-container .empty-header .h5 {
      font-weight: 400;
      font-family: "Lexend-Regular"; }
    .empty-container .empty-header__underline {
      background-color: #adb5bd;
      width: 5rem;
      height: 2px;
      margin: auto;
      display: block;
      margin-top: 10px; }
  .empty-container .empty-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 2rem;
    font-size: 16px;
    color: #fff;
    font-family: "Lexend-Light";
    line-height: 24px; }
    .empty-container .empty-content .empty-icon {
      z-index: 9; }
    .empty-container .empty-content__shape {
      position: absolute;
      background-image: linear-gradient(#006ba1, #e8f0f5, #a7c2bb);
      opacity: 0.3;
      border-radius: 50%;
      left: 35vw; }
  .empty-container .empty-footer {
    display: flex;
    justify-content: center; }
    .empty-container .empty-footer__btn {
      position: absolute;
      bottom: 3rem;
      width: 90vw;
      height: 4rem;
      color: #fff;
      background-color: transparent;
      border: 1px solid #fff;
      border-radius: 8px;
      font-family: "Lexend-Regular"; }

.new-container {
  width: 100%;
  height: 100%; }
  .new-container .news-header {
    margin-bottom: 20px; }
  .new-container .news-content {
    padding: 0 24px 5px 24px; }
    .new-container .news-content__list {
      width: 100%;
      height: 177px;
      border-radius: 8px;
      background-color: #f8f9fa;
      border: 1px solid #ced4da;
      box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
      margin-bottom: 1.5rem;
      padding: 8px;
      color: #22493b; }
      .new-container .news-content__list .news-image {
        width: 100%;
        height: 108px;
        margin-bottom: 8px; }
      .new-container .news-content__list .news-line {
        margin: 0 -8px 4px -8px;
        background-color: #6c757d; }
      .new-container .news-content__list .news-title {
        font-family: Lexend-SemiBold;
        font-size: 12px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical; }
      .new-container .news-content__list .news-name {
        margin-top: 0.2rem;
        font-size: 11px;
        font-family: Lexend-Light;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical; }

.address-container {
  height: 100vh;
  width: 100vw;
  margin: 0px; }
  .address-container .address-content {
    padding: 1rem; }
    .address-container .address-content .address-card {
      width: 100%;
      min-height: 100px;
      border-bottom: 1px solid #ced4da;
      margin-bottom: 1rem; }
      .address-container .address-content .address-card .address-item {
        display: flex; }
        .address-container .address-content .address-card .address-item__content {
          margin-left: 0.8rem;
          display: flex;
          flex-direction: column;
          color: #22493b;
          font-size: 16px; }
          .address-container .address-content .address-card .address-item__content .address-location {
            font-family: Lexend-Medium;
            font-weight: 700; }
          .address-container .address-content .address-card .address-item__content .address-street {
            margin-top: 0.5rem;
            font-family: Lexend-Light;
            line-height: 24px; }
        .address-container .address-content .address-card .address-item__left-icon {
          padding-right: 0.2rem; }
        .address-container .address-content .address-card .address-item__right-icon {
          margin-left: auto; }

.moreInfo-container {
  height: 100vh;
  width: 100vw;
  background-color: #fff;
  color: #000000; }
  .moreInfo-container .content {
    padding-left: 45px;
    padding-right: 25px; }
  .moreInfo-container .moreInfo-paragraph {
    font-size: 16;
    font-family: "Lexend-Regular";
    color: #22493b; }

.certificates-container .certificates-content {
  padding: 1rem;
  display: grid;
  grid-template-columns: auto auto;
  justify-items: center;
  grid-gap: 1rem;
  row-gap: 1rem; }
  .certificates-container .certificates-content .certificates-item {
    border-radius: 1rem;
    background-color: white;
    width: 178px;
    height: auto;
    box-shadow: rgba(34, 73, 59, 0.5) 0px 3px 8px; }
    .certificates-container .certificates-content .certificates-item__image {
      height: 131px;
      width: 131px;
      object-fit: fill; }
    .certificates-container .certificates-content .certificates-item__name {
      font-weight: 600;
      font-family: "Lexend-SemiBold";
      color: #22493b;
      font-size: 12px;
      text-align: left; }
      @media (max-width: 360px) {
        .certificates-container .certificates-content .certificates-item__name {
          font-size: 10px;
          margin-bottom: 1px; } }
      @media (max-width: 280px) {
        .certificates-container .certificates-content .certificates-item__name {
          font-size: 8px;
          margin-bottom: 2px; } }
    .certificates-container .certificates-content .certificates-item__year {
      font-weight: 300;
      font-family: "Lexend-Light";
      font-size: 10px;
      color: #22493b;
      text-align: left; }
      @media (max-width: 360px) {
        .certificates-container .certificates-content .certificates-item__year {
          font-size: 8px; } }
      @media (max-width: 280px) {
        .certificates-container .certificates-content .certificates-item__year {
          font-size: 6px; } }

.certificatesDetail-container {
  height: 100vh;
  width: 100vw;
  background-color: #fff;
  color: #000000;
  margin-bottom: 163px; }
  .certificatesDetail-container .certificatesDetail-content {
    text-align: center;
    display: block; }
    .certificatesDetail-container .certificatesDetail-content .certificatesDetail-text .certificatesDetail-txtTitle {
      font-weight: 600;
      color: #22493b;
      font-family: "Lexend-SemiBold";
      font-size: 12px;
      margin-bottom: -4px; }
    .certificatesDetail-container .certificatesDetail-content .certificatesDetail-text .certificatesDetail-txtYear {
      font-weight: 300;
      font-family: "Lexend-Light";
      font-size: 10px;
      color: #22493b; }
    .certificatesDetail-container .certificatesDetail-content .certificatesDetail-paper .certificatesDetail-img {
      padding: 0 24px;
      max-width: 100%;
      height: auto; }
    .certificatesDetail-container .certificatesDetail-content .certificatesDetail-Download {
      padding-top: 10px; }
      .certificatesDetail-container .certificatesDetail-content .certificatesDetail-Download .certificatesDetail-btnDownload {
        border: 1px solid #22493b;
        width: 35%;
        border-radius: 8px;
        background-color: #fff;
        color: #22493b;
        font-family: "Lexend-Regular";
        font-size: 14;
        padding: 0 16px;
        height: 40px; }

.admin-header {
  padding: 0;
  margin: 0;
  width: 100%;
  min-height: 100vh;
  background-color: #e2f1ef;
  box-sizing: border-box; }

.sidebar {
  width: 16%;
  min-height: 100vh;
  background-color: #22493b;
  float: left;
  position: fixed;
  z-index: 1;
  overflow-x: hidden; }
  .sidebar__header {
    display: flex;
    flex-direction: column;
    align-items: center; }
  .sidebar__avt {
    margin-top: 16px;
    width: 40px;
    height: 40px;
    background-color: #fff;
    border-radius: 50px; }
  .sidebar__name {
    color: #fff;
    font-family: 'Lexend-Light';
    font-size: 14px;
    margin-top: 8px;
    line-height: 1.2; }

.header {
  padding: 25px 0 25px 17%;
  width: 100%;
  height: 15%; }
  .header__title {
    font-family: 'Lexend-Medium';
    color: #22493b;
    font-size: 32px; }
  .header__sub {
    display: flex;
    height: 2vh;
    align-items: center;
    justify-content: space-between;
    margin-right: 14px; }
  .header__subTitle {
    font-family: 'Lexend-Light';
    color: #22493b;
    font-size: 18px;
    margin-top: 16px;
    height: 2.5rem;
    display: flex;
    align-items: center; }
  .header__right {
    display: flex; }
  .header__search {
    width: 309px;
    height: 40px;
    border: 1px #8ac9bb solid;
    border-radius: 8px;
    display: flex;
    align-items: center;
    margin-right: 16px; }
    .header__search__icon {
      margin: 8px 10px 8px 16px; }
    .header__search__input {
      height: 40px;
      border-radius: 8px;
      border: none;
      outline: none !important;
      background-color: transparent; }
    .header__search__input::placeholder {
      font-family: 'Lexend-Regular';
      color: #3b927d; }
  .header .header-btn {
    border: none;
    border-radius: 8px;
    height: 40px; }
  .header .filter {
    width: 56px;
    height: 40px;
    flex-grow: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 1px 16px;
    border-radius: 8px;
    background-color: #22493b;
    margin-right: 16px; }
  .header .addNew {
    width: 133px;
    height: 40px;
    flex-grow: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 1px 16px;
    border-radius: 8px;
    background-color: #ed6c02;
    color: white;
    font-family: 'Lexend-Regular'; }

.children {
  padding: 25px 1% 25px 17%;
  width: 100%; }

.btn-primary {
  background-color: #22493b;
  border: 0;
  color: #ffffff;
  font-family: Lexend-Regular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  padding: 9.5px; }
  .btn-primary:hover {
    background-color: #22493b;
    opacity: 0.9; }
  .btn-primary:active {
    background-color: #22493b !important;
    opacity: 1; }
  .btn-primary:disabled {
    background-color: #c9cdd2 !important;
    color: #e8ebed; }

.btn-text {
  color: #0288d1;
  flex-grow: 0;
  font-family: Lexend-Regular;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  padding: 0;
  margin: 0;
  border: 0;
  outline: none; }

.signin-container {
  width: 100%;
  min-height: 100vh;
  object-fit: contain;
  background-repeat: no-repeat;
  background-size: cover; }
  .signin-container .signin-content {
    max-width: 728px;
    padding: 25px 119px 57px;
    object-fit: contain;
    border-radius: 24px;
    backdrop-filter: blur(15px);
    background-color: rgba(255, 255, 255, 0.1);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column; }
    .signin-container .signin-content > h2, .signin-container .signin-content > .h2 {
      color: #22493b;
      font-family: Lexend-Regular;
      margin-bottom: 16px; }

.validation-input .error-message {
  font-family: Lexend-Regular;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #ff0000;
  padding-left: 16px; }

.validation-input .input-atom {
  height: 62px;
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  gap: 4px;
  padding: 8px 8px 8px 16px;
  border-radius: 4px;
  border: solid 1px #e8ebed; }
  .validation-input .input-atom label {
    font-family: Lexend-Regular;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #454c53; }
  .validation-input .input-atom input {
    background-color: transparent;
    width: 100%;
    border: 0;
    padding: 0; }
    .validation-input .input-atom input:focus {
      outline: none;
      border: 0; }
    .validation-input .input-atom input:focus ~ label {
      color: #3b927d; }
  .validation-input .input-atom input[type='password']::-ms-reveal,
  .validation-input .input-atom input[type='password']::-ms-clear {
    display: none; }
  .validation-input .input-atom button {
    background-color: transparent;
    outline: none;
    border: 0;
    padding: 0; }
  .validation-input .input-atom .placeholder-group {
    width: 100%;
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-start;
    justify-content: center;
    align-items: flex-start;
    padding: 0; }
  .validation-input .input-atom > input::placeholder {
    flex-grow: 1;
    font-family: Lexend-Regular;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #9ea4aa; }

.checkbox-group {
  display: flex;
  flex-direction: row-reverse; }
  .checkbox-group :nth-child(1) {
    margin-left: 8px;
    color: #9ea4aa; }
  .checkbox-group :hover {
    cursor: pointer; }
  .checkbox-group label {
    font-family: Lexend-Regular;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #454c53; }

.error-message {
  color: #ff0000 !important; }

.form-body {
  width: 490px;
  height: auto;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 24px;
  padding: 32px;
  border-radius: 24px;
  background-color: #fff; }
  .form-body .place-center {
    align-self: stretch;
    flex-grow: 0;
    font-family: Lexend-Light;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    color: #9ea4aa;
    margin: 0; }
  .form-body .frame {
    align-self: stretch;
    flex-grow: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0; }

.inner-frame {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  padding: 0;
  font-family: Lexend-Light;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #ffffff; }
  .inner-frame img {
    width: 194px;
    height: 194px;
    flex-grow: 0;
    object-fit: contain; }
  .inner-frame span {
    color: #edd720; }

.small-padding {
  padding: 26px 33px 146px 34px !important; }

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0; }

.verified-code-input {
  width: 74px !important;
  height: 74px;
  border-radius: 12px;
  border: 1px solid #22493b;
  font-family: Lexend-Light;
  font-size: 24px;
  font-weight: 300;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #22493b; }

.table-all {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 16px; }

.table-atom {
  background-color: #ffffff;
  border-radius: 12px;
  border-spacing: 0;
  border-collapse: separate;
  border: 0px;
  overflow: hidden;
  width: 100%;
  font-family: Lexend-Light;
  filter: drop-shadow(4px 4px 12px rgba(34, 73, 59, 0.5)); }
  .table-atom > thead {
    background-color: #b7ded6;
    color: #22493b; }
  .table-atom td {
    padding: 8px; }
  .table-atom tbody td:not(:last-child) {
    border-right: 1px solid #e2f1ef; }
  .table-atom .table-header {
    font-family: Lexend-Medium;
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: #22493b;
    white-space: nowrap; }

.pagination-footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%; }
  .pagination-footer .page-item-control {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 11px;
    padding: 0; }
    .pagination-footer .page-item-control .rowcount-mess {
      color: #22493b;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: center; }
  .pagination-footer .pagination {
    display: flex;
    width: 100%;
    justify-content: flex-end;
    align-items: center; }
    .pagination-footer .pagination .page-links {
      text-decoration: none;
      color: #22493b; }
    .pagination-footer .pagination .page-items,
    .pagination-footer .pagination .next,
    .pagination-footer .pagination .previous {
      margin-left: 12px;
      min-width: 36px;
      height: 36px;
      border: 1px solid transparent;
      border-radius: 4px;
      color: red;
      display: inline-flex;
      align-items: center;
      justify-content: center; }
      .pagination-footer .pagination .page-items:hover,
      .pagination-footer .pagination .next:hover,
      .pagination-footer .pagination .previous:hover {
        cursor: pointer; }
    .pagination-footer .pagination .selected {
      width: 40px;
      height: 40px;
      flex-grow: 0;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 8px;
      padding: 8px 16px;
      border-radius: 4px;
      border: solid 1px transparent;
      background-color: #22493b; }
      .pagination-footer .pagination .selected > .page-links {
        color: #ffffff; }
    .pagination-footer .pagination .previous *,
    .pagination-footer .pagination .next * {
      fill: #22493b; }
    .pagination-footer .pagination .disabled * {
      fill: #b7ded6 !important; }

.justify-content-evenlys {
  display: flex;
  justify-content: space-evenly; }

ul,
li {
  margin: 0;
  padding: 0; }

button {
  background-color: transparent;
  border: 0px; }

select {
  width: 58px;
  height: 40px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  border-radius: 4px;
  border: solid 1px #3b927d;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-repeat: no-repeat;
  background-position: right 0.5rem top 50%;
  font-size: 16px;
  color: #22493b;
  background-color: transparent; }

.fit-content {
  width: 0;
  min-width: fit-content; }

.button-group {
  display: flex; }

.btn-link {
  text-decoration: none;
  height: 24px;
  flex-grow: 1;
  font-family: Lexend-Light;
  font-size: 16px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #0288d1; }

.chip-atom {
  max-width: 100%;
  height: 24px;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 8px;
  border-radius: 8px;
  white-space: nowrap;
  min-width: min-content; }
  .chip-atom.blue {
    background-color: #cce7f6;
    color: #0288d1; }
  .chip-atom.green {
    background-color: #d5e5d6;
    color: #2e7d32; }
  .chip-atom.hidden {
    background-color: #e8ebed;
    color: #72787f; }

.create-product .create-product-header {
  display: flex;
  justify-content: space-between;
  background-color: #e2f1ef;
  border-radius: 10px 10px 0 0; }
  .create-product .create-product-header .create-product-txtHeader {
    font-size: 16px;
    font-weight: 500;
    color: #22493b; }

.create-product .create-product-body .create-product-txtGeneralInfo {
  font-size: 14px;
  font-weight: 500;
  font-family: Lexend-Regular;
  color: #22493b;
  margin-bottom: 16px; }

.create-product .create-product-body .create-product-1stInput,
.create-product .create-product-body .create-product-2ndInput {
  display: flex; }

.create-product .create-product-body .create-product-2ndInput {
  margin-top: 16px; }

.create-product .txt-detail-info {
  font-size: 14px;
  font-weight: 500;
  font-family: Lexend-Regular;
  color: #22493b;
  margin: 24px 0 16px 0; }

.create-product .detail-info {
  display: flex;
  justify-content: space-between; }

.create-product .change-units {
  font-size: 14px;
  font-weight: 500;
  font-family: Lexend-Regular;
  color: #9ea4aa;
  height: 18px;
  margin-left: 32%;
  margin-bottom: -10px; }

.product-input {
  height: 62px;
  width: 30%;
  padding: 8px 8px 8px 16px;
  border-radius: 4px;
  border: solid 1px #e8ebed; }
  .product-input .attachment {
    display: flex;
    align-items: center; }
  .product-input .custom-upload-label {
    font-size: 14px;
    cursor: pointer; }
  .product-input .custom-datePicker {
    color: #9ea4aa; }
  .product-input .placeholder-text {
    color: #9ea4aa;
    font-size: 14px;
    font-family: Lexend Regular;
    margin-right: 17px;
    margin-top: 5.5px; }
  .product-input .custom-date {
    display: none; }
  .product-input .custom-upload-input {
    display: none; }
  .product-input .change-units {
    margin-left: 0px;
    margin-top: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center; }
    .product-input .change-units .input-units {
      width: 50px; }
  .product-input .units {
    display: none; }
  .product-input .qr {
    height: 21px;
    margin-top: 4px; }
    .product-input .qr .btn-qr {
      width: 208px;
      height: 21px;
      color: #0288d1;
      display: flex;
      justify-content: space-between;
      padding: 0px; }
  .product-input .link {
    display: flex;
    height: 31px;
    margin-top: -5px; }
    .product-input .link .link-options {
      border-width: 0;
      outline: none; }
  .product-input .pick-img {
    display: flex;
    margin-top: 10px; }
    .product-input .pick-img .preview-container {
      display: flex;
      width: fit-content; }
      .product-input .pick-img .preview-container .preview-item {
        position: relative;
        margin-right: 10px;
        width: 56px; }
        .product-input .pick-img .preview-container .preview-item .preview-image {
          width: 56px;
          height: 56px; }
        .product-input .pick-img .preview-container .preview-item .close-btn {
          background-color: #ff0000;
          border-radius: 100px;
          width: 20px;
          height: 20px;
          top: -3px;
          right: -3px;
          position: absolute; }
          .product-input .pick-img .preview-container .preview-item .close-btn .clear-icon {
            top: 2px;
            right: 2px;
            position: absolute; }
    .product-input .pick-img .dropzone-container {
      display: flex; }
      .product-input .pick-img .dropzone-container .dropzone {
        border: 2px dashed #aaa;
        border-radius: 4px;
        cursor: pointer;
        width: 56px;
        height: 56px;
        display: flex;
        justify-content: center;
        align-items: center; }
      .product-input .pick-img .dropzone-container .dropzone.active {
        border-color: #2196f3; }
      .product-input .pick-img .dropzone-container .dropzone p {
        margin: 0;
        font-size: 24px;
        color: #3b927d; }

.product-input > label {
  font-family: Lexend-Regular;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: #3b927d; }

.product-input input {
  background-color: transparent;
  width: 100%;
  border: 0;
  padding: 0; }
  .product-input input:focus {
    outline: none;
    border: 0; }
  .product-input input:focus ~ label {
    color: #3b927d; }

.product-input .lbl-darkGray {
  color: #454c53; }

.product-input .lbl-darkGray0 {
  color: #9ea4aaed; }

.product-input .label {
  padding-left: 2px;
  color: #ff0000; }

.product-name {
  width: 70%;
  margin-left: 16px;
  height: 62px; }

.product-source {
  width: 33.5%;
  margin-left: 16px;
  margin-right: 0;
  height: 62px; }

.product-QR {
  width: 33.5%;
  margin-left: 16px;
  margin-right: 0;
  height: 62px;
  background-color: #f7f8f9; }

.product-detail-info {
  width: 49%;
  height: 100px; }

.product-imgUploading {
  width: 100%;
  height: 110px;
  margin: 16px 16px 16px 0; }

.product-link {
  width: 100%;
  height: 62px; }

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 61px;
  height: 24px;
  margin-left: 20px; }

.toggle-switch .switch {
  color: #ffffff;
  position: absolute;
  cursor: pointer;
  background-color: #ccc;
  border-radius: 25px;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transition: background-color 0.2s ease; }

.toggle-switch .switch::before {
  position: absolute;
  content: "ml";
  width: 32px;
  height: 24px;
  background-color: #3b927d;
  border-radius: 50%;
  transition: transform 0.3s ease;
  padding-left: 5px; }

.toggle-switch .switch::after {
  position: absolute;
  content: "cc";
  transition: transform 0.3s ease;
  margin-left: 40px;
  border-radius: 50%; }

.toggle-switch input[type="checkbox"]:checked + .switch::before {
  transform: translateX(25px);
  padding-left: 10px;
  content: "cc"; }

.toggle-switch input[type="checkbox"]:checked + .switch::after {
  display: none; }

.toggle-switch input[type="checkbox"]:checked + .switch {
  padding-left: 5px; }

.hidden_box {
  min-width: 100px;
  display: flex;
  justify-content: space-around;
  align-items: center; }
  .hidden_box > span > svg > path {
    background-color: #72787f; }

.header-container {
  flex-direction: row;
  align-items: center;
  padding-top: 1.5rem;
  padding-left: 0.5rem; }
  .header-container__title {
    font-family: "Lexend-Regular";
    text-align: center;
    color: white;
    font-size: 20px; }
  .header-container__underline {
    background-color: #adb5bd;
    width: 4rem;
    height: 2px;
    margin: auto;
    display: block;
    margin-top: 0.1rem; }

.header-textGreen {
  color: #22493b; }

.header-underLineGreen {
  background-color: #22493b; }

.footer-container {
  display: flex;
  justify-content: flex-end;
  color: #22493b;
  text-align: center; }
  .footer-container__background {
    background-color: #fff;
    border-top-left-radius: 40px;
    border-top-right-radius: 40px;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 10px 24px;
    position: absolute;
    bottom: 0px;
    width: 100%;
    min-height: 40%; }
  .footer-container__title {
    font-size: 12px;
    font-family: "Lexend-Light";
    margin: 8px 0 4px 0; }
  .footer-container__titleBold {
    font-size: 16px;
    font-family: "Lexend-Medium";
    margin: 8px 0 4px 0; }
  @media only screen and (max-width: 600px) {
    .footer-container {
      margin: 8px 0 4px 0; } }

.modal-wrapper {
  min-width: 727px;
  min-height: 100px;
  border-radius: 0;
  font-family: "Lexend-Regular"; }
  .modal-wrapper .modal-header {
    background-color: #e2f1ef;
    height: 56px;
    padding: 18.5px 16px; }
    .modal-wrapper .modal-header .header-text {
      height: 19px;
      color: #22493b;
      font-family: "Inter-Medium"; }
  .modal-wrapper .modal-children {
    padding: 16px; }
    .modal-wrapper .modal-children .sub-header {
      color: #22493b;
      padding-bottom: 16px; }
    .modal-wrapper .modal-children .input-container-area {
      text-align: left;
      border: #ced4da 1px solid;
      border-radius: 4px;
      width: 100%;
      height: 100px;
      padding: 6px 16px;
      margin-bottom: 16px;
      display: flex;
      flex-direction: column-reverse;
      box-sizing: border-box; }
      .modal-wrapper .modal-children .input-container-area textarea:focus + label {
        color: #3b927d; }
    .modal-wrapper .modal-children .input-container {
      text-align: left;
      border: #ced4da 1px solid;
      border-radius: 4px;
      width: 100%;
      height: 62px;
      padding: 6px 16px;
      margin-bottom: 16px;
      display: flex;
      flex-direction: column-reverse;
      box-sizing: border-box; }
      .modal-wrapper .modal-children .input-container__title {
        height: 18px;
        font-size: 12px;
        line-height: 1.5;
        text-align: left;
        color: #454c53;
        font-family: "Lexend-Regular"; }
        .modal-wrapper .modal-children .input-container__title__green {
          color: #3b927d;
          font-size: 12px; }
      .modal-wrapper .modal-children .input-container__input {
        border: 0;
        height: 24px;
        width: 101%;
        padding: 0;
        outline: none !important; }
      .modal-wrapper .modal-children .input-container input:focus + label {
        color: #3b927d; }
      .modal-wrapper .modal-children .input-container__input::placeholder {
        color: #9ea4aa;
        font-family: "Lexend-Regular"; }
      .modal-wrapper .modal-children .input-container__textarea {
        resize: none;
        border: 0;
        width: 100%;
        padding: 0;
        outline: none !important; }
      .modal-wrapper .modal-children .input-container__textarea::placeholder {
        color: #9ea4aa;
        font-family: "Lexend-Regular"; }
      .modal-wrapper .modal-children .input-container__textarea:focus + .modal-wrapper .modal-children .input-container__title {
        color: #3b927d; }
      .modal-wrapper .modal-children .input-container .link-icon {
        background: url(${___CSS_LOADER_URL_REPLACEMENT_27___}) no-repeat;
        width: 24px;
        height: 24px;
        display: block; }
      .modal-wrapper .modal-children .input-container .date-icon {
        background: url(${___CSS_LOADER_URL_REPLACEMENT_28___}) no-repeat;
        width: 24px;
        height: 24px;
        display: block; }
      .modal-wrapper .modal-children .input-container .link-label {
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between; }
        .modal-wrapper .modal-children .input-container .link-label .silver-text {
          color: #9ea4aa; }
        .modal-wrapper .modal-children .input-container .link-label .blue-text {
          color: #0288d1; }
    .modal-wrapper .modal-children .disable-background {
      background-color: #e8ebed; }
    .modal-wrapper .modal-children .disable-text {
      color: #9ea4aa; }
    .modal-wrapper .modal-children input[type="date"]::-webkit-calendar-picker-indicator {
      opacity: 1;
      display: block;
      background: url(${___CSS_LOADER_URL_REPLACEMENT_28___}) no-repeat;
      width: 24px;
      height: 24px; }
    .modal-wrapper .modal-children .toggle-container {
      display: inline-block;
      position: relative;
      width: 61px;
      height: 24px; }
    .modal-wrapper .modal-children .toggle-switch-s {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: #e8ebed;
      color: #c9cdd2;
      border-radius: 15px;
      cursor: pointer;
      transition: background-color 0.3s;
      display: flex;
      justify-content: space-around;
      align-items: center; }
    .modal-wrapper .modal-children .toggle-handle {
      position: absolute;
      width: 32px;
      height: 22px;
      left: 0;
      background-color: #3b927d;
      border-radius: 100px;
      transition: background-color 0.3s, transform 0.3s; }
    .modal-wrapper .modal-children .toggle-input {
      display: none; }
    .modal-wrapper .modal-children .toggle-input:checked + .toggle-switch-s .toggle-handle {
      background-color: #3b927d;
      transform: translateX(30px); }
    .modal-wrapper .modal-children .toggle-input:checked + .toggle-switch-s .toggle-handle::after {
      content: 'cc';
      color: #fff;
      position: absolute;
      left: 50%;
      transform: translate(-50%, 2%); }
    .modal-wrapper .modal-children .toggle-handle::after {
      content: 'ml';
      color: #fff;
      position: absolute;
      left: 50%;
      transform: translate(-50%, 2%); }
  .modal-wrapper .modal-footer {
    width: 100%;
    min-height: 72px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    border: solid 1px #e2f1ef;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px; }
    .modal-wrapper .modal-footer .modal-button {
      display: flex;
      padding: 16px; }
      .modal-wrapper .modal-footer .modal-button__cancel {
        width: 60px;
        height: 40px;
        flex-grow: 0;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 10px;
        padding: 1px 16px;
        border-radius: 8px;
        color: #22493b; }
      .modal-wrapper .modal-footer .modal-button__submit {
        width: 100px;
        height: 40px;
        flex-grow: 0;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 10px;
        padding: 1px 16px;
        border-radius: 8px;
        background-color: #22493b;
        color: #fff; }

.swal2-container {
  z-index: 10000; }

textarea {
  resize: none; }

.product-container__image {
  display: flex;
  justify-content: center;
  align-items: center; }

.product-container__info {
  display: flex;
  align-items: center; }

.background {
  background-color: #22493b;
  width: 100vw;
  height: 100vh;
  margin: 0;
  min-height: 100%;
  position: relative;
  color: #fff; }

.product-line {
  border: none;
  border-top: 2px dashed #22493b;
  height: 1px;
  width: 95%;
  opacity: 0.8; }

.product-btn-div {
  margin-top: 10px; }

.wrong-btn {
  border-radius: 8px;
  color: #22493b;
  font-weight: 500;
  border: solid 1px #22493b;
  background-color: #fff;
  font-family: "Lexend-Regular"; }

.correct-btn {
  border: none;
  border-radius: 8px;
  background-color: #22493b;
  color: white;
  font-family: "Lexend-Regular"; }

.btn-discover {
  height: 80px;
  width: 300px;
  margin-right: 10px;
  border: none;
  padding: 15px 32px;
  text-align: center;
  display: inline-block;
  font-size: 16px;
  background-color: #22493b;
  border-radius: 8px;
  color: white;
  cursor: pointer; }

.slide-container {
  padding: 5px 25px 0 25px; }

.product-info-container {
  width: 100vw;
  height: 90vh; }

.product-info-title {
  font-size: 20px;
  display: flex;
  justify-content: center;
  font-weight: 700;
  font-family: "Lexend-SemiBold";
  text-align: center; }

.infoTxt {
  font-family: "Lexend-Light"; }

.product-info-right {
  font-family: "Lexend-Medium";
  margin-left: 10;
  flex: 1 1;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: #fff; }

.footer-slide {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  font-size: 11px;
  font-family: "Lexend-Light"; }

.slide-div {
  height: 150px;
  width: 100%;
  display: flex;
  align-content: center; }

.slide-image {
  height: 100%;
  background-size: contain;
  display: block;
  margin-left: auto;
  margin-right: auto; }

.dot {
  width: 36px;
  height: 36px;
  border-radius: 100%;
  background-color: #fff;
  border: 0;
  padding: 0 6px; }
  .dot .dot-icon {
    text-align: center;
    align-self: center;
    margin: 0 auto; }

.required:after {
  content: " *";
  color: #dc3545; }

input::placeholder,
textarea::placeholder {
  font-family: "Lexend-Regular"; }

.product-incorrect-container__subtitle {
  font-family: "Lexend-Light";
  font-size: 12px; }

.card-container {
  text-align: left;
  border: #ced4da 1px solid;
  border-radius: 4px;
  width: 100%;
  height: 60px;
  padding: 6px 16px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column-reverse;
  box-sizing: border-box; }
  .card-container .upload-box {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
    border-radius: 4px;
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center; }
  .card-container__title {
    display: block;
    height: 24px;
    width: 100%;
    color: #000000;
    font-family: "Lexend-Regular"; }
  .card-container__input {
    border: 0;
    height: 24px;
    width: 100%;
    padding: 0;
    outline: none !important; }
  .card-container__input:focus + .card-container__title {
    color: #3b927d; }
  .card-container__textarea {
    resize: none;
    border: 0;
    height: 48px;
    width: 100%;
    padding: 0;
    outline: none !important; }
  .card-container__textarea:focus + .card-container__title {
    color: #3b927d; }
  .card-container__image-preview {
    width: 45px;
    height: 45px;
    border: #72787f 1px solid;
    border-radius: 4px;
    margin-right: 10px;
    box-sizing: border-box;
    object-fit: fill; }
  .card-container .remove-image-btn {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    background-color: #dc3545;
    position: absolute;
    right: 6px;
    top: -4px;
    display: flex; }

.resize-height {
  height: 85px; }

.progress-container {
  margin-top: 5px;
  display: flex;
  justify-content: center;
  align-items: center; }
  .progress-container .progress-bar {
    position: relative;
    overflow: hidden;
    width: 45px;
    height: 5px;
    border-radius: 5px;
    background-color: #486a5f; }

.product-title {
  width: 154px;
  height: 24px;
  flex-grow: 0;
  font-family: Lexend;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #fff; }

input::placeholder,
textarea::placeholder {
  font-family: "Lexend-Regular"; }

.product-otp {
  padding: 35px 16.5px 35px 17px;
  border-radius: 12px;
  border: solid 1px #22493b; }

@media only screen and (max-width: 600px) {
  .image {
    width: 80%; }
  .product-btn {
    height: 50px;
    width: 160px;
    margin-right: 10px;
    text-align: center;
    font-size: 16px;
    line-height: 5px; }
  .product-btn-div {
    position: absolute;
    bottom: 20px;
    width: 100%;
    text-align: center; }
  .btn-discover {
    height: 50px;
    width: 80%;
    border: none;
    text-align: center;
    display: inline-block;
    font-size: 16px;
    background-color: #22493b;
    border-radius: 8px;
    color: white; }
  .product-info-content {
    display: flex;
    padding-bottom: 10px;
    align-items: center; }
    .product-info-content__icon {
      padding-right: 5px; }
    .product-info-content__name {
      width: 130px;
      padding-right: 15px; }
    .product-info-content__value {
      font-weight: 700;
      width: 140px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      /* number of lines to show */
      line-clamp: 2;
      -webkit-box-orient: vertical; }
  .footer-title {
    margin-left: 10px;
    font-family: "Lexend-Light"; }
  .product-name-p {
    font-family: "Lexend-SemiBold";
    font-size: 20px;
    font-weight: 800;
    min-width: 90%; }
  .product-context {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 90%; }
  .product-unit {
    font-size: 14px; }
  .product-name-info {
    font-family: "Lexend-SemiBold";
    font-size: 22px;
    text-align: left; } }

.dashboard-item {
  text-decoration: none;
  font-size: 14px;
  color: #fff;
  display: block;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
  cursor: pointer;
  outline: none;
  font-family: "Lexend-Light";
  line-height: 16.8px;
  padding: 16px 0 16px 16px;
  margin: 16px 0 16px 16px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px; }
  .dashboard-item__header {
    display: flex;
    align-items: center;
    max-width: 90%; }
  .dashboard-item__text {
    font-family: "Lexend-Light"; }
    @media (max-width: 1520px) {
      .dashboard-item__text {
        font-size: 12px; } }
  .dashboard-item .icon-left {
    margin-right: 11px; }
    @media (max-width: 1520px) {
      .dashboard-item .icon-left {
        margin-left: -5px;
        margin-right: 5px; } }
  .dashboard-item .icon-right {
    margin-left: 5%; }
  .dashboard-item.drop {
    border-bottom-left-radius: 0px; }
  .dashboard-item__icon-left {
    margin-left: 9px;
    margin-right: 11px; }
  .dashboard-item.active {
    font-family: "Lexend-Medium";
    background-color: #e2f1ef;
    color: #22493b; }
  .dashboard-item.active-non {
    font-family: "Lexend-Light"; }
  .dashboard-item h6, .dashboard-item .h6 {
    font-size: 14px; }

.spacing-icon {
  width: 24px;
  height: 24px;
  flex-grow: 0;
  margin: 0 11px 0 -7px; }

.dashboard-item:hover {
  color: #486a5f; }

.dropdown-container {
  margin-left: 16px;
  background-color: #e2f1ef;
  display: none; }
  .dropdown-container a {
    color: #22493b;
    margin-top: 0;
    margin-bottom: 0;
    align-items: center; }
  .dropdown-container a:active {
    font-family: "Lexend-Medium"; }
  .dropdown-container .dot-active {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #ed6c02;
    position: absolute;
    right: 40px; }

.dropdown-container:last-of-type {
  border-bottom-left-radius: 20px; }

.bgLoading {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 10;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center; }
  .bgLoading .loader {
    width: 48px;
    height: 48px;
    border: 5px solid #22493b;
    border-bottom-color: #3b927d;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite; }

@keyframes rotation {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }
`, "",{"version":3,"sources":["webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./src/_styles.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/_functions.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/styles/common.scss","webpack://./src/styles/constants.scss","webpack://./src/styles/custom.scss","webpack://./src/pages/Scan/scan.scss","webpack://./src/pages/Empty/empty.scss","webpack://./src/pages/News/news.scss","webpack://./src/pages/Address/address.scss","webpack://./src/pages/MoreInfo/moreInfo.scss","webpack://./src/pages/Certificates/certificates.scss","webpack://./src/pages/CertificatesDetail/certificatesDetail.scss","webpack://./src/pages/Admin/Component/HeaderSidebar/adminpage.scss","webpack://./src/pages/Admin/Component/SignInButton/signInButton.scss","webpack://./src/pages/Admin/Component/SignInForm/signInForm.scss","webpack://./src/pages/Admin/Component/SignInput/signInInput.scss","webpack://./src/pages/Admin/SignIn/Signin.scss","webpack://./src/pages/Admin/Component/Table/Table.scss","webpack://./src/pages/Admin/Component/Badge/Badge.scss","webpack://./src/pages/Admin/Component/CreateProductComp/createProductComp.scss","webpack://./src/pages/Admin/Component/ProductInput/productInput.scss","webpack://./src/pages/Admin/Component/HidenBox/hidenBox.scss","webpack://./src/components/Header/header.scss","webpack://./src/components/Footer/footer.scss","webpack://./src/components/DialogModal/dialog.scss","webpack://./src/pages/Product/product.scss","webpack://./src/components/DashboardItem/dashboardItem.scss","webpack://./src/components/Loading/loading.scss"],"names":[],"mappings":"AACE;;;;ICGE;ACJJ;;EASI,kBAAwB;EAAxB,oBAAwB;EAAxB,oBAAwB;EAAxB,kBAAwB;EAAxB,iBAAwB;EAAxB,oBAAwB;EAAxB,oBAAwB;EAAxB,mBAAwB;EAAxB,kBAAwB;EAAxB,kBAAwB;EAAxB,gBAAwB;EAAxB,gBAAwB;EAAxB,kBAAwB;EAAxB,uBAAwB;EAIxB,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAIlC,qBAAwB;EAAxB,uBAAwB;EAAxB,qBAAwB;EAAxB,kBAAwB;EAAxB,qBAAwB;EAAxB,oBAAwB;EAAxB,mBAAwB;EAAxB,kBAAwB;EAIxB,8BAAgC;EAAhC,iCAAgC;EAAhC,6BAAgC;EAAhC,2BAAgC;EAAhC,6BAAgC;EAAhC,4BAAgC;EAAhC,6BAAgC;EAAhC,yBAAgC;EAIhC,mCAAoD;EAApD,qCAAoD;EAApD,mCAAoD;EAApD,gCAAoD;EAApD,mCAAoD;EAApD,kCAAoD;EAApD,iCAAoD;EAApD,gCAAoD;EAIpD,+BAA4C;EAA5C,iCAA4C;EAA5C,+BAA4C;EAA5C,4BAA4C;EAA5C,+BAA4C;EAA5C,8BAA4C;EAA5C,6BAA4C;EAA5C,4BAA4C;EAI5C,mCAAoD;EAApD,qCAAoD;EAApD,mCAAoD;EAApD,gCAAoD;EAApD,mCAAoD;EAApD,kCAAoD;EAApD,iCAAoD;EAApD,gCAAoD;EAGtD,6BAAiC;EACjC,uBAAiC;EAMjC,qNAA6C;EAC7C,yGAA2C;EAC3C,yFAA+B;EAO/B,gDAA+C;EC2O3C,yBAnE+B;EDtKnC,0BAA+C;EAC/C,0BAA+C;EAK/C,wBAAmC;EACnC,+BAA2C;EAC3C,kBAA6B;EAC7B,+BAAqC;EAErC,yBAA2C;EAC3C,gCAAmD;EAEnD,4CAA6C;EAC7C,oCAAqD;EACrD,0BAAuC;EACvC,oCAA+C;EAE/C,0CAA2C;EAC3C,mCAAmD;EACnD,yBAAqC;EACrC,mCAA6C;EAG7C,2BAAyC;EAEzC,wBAAmC;EACnC,iCAA2C;EAC3C,+BAA6C;EAE7C,8BAA+C;EAC/C,sCAAuD;EAMvD,wBAAmC;EACnC,6BAA6C;EAC7C,0BAAuC;EAGvC,sBAAuC;EACvC,wBAAuC;EACvC,0BAAuC;EACvC,mDAA+D;EAE/D,4BAAyC;EACzC,8BAA+C;EAC/C,6BAA+C;EAC/C,2BAA+C;EAC/C,4BAAiD;EACjD,mDAAiD;EACjD,8BAAmD;EAGnD,kDAAmC;EACnC,2DAAyC;EACzC,oDAAyC;EACzC,2DAA+C;EAI/C,8BAA+C;EAC/C,6BAAmD;EACnD,+CAA+C;EAI/C,8BAA+C;EAC/C,qCAA6D;EAC7D,gCAAmD;EACnD,uCAAiE,EAAA;;ADDnE;ECOI,kBAAkB;EAGlB,wBAAmC;EACnC,kCAA2C;EAC3C,qBAA6B;EAC7B,4BAAqC;EAErC,yBAA2C;EAC3C,sCAAmD;EAEnD,+CAA6C;EAC7C,uCAAqD;EACrD,0BAAuC;EACvC,iCAA+C;EAE/C,6CAA2C;EAC3C,sCAAmD;EACnD,yBAAqC;EACrC,gCAA6C;EAG3C,mCAAoD;EAApD,qCAAoD;EAApD,mCAAoD;EAApD,gCAAoD;EAApD,mCAAoD;EAApD,kCAAoD;EAApD,iCAAoD;EAApD,gCAAoD;EAIpD,+BAA4C;EAA5C,iCAA4C;EAA5C,+BAA4C;EAA5C,4BAA4C;EAA5C,+BAA4C;EAA5C,8BAA4C;EAA5C,6BAA4C;EAA5C,4BAA4C;EAI5C,mCAAoD;EAApD,qCAAoD;EAApD,mCAAoD;EAApD,gCAAoD;EAApD,mCAAoD;EAApD,kCAAoD;EAApD,iCAAoD;EAApD,gCAAoD;EAGtD,2BAAyC;EAEzC,wBAAmC;EACnC,8BAA+C;EAC/C,kCAA2C;EAC3C,wCAAuD;EAEvD,wBAAmC;EACnC,6BAA6C;EAC7C,0BAAuC;EAEvC,0BAAuC;EACvC,wDAA+D;EAE/D,8BAA+C;EAC/C,qCAA6D;EAC7D,gCAAmD;EACnD,uCAAiE,EAAA;;AExKrE;;;EAGE,sBAAsB,EAAA;;AAepB;EANJ;IAOM,uBAAuB,EAAA,EAG5B;;AAWD;EACE,SAAS;EACT,uCAAgE;ED6O5D,mCAnE+B;ECxKnC,uCAAgE;EAChE,uCAAgE;EAChE,2BAA8C;EAC9C,qCAA6D;EAC7D,mCAAmD;EACnD,8BAA8B;EAC9B,6CCxCa,EAAA;;ADiDf;EACE,cAAsB;EACtB,cCmnBmC;EDlnBnC,SAAS;EACT,wCAAkC;EAClC,aCynB+B,EAAA;;AD/mBjC;EACE,aAAa;EACb,qBCwjBwC;EDrjBxC,gBCwjB+B;EDvjB/B,gBCwjB+B;EDvjB/B,8BAAoD,EAAA;;AAGtD;EDuMQ,iCAf6B,EAAA;EA7IjC;IC3CJ;MD8MQ,iBA9E6B,EAAA,EC7HpC;;AAED;EDkMQ,iCAf6B,EAAA;EA7IjC;ICtCJ;MDyMQ,eA9E6B,EAAA,ECxHpC;;AAED;ED6LQ,+BAf6B,EAAA;EA7IjC;ICjCJ;MDoMQ,kBA9E6B,EAAA,ECnHpC;;AAED;EDwLQ,iCAf6B,EAAA;EA7IjC;IC5BJ;MD+LQ,iBA9E6B,EAAA,EC9GpC;;AAED;ED+KM,kBAnE+B,EAAA;;ACvGrC;ED0KM,eAnE+B,EAAA;;AC5FrC;EACE,aAAa;EACb,mBCwV8B,EAAA;;AD9UhC;EACE,yCAAiC;UAAjC,iCAAiC;EACjC,YAAY;EACZ,8BAA8B,EAAA;;AAMhC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB,EAAA;;AAMtB;;EAEE,kBAAkB,EAAA;;AAGpB;;;EAGE,aAAa;EACb,mBAAmB,EAAA;;AAGrB;;;;EAIE,gBAAgB,EAAA;;AAGlB;EACE,gBC6b+B,EAAA;;ADxbjC;EACE,oBAAoB;EACpB,cAAc,EAAA;;AAMhB;EACE,gBAAgB,EAAA;;AAQlB;;EAEE,mBCsakC,EAAA;;AD9ZpC;ED6EM,kBAnE+B,EAAA;;ACHrC;EACE,iBCqfmC;EDpfnC,gCAAwD;EACxD,wCAA6D,EAAA;;AAS/D;;EAEE,kBAAkB;EDwDd,iBAnE+B;ECanC,cAAc;EACd,wBAAwB,EAAA;;AAG1B;EAAM,cAAc,EAAA;;AACpB;EAAM,UAAU,EAAA;;AAKhB;EACE,gEAA4G;EAC5G,0BCgNiD,EAAA;EDlNnD;IAKI,mDAA2C,EAAA;;AAU/C;EAGI,cAAc;EACd,qBAAqB,EAAA;;AAOzB;;;;EAIE,qCCgV2E;EFlUvE,cAnE+B,EAAA;;AC6DrC;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,cAAc;EDEV,kBAnE+B,EAAA;EC6DrC;IDMM,kBAnE+B;ICwEjC,cAAc;IACd,kBAAkB,EAAA;;AAItB;EDVM,kBAnE+B;EC+EnC,2BAA8C;EAC9C,qBAAqB,EAAA;EAGrB;IACE,cAAc,EAAA;;AAIlB;EACE,2BC25CyC;EFj7CrC,kBAnE+B;EC2FnC,wBC25CmE;ED15CnE,sCC25CyE;EChsDvE,sBDghBgC,EAAA;ED/OpC;IAQI,UAAU;ID7BR,cAnE+B,EAAA;;AC2GrC;EACE,gBAAgB,EAAA;;AAMlB;;EAEE,sBAAsB,EAAA;;AAQxB;EACE,oBAAoB;EACpB,yBAAyB,EAAA;;AAG3B;EACE,mBC4XiC;ED3XjC,sBC2XiC;ED1XjC,gCC4Z6E;ED3Z7E,gBAAgB,EAAA;;AAOlB;EAEE,mBAAmB;EACnB,gCAAgC,EAAA;;AAGlC;;;;;;EAME,qBAAqB;EACrB,mBAAmB;EACnB,eAAe,EAAA;;AAQjB;EACE,qBAAqB,EAAA;;AAMvB;EAEE,gBAAgB,EAAA;;AAQlB;EACE,UAAU,EAAA;;AAKZ;;;;;EAKE,SAAS;EACT,oBAAoB;ED5HhB,kBAnE+B;ECiMnC,oBAAoB,EAAA;;AAItB;;EAEE,oBAAoB,EAAA;;AHTtB;EGeE,eAAe,EAAA;;AAGjB;EAGE,iBAAiB,EAAA;EAHnB;IAOI,UAAU,EAAA;;AHjBd;EGyBE,wBAAwB,EAAA;;AAQ1B;;;;EAIE,0BAA0B,EAAA;EAJ5B;;;;IAQM,eAAe,EAAA;;AAOrB;EACE,UAAU;EACV,kBAAkB,EAAA;;AAKpB;EACE,gBAAgB,EAAA;;AAUlB;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,SAAS,EAAA;;AAQX;EACE,WAAW;EACX,WAAW;EACX,UAAU;EACV,qBCmNiC;EDjNjC,oBAAoB;EDnNd,iCAf6B,EAAA;EA7IjC;ICyWJ;MDtMQ,iBA9E6B,EAAA,ECgSpC;EAZD;IAUI,WAAW,EAAA;;AAOf;;;;;;;EAOE,UAAU,EAAA;;AAGZ;EACE,YAAY,EAAA;;AHtDd;EGgEE,6BAA6B;EAC7B,oBAAoB,EAAA;;AAQtB;;;;;;;CH9DC;AGyED;EACE,wBAAwB,EAAA;;AAK1B;EACE,UAAU,EAAA;;AAOZ;EACE,aAAa;EACb,0BAA0B,EAAA;;AAK5B;EACE,qBAAqB,EAAA;;AAKvB;EACE,SAAS,EAAA;;AAOX;EACE,kBAAkB;EAClB,eAAe,EAAA;;AAQjB;EACE,wBAAwB,EAAA;;AH/F1B;EGwGE,wBAAwB,EAAA;;AGrkB1B;EJmQM,kBAnE+B;EI9LnC,gBFwoB+B,EAAA;;AEnoB/B;EAGE,gBF0nBqB;EEznBrB,gBFymB6B;EF7WzB,iCAf6B,EAAA;EA7IjC;IIpGF;MJuQM,eA9E6B,EAAA,EInLlC;;AAND;EAGE,gBF0nBqB;EEznBrB,gBFymB6B;EF7WzB,iCAf6B,EAAA;EA7IjC;IIpGF;MJuQM,iBA9E6B,EAAA,EInLlC;;AAND;EAGE,gBF0nBqB;EEznBrB,gBFymB6B;EF7WzB,iCAf6B,EAAA;EA7IjC;IIpGF;MJuQM,eA9E6B,EAAA,EInLlC;;AAND;EAGE,gBF0nBqB;EEznBrB,gBFymB6B;EF7WzB,iCAf6B,EAAA;EA7IjC;IIpGF;MJuQM,iBA9E6B,EAAA,EInLlC;;AAND;EAGE,gBF0nBqB;EEznBrB,gBFymB6B;EF7WzB,iCAf6B,EAAA;EA7IjC;IIpGF;MJuQM,eA9E6B,EAAA,EInLlC;;AAND;EAGE,gBF0nBqB;EEznBrB,gBFymB6B;EF7WzB,iCAf6B,EAAA;EA7IjC;IIpGF;MJuQM,iBA9E6B,EAAA,EInLlC;;AAkBH;ECvDE,eAAe;EACf,gBAAgB,EAAA;;AD2DlB;EC5DE,eAAe;EACf,gBAAgB,EAAA;;AD8DlB;EACE,qBAAqB,EAAA;EADvB;IAII,oBFsoB+B,EAAA;;AE5nBnC;EJ8MM,kBAnE+B;EIzInC,yBAAyB,EAAA;;AAI3B;EACE,mBFiUW;EF1HP,kBAnE+B,EAAA;EIrIrC;IAKI,gBAAgB,EAAA;;AAIpB;EACE,iBFwTW;EEvTX,mBFuTW;EF1HP,kBAnE+B;EIxHnC,cFtFgB,EAAA;EEkFlB;IAOI,qBAAqB,EAAA;;AEhGzB;ECIE,eAAe;EAGf,YAAY,EAAA;;ADDd;EACE,gBJ+jDwC;EI9jDxC,mCJ+jDmE;EI9jDnE,2DJgkD6E;EC7jD3E,sCD8jD6E;EKtkD/E,eAAe;EAGf,YAAY,EAAA;;ADcd;EAEE,qBAAqB,EAAA;;AAGvB;EACE,qBAA2B;EAC3B,cAAc,EAAA;;AAGhB;ENyPM,kBAnE+B;EMpLnC,gCJkjDmF,EAAA;;AMplDnF;;;;;;;ECHA,qBAA+B;EAC/B,gBAA+B;EAC/B,WAAW;EACX,4CAA6D;EAC7D,2CAA4D;EAC5D,kBAAkB;EAClB,iBAAiB,EAAA;;ACsDf;EF5CE;IACE,gBNmeG,EAAA,EMleJ;;AE0CH;EF5CE;IACE,gBNoeG,EAAA,EMneJ;;AE0CH;EF5CE;IACE,gBNqeG,EAAA,EMpeJ;;AE0CH;EF5CE;IACE,iBNseI,EAAA,EMreL;;AE0CH;EF5CE;IACE,iBNueK,EAAA,EMteN;;APMP;EUrBI,qBAA6C;EAA7C,yBAA6C;EAA7C,yBAA6C;EAA7C,yBAA6C;EAA7C,0BAA6C;EAA7C,2BAA6C,EAAA;;AAK/C;ECNA,qBAA+B;EAC/B,gBAA+B;EAC/B,aAAa;EACb,eAAe;EAEf,yCAA0D;EAC1D,4CAA6D;EAC7D,2CAA4D,EAAA;EDD5D;ICUA,cAAc;IACd,WAAW;IACX,eAAe;IACf,4CAA6D;IAC7D,2CAA4D;IAC5D,8BAA+C,EAAA;;AA+C3C;EACE,SAAW,EAAA;;AAGb;EApCJ,cAAc;EACd,WAAW,EAAA;;AAcX;EACE,cAAc;EACd,WAAoC,EAAA;;AAFtC;EACE,cAAc;EACd,UAAoC,EAAA;;AAFtC;EACE,cAAc;EACd,gBAAoC,EAAA;;AAFtC;EACE,cAAc;EACd,UAAoC,EAAA;;AAFtC;EACE,cAAc;EACd,UAAoC,EAAA;;AAFtC;EACE,cAAc;EACd,gBAAoC,EAAA;;AA+BlC;EAhDJ,cAAc;EACd,WAAW,EAAA;;AAqDH;EAhEN,cAAc;EACd,eAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,UAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,UAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,UAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,WAA0C,EAAA;;AAuElC;EAxDV,qBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,gBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,gBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,gBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAmExC;;EAEE,gBAA+B,EAAA;;AAGjC;;EAEE,gBAA+B,EAAA;;AAPjC;;EAEE,sBAA+B,EAAA;;AAGjC;;EAEE,sBAA+B,EAAA;;AAPjC;;EAEE,qBAA+B,EAAA;;AAGjC;;EAEE,qBAA+B,EAAA;;AAPjC;;EAEE,mBAA+B,EAAA;;AAGjC;;EAEE,mBAA+B,EAAA;;AAPjC;;EAEE,qBAA+B,EAAA;;AAGjC;;EAEE,qBAA+B,EAAA;;AAPjC;;EAEE,mBAA+B,EAAA;;AAGjC;;EAEE,mBAA+B,EAAA;;AF1DrC;EEUE;IACE,SAAW,EAAA;EAGb;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,gBAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,gBAAoC,EAAA;EA+BlC;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EAuElC;IAxDV,cAA4B,EAAA;EAwDlB;IAxDV,qBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAmExC;;IAEE,gBAA+B,EAAA;EAGjC;;IAEE,gBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA,EAChC;;AF3DL;EEUE;IACE,SAAW,EAAA;EAGb;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,gBAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,gBAAoC,EAAA;EA+BlC;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EAuElC;IAxDV,cAA4B,EAAA;EAwDlB;IAxDV,qBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAmExC;;IAEE,gBAA+B,EAAA;EAGjC;;IAEE,gBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA,EAChC;;AF3DL;EEUE;IACE,SAAW,EAAA;EAGb;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,gBAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,gBAAoC,EAAA;EA+BlC;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EAuElC;IAxDV,cAA4B,EAAA;EAwDlB;IAxDV,qBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAmExC;;IAEE,gBAA+B,EAAA;EAGjC;;IAEE,gBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA,EAChC;;AF3DL;EEUE;IACE,SAAW,EAAA;EAGb;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,gBAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,gBAAoC,EAAA;EA+BlC;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EAuElC;IAxDV,cAA4B,EAAA;EAwDlB;IAxDV,qBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAmExC;;IAEE,gBAA+B,EAAA;EAGjC;;IAEE,gBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA,EAChC;;AF3DL;EEUE;IACE,SAAW,EAAA;EAGb;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,gBAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,UAAoC,EAAA;EAFtC;IACE,cAAc;IACd,gBAAoC,EAAA;EA+BlC;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EAuElC;IAxDV,cAA4B,EAAA;EAwDlB;IAxDV,qBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAmExC;;IAEE,gBAA+B,EAAA;EAGjC;;IAEE,gBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA,EAChC;;ACtHT;EAEE,8BAA+C;EAC/C,2BAAyC;EACzC,+BAAiD;EACjD,4BAA2C;EAE3C,0CAAqC;EACrC,gCAA+B;EAC/B,+CAAmD;EACnD,iCAA6C;EAC7C,kDAAqD;EACrD,+DAA+C;EAC/C,iDAAmD;EACnD,6DAA6C;EAC7C,gDAAiD;EACjD,8DAA2C;EAE3C,WAAW;EACX,mBXkYW;EWjYX,mBXusB+B;EWtsB/B,0CAAqE,EAAA;EArBvE;IA6BI,sBX0rB+B;IWxrB/B,qFAA4J;IAC5J,oCAAqD;IACrD,2CX+sBqE;IW9sBrE,2GAAgL,EAAA;EAlCpL;IAsCI,uBAAuB,EAAA;EAtC3B;IA0CI,sBAAsB,EAAA;;AAI1B;EACE,+DXusBwC,EAAA;;AWhsB1C;EACE,iBAAiB,EAAA;;AAQnB;EAGI,wBXupBgC,EAAA;;AWzoBpC;EAEI,sCAAmC,EAAA;EAFvC;IAMM,sCX0pBmE,EAAA;;AWrpBzE;EAGI,sBAAsB,EAAA;;AAH1B;EAOI,mBAAmB,EAAA;;AASvB;EAEI,oDAA+C;EAC/C,8CAAyC,EAAA;;AAK7C;EAEI,oDAA+C;EAC/C,8CAAyC,EAAA;;AAQ7C;EACE,oDAAiD;EACjD,8CAA2C,EAAA;;AAO7C;EAEI,mDAAiD;EACjD,6CAA2C,EAAA;;AC5I7C;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,6BAA6C;EAC7C,6BAAmD;EACnD,4BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,6BAA6C;EAC7C,6BAAmD;EACnD,4BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,6BAA6C;EAC7C,6BAAmD;EACnD,4BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,6BAA6C;EAC7C,6BAAmD;EACnD,4BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,6BAA6C;EAC7C,6BAAmD;EACnD,4BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,6BAA6C;EAC7C,6BAAmD;EACnD,4BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,6BAA6C;EAC7C,6BAAmD;EACnD,4BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,6BAA6C;EAC7C,6BAAmD;EACnD,4BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;ADiJrE;EACE,gBAAgB;EAChB,iCAAiC,EAAA;;AH3FnC;EGyFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AH5FD;EGyFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AH5FD;EGyFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AH5FD;EGyFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AH5FD;EGyFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AEpKL;EACE,qBbu2B2C,EAAA;;Aa91B7C;EACE,oDC2N8D;ED1N9D,uDC0N8D;EDzN9D,gBAAgB;Ef8QZ,kBAnE+B;EevMnC,gBb+lB+B,EAAA;;Aa3lBjC;EACE,kDCgN8D;ED/M9D,qDC+M8D;EhBqD1D,kBAnE+B,EAAA;;Ae7LrC;EACE,mDC0M8D;EDzM9D,sDCyM8D;EhBqD1D,mBAnE+B,EAAA;;AiBxNrC;EACE,mBf+1B4C;EFrkBxC,kBAnE+B;EiBnNnC,gCf+1BuF,EAAA;;AgBp2BzF;EACE,cAAc;EACd,WAAW;EACX,yBhB8wBkC;EFtf9B,eAnE+B;EkBlNnC,gBhBkmB+B;EgBjmB/B,gBhBymB+B;EgBxmB/B,2BhB43B6E;EgB33B7E,gBAAgB;EAChB,mChBq3BuE;EgBp3BvE,4BAA4B;EAC5B,2DhBy3BiF;ECt3B/E,sCD03BiF;EiB73B/E,wEjBo5B4F,EAAA;EiBh5B5F;IDhBN;MCiBQ,gBAAgB,EAAA,ED2FvB;EA5GD;IAqBI,gBAAgB,EAAA;IArBpB;MAwBM,eAAe,EAAA;EAxBrB;IA8BI,2BhBs2B2E;IgBr2B3E,mChBg2BqE;IgB/1BrE,qBF0KiC;IEzKjC,UAAU;IAKR,kDhBJW,EAAA;EgBlCjB;IAgDI,eAAe;IAMf,aAAmE;IAKnE,SAAS,EAAA;EA3Db;IAiEI,cAAc;IACd,UAAU,EAAA;EAlEd;IAuEI,gChB40BqF;IgB10BrF,UAAU,EAAA;EAzEd;IAmFI,wChB8yB+E;IgB3yB/E,UAAU,EAAA;EAtFd;IA2FI,yBhBsrBgC;IgBrrBhC,0BhBqrBgC;IgBprBhC,0BhBorBgC;IgBnrBhC,2BhBsyB2E;IkBp4B7E,uClBqiCyE;IgBr8BvE,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,+ChBgsBqE;IgB/rBrE,gBAAgB;ICzFd,qIjBo0B6I,EAAA;IiBh0B7I;MDhBN;QCiBQ,gBAAgB,EAAA,EDsFrB;EAvGH;IA0GI,wChB47ByE,EAAA;;AgBn7B7E;EACE,cAAc;EACd,WAAW;EACX,mBAA2B;EAC3B,gBAAgB;EAChB,gBhBwf+B;EgBvf/B,2BhB2xB6E;EgB1xB7E,6BAA6B;EAC7B,yBAAyB;EACzB,sCAAmC,EAAA;EATrC;IAYI,UAAU,EAAA;EAZd;IAiBI,gBAAgB;IAChB,eAAe,EAAA;;AAWnB;EACE,mEFqF8D;EEpF9D,uBhB2oBiC;EFlgB7B,mBAnE+B;EGzMjC,yCD23BuF,EAAA;EgB1vB3F;IAOI,uBhBsoB+B;IgBroB/B,wBhBqoB+B;IgBpoB/B,yBhBooB+B,EAAA;;AgBhoBnC;EACE,iEFwE8D;EEvE9D,oBhBkoBgC;EFtgB5B,kBAnE+B;EGzMjC,yCD43BuF,EAAA;EgB9uB3F;IAOI,oBhB6nB8B;IgB5nB9B,qBhB4nB8B;IgB3nB9B,uBhB2nB8B,EAAA;;AgBpnBlC;EAEI,oEFuD4D,EAAA;;AEzDhE;EAMI,mEFmD4D,EAAA;;AEzDhE;EAUI,iEF+C4D,EAAA;;AE1ChE;EACE,WhBquB0C;EgBpuB1C,gEFwC8D;EEvC9D,iBhBilBmC,EAAA;EgBplBrC;IAMI,eAAe,EAAA;EANnB;IAUI,oBAAoB;IfvLpB,sCD03BiF,EAAA;EgB7sBrF;IAeI,oBAAoB;If5LpB,sCD03BiF,EAAA;EgB7sBrF;IAmBsB,+DFuB0C,EAAA;EE1ChE;IAoBsB,6DFsB0C,EAAA;;AKrOhE;EACE,gEAAmD;EAEnD,cAAc;EACd,WAAW;EACX,0CnB2wBkC;EFtf9B,eAnE+B;EqB/MnC,gBnB+lB+B;EmB9lB/B,gBnBsmB+B;EmBrmB/B,2BnBy3B6E;EmBx3B7E,gBAAgB;EAChB,mCnBk3BuE;EmBj3BvE,mFAA0I;EAC1I,4BAA4B;EAC5B,yCnB+9BqE;EmB99BrE,0BnB+9B2C;EmB99B3C,2DnBm3BiF;ECt3B/E,sCD03BiF;EiB73B/E,wEjBo5B4F,EAAA;EiBh5B5F;IEfN;MFgBQ,gBAAgB,EAAA,EEkCvB;EAlDD;IAuBI,qBLkLiC;IKjLjC,UAAU;IAKR,kDnBIW,EAAA;EmBjCjB;IAmCI,sBnB6uBgC;ImB5uBhC,sBAAsB,EAAA;EApC1B;IAyCI,wCnBu1B+E,EAAA;EmBh4BnF;IA+CI,kBAAkB;IAClB,uCnBm1B2E,EAAA;;AmB/0B/E;EACE,oBnBsuBkC;EmBruBlC,uBnBquBkC;EmBpuBlC,oBnBquBiC;EFlgB7B,mBAnE+B;EGzMjC,yCD23BuF,EAAA;;AmB70B3F;EACE,mBnBkuBiC;EmBjuBjC,sBnBiuBiC;EmBhuBjC,kBnBiuBgC;EFtgB5B,kBAnE+B;EGzMjC,yCD43BuF,EAAA;;AJ26B3F;EuB9uDM,gEAAmD,EAAA;;ACxEzD;EACE,cAAc;EACd,kBpBq6B2E;EoBp6B3E,mBpBq6BsE;EoBp6BtE,uBpBq6B+C,EAAA;EoBz6BjD;IAOI,WAAW;IACX,mBAA2C,EAAA;;AAI/C;EACE,oBpB25BsE;EoB15BtE,eAAe;EACf,iBAAiB,EAAA;EAHnB;IAMI,YAAY;IACZ,oBAA4C;IAC5C,cAAc,EAAA;;AAIlB;EACE,qCAAyC;EAEzC,cAAc;EACd,UpB04B2C;EoBz4B3C,WpBy4B2C;EoBx4B3C,kBAA8D;EAC9D,mBAAmB;EACnB,gBAAgB;EAChB,yCAA+D;EAC/D,+CAA2E;EAC3E,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,2DpB24BqI;EoB14BrI,yBAAyB,EAAA;EAf3B;InBTI,qBDm6B2C,EAAA;EoB15B/C;IAwBI,kBpBm4ByC,EAAA;EoB35B7C;IA4BI,uBpB03BqD,EAAA;EoBt5BzD;IAgCI,qBNkJiC;IMjJjC,UAAU;IACV,kDpBxBa,EAAA;EoBVjB;IAsCI,yBpB5Ba;IoB6Bb,qBpB7Ba,EAAA;IoBVjB;MA6CQ,iEAAqD,EAAA;IA7C7D;MAqDQ,iEAAqD,EAAA;EArD7D;IA2DI,yBpBjDa;IoBkDb,qBpBlDa;IoBuDX,iEAAqD,EAAA;EAjE3D;IAsEI,oBAAoB;IACpB,YAAY;IACZ,YpBk2ByC,EAAA;EoB16B7C;IAgFM,eAAe;IACf,YpBy1BuC,EAAA;;AoB30B7C;EACE,mBpBo1ByD,EAAA;EoBr1B3D;IAII,4DAA2C;IAE3C,UpB80BiC;IoB70BjC,mBAA4C;IAC5C,0CAAiE;IACjE,gCAAgC;InBjHhC,kBD47BiC;IiB/7B/B,iDjBm8BgE,EAAA;IiB/7BhE;MGuGN;QHtGQ,gBAAgB,EAAA,EGgIrB;IA1BH;MAcM,4DAA2C,EAAA;IAdjD;MAkBM,iCpB60BwC;MoBx0BtC,4DAA2C,EAAA;EAvBnD;IA6BI,oBpBwzBuD;IoBvzBvD,eAAe,EAAA;IA9BnB;MAiCM,oBAA6C;MAC7C,cAAc,EAAA;;AAKpB;EACE,qBAAqB;EACrB,kBpBsyBoC,EAAA;;AoBnyBtC;EACE,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB,EAAA;EAHtB;IAQM,oBAAoB;IACpB,YAAY;IACZ,apBspB2B,EAAA;;AJ0lCjC;EwBxuDM,4DAA2C,EAAA;;ACnLjD;EACE,WAAW;EACX,cP+N2B;EO9N3B,UAAU;EACV,gBAAgB;EAChB,6BAA6B,EAAA;EAL/B;IAQI,UAAU,EAAA;IARd;MAY8B,kErBoBb,EAAA;IqBhCjB;MAa8B,kErBmBb,EAAA;EqBhCjB;IAiBI,SAAS,EAAA;EAjBb;IAqBI,WrB+/B2C;IqB9/B3C,YrB8/B2C;IqB7/B3C,oBAAsE;IACtE,gBAAgB;IH1BlB,yBlBkCe;IqBNb,SrB6/BwC;IC1gCxC,mBD2gC2C;IiB9gCzC,oHjBohCkI;IiBphClI,4GjBohCkI,EAAA;IiBhhClI;MIdN;QJeQ,wBAAgB;QAAhB,gBAAgB,EAAA,EImBrB;IAlCH;MHFE,yBJ0MmC,EAAA;EOxMrC;IAqCI,WrBw+BkC;IqBv+BlC,crBw+BmC;IqBv+BnC,kBAAkB;IAClB,erBu+BqC;IqBt+BrC,wCrBu+ByE;IqBt+BzE,yBAAyB;IpB7BzB,mBDogCkC,EAAA;EqBjhCtC;IAgDI,WrBo+B2C;IqBn+B3C,YrBm+B2C;IqBl+B3C,gBAAgB;IHpDlB,yBlBkCe;IqBoBb,SrBm+BwC;IC1gCxC,mBD2gC2C;IiB9gCzC,iHjBohCkI;IiBphClI,4GjBohCkI,EAAA;IiBhhClI;MIdN;QJeQ,qBAAgB;QAAhB,gBAAgB,EAAA,EI6CrB;IA5DH;MHFE,yBJ0MmC,EAAA;EOxMrC;IA+DI,WrB88BkC;IqB78BlC,crB88BmC;IqB78BnC,kBAAkB;IAClB,erB68BqC;IqB58BrC,wCrB68ByE;IqB58BzE,yBAAyB;IpBvDzB,mBDogCkC,EAAA;EqBjhCtC;IA0EI,oBAAoB,EAAA;IA1ExB;MA6EM,2CrBg9BsF,EAAA;IqB7hC5F;MAiFM,2CrB48BsF,EAAA;;AsBniC5F;EACE,kBAAkB,EAAA;EADpB;;;IAMI,uDRoO4D;IQnO5D,2DRmO4D;IQlO5D,iBtBuiCwC,EAAA;EsB/iC5C;IAYI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,eAAe;IACf,YAAY;IACZ,qBtBmwBgC;IsBlwBhC,gBAAgB;IAChB,2CAA6F;IAC7F,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,gDAA6C;IAC7C,qBAAqB;ILVnB,gEjBwiCoF,EAAA;IiBpiCpF;MKpBN;QLqBQ,gBAAgB,EAAA,EKOrB;EA5BH;;IAgCI,qBtBqvBgC,EAAA;IsBrxBpC;;MAmCM,kBAAkB,EAAA;IAnCxB;;;MAwCM,qBtB0gC0C;MsBzgC1C,wBtB0gCyC,EAAA;IsBnjC/C;;MA6CM,qBtBqgC0C;MsBpgC1C,wBtBqgCyC,EAAA;EsBnjC/C;IAmDI,qBtB+/B4C;IsB9/B5C,wBtB+/B2C;IsB9/B3C,qBtBguBgC,EAAA;EsBrxBpC;;;;IA6DM,8DtBy/BkF,EAAA;EsBtjCxF;IAmEM,8DtBm/BkF,EAAA;EsBtjCxF;;IAyEM,kBAAkB;IAClB,oBAA+D;IAC/D,WAAW;IACX,atBw+BuC;IsBv+BvC,WAAW;IACX,mCtBqzBmE;ICh3BrE,sCD03BiF,EAAA;EsB74BrF;IAmFI,wCtBkzB+E,EAAA;EsBr4BnF;IAwFM,sCAAmC,EAAA;EAxFzC;;IA8FI,ctBhFc,EAAA;;AuBVlB;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,WAAW,EAAA;EALb;;;IAUI,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,YAAY,EAAA;EAbhB;;;IAoBI,UAAU,EAAA;EApBd;IA2BI,kBAAkB;IAClB,UAAU,EAAA;IA5Bd;MA+BM,UAAU,EAAA;;AAWhB;EACE,aAAa;EACb,mBAAmB;EACnB,yBvBouBkC;EFtf9B,eAnE+B;EyBzKnC,gBvByjB+B;EuBxjB/B,gBvBgkB+B;EuB/jB/B,2BvBm1B6E;EuBl1B7E,kBAAkB;EAClB,mBAAmB;EACnB,uCvB06B+E;EuBz6B/E,2DvBg1BiF;ECt3B/E,sCD03BiF,EAAA;;AuB10BrF;;;;EAIE,oBvB8tBgC;EFtgB5B,kBAnE+B;EGzMjC,yCD43BuF,EAAA;;AuBn0B3F;;;;EAIE,uBvBitBiC;EFlgB7B,mBAnE+B;EGzMjC,yCD23BuF,EAAA;;AuBzzB3F;;EAEE,mBAAsE,EAAA;;AAWxE;;;;EtB/DI,0BsBqE8B;EtBpE9B,6BsBoE8B,EAAA;;AANlC;;;;EtB/DI,0BsB8E8B;EtB7E9B,6BsB6E8B,EAAA;;AAflC;EAyBI,8CAA8C;EtB1E9C,yBsB2E8B;EtB1E9B,4BsB0E8B,EAAA;;AA1BlC;;EtBjDI,yBsBgF8B;EtB/E9B,4BsB+E8B,EAAA;;AAP4B;EC/F1D,aAAa;EACb,WAAW;EACX,mBxBu0B0C;EFrkBxC,kBAnE+B;E0B5LjC,iCxBojC4D,EAAA;;AuB19BtB;ECtFtC,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,uBxBy1C4C;EwBx1C5C,iBAAiB;E1BqPf,mBAnE+B;E0B/KjC,WxByiCqB;EwBxiCrB,mCxByiCqD;ECpkCrD,sCD42C6E,EAAA;;AwBz3C7E;;;;EA+CE,cAAc,EAAA;;AA/ChB;EAqDE,+CxB8hC+E;EwB3hC7E,oCV4KwD;EU3KxD,yDVwE0E;EUvE1E,4BAA4B;EAC5B,2DAA6D;EAC7D,gEVwKwD,EAAA;EUpO5D;IAgEI,+CxBmhC6E;IwB9gC3E,2DxB6gC0I,EAAA;;AwBllChJ;EA+EI,oCVqJwD;EUpJxD,kFVoJwD,EAAA;;AUpO5D;EAuFE,+CxB4/B+E,EAAA;EwBnlCjF;IA4FM,iEAAqD;IACrD,uBxBq5B2F;IwBp5B3F,+DxBu4BoD;IwBt4BpD,2EVqIsD,EAAA;EUpO5D;IAoGI,+CxB++B6E;IwB1+B3E,2DxBy+B0I,EAAA;;AwBllChJ;EAkHI,yCVkHwD,EAAA;;AUpO5D;EAyHE,+CxB09B+E,EAAA;EwBnlCjF;IA4HI,4CxBk9BwD,EAAA;EwB9kC5D;IAgII,2DxBk9B4I,EAAA;EwBllChJ;IAoII,iCxB08BwD,EAAA;;AwBt8B9D;EAEI,iBAAiB,EAAA;;AA1InB;;;;;EAoJM,UAAU,EAAA;;ADhCqF;EC/FrG,aAAa;EACb,WAAW;EACX,mBxBu0B0C;EFrkBxC,kBAnE+B;E0B5LjC,mCxB4jCgE,EAAA;;AuBl+Be;ECtF/E,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,uBxBy1C4C;EwBx1C5C,iBAAiB;E1BqPf,mBAnE+B;E0B/KjC,WxBijCqB;EwBhjCrB,kCxBijCmD;EC5kCnD,sCD42C6E,EAAA;;AwBz3C7E;;;;EA+CE,cAAc,EAAA;;AA/ChB;EAqDE,iDxBsiCmF;EwBniCjF,oCV4KwD;EU3KxD,0DVwE0E;EUvE1E,4BAA4B;EAC5B,2DAA6D;EAC7D,gEVwKwD,EAAA;EUpO5D;IAgEI,iDxB2hCiF;IwBthC/E,0DxBqhCwI,EAAA;;AwB1lC9I;EA+EI,oCVqJwD;EUpJxD,kFVoJwD,EAAA;;AUpO5D;EAuFE,iDxBogCmF,EAAA;EwB3lCrF;IA4FM,kEAAqD;IACrD,uBxBq5B2F;IwBp5B3F,+DxBu4BoD;IwBt4BpD,2EVqIsD,EAAA;EUpO5D;IAoGI,iDxBu/BiF;IwBl/B/E,0DxBi/BwI,EAAA;;AwB1lC9I;EAkHI,yCVkHwD,EAAA;;AUpO5D;EAyHE,iDxBk+BmF,EAAA;EwB3lCrF;IA4HI,8CxB09B4D,EAAA;EwBtlChE;IAgII,0DxB09B0I,EAAA;EwB1lC9I;IAoII,mCxBk9B4D,EAAA;;AwB98BlE;EAEI,iBAAiB,EAAA;;AA1InB;;;;;EAsJM,UAAU,EAAA;;ACxJpB;EAEE,2BAAyC;EACzC,4BAAyC;EACzC,sBAA6C;E3BuRzC,wBAnE+B;E2BlNnC,yBAA6C;EAC7C,yBAA6C;EAC7C,oCAAiC;EACjC,wBAA2B;EAC3B,6CAA+C;EAC/C,kCAA+C;EAC/C,+CAAiD;EACjD,wCAA2D;EAC3D,4FAA2C;EAC3C,+BAAuD;EACvD,iFAAuD;EAGvD,qBAAqB;EACrB,wDAAoG;EACpG,sCAA8D;E3BsQ1D,kCAnE+B;E2BjMnC,sCAA8D;EAC9D,sCAA8D;EAC9D,0BAA4C;EAC5C,kBAAkB;EAClB,qBAAwD;EAExD,sBAAsB;EACtB,eAA2C;EAC3C,yBAAiB;UAAjB,iBAAiB;EACjB,mEAAqH;ExBjBnH,0CwBkB0E;EPjC5E,kCOkCoD;ERtBhD,qIjBo0B6I,EAAA;EiBh0B7I;IQhBN;MRiBQ,gBAAgB,EAAA,EQqGvB;EAtHD;IAuCI,gCAAwD;IAExD,wCAA6D;IAC7D,8CAA6E,EAAA;EAG/E;IAEE,0BAA4C;IAC5C,kCAAiD;IACjD,wCAAiE,EAAA;EAjDrE;IAqDI,gCAAwD;IPrD1D,wCOsDkE;IAChE,8CAA6E;IAC7E,UAAU;IAKR,0CAAuE,EAAA;EAI3E;IACE,8CAA6E;IAC7E,UAAU;IAKR,0CAAuE,EAAA;EAI3E;;IAKE,iCAA0D;IAC1D,yCAA+D;IAG/D,+CAA+E,EAAA;IATjF;;MAiBM,0CAAuE,EAAA;EAK7E;IAKI,0CAAuE,EAAA;EAvG7E;;IA8GI,mCAA8D;IAC9D,oBAAoB;IACpB,2CAAmE;IAEnE,iDAAmF;IACnF,uCAAoE,EAAA;;AAYtE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADkGjE;EC/GA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,qCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;AD4HjE;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADmG/B;EChHA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,qCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;AD+GjC;EACE,yBAA6C;EAC7C,oCAAiC;EACjC,wBAA2B;EAC3B,kCAA+C;EAC/C,gDAA6C;EAC7C,wCAA2D;EAC3D,iDAA+C;EAC/C,yCAA6D;EAC7D,gCAAmD;EACnD,2CAAiE;EACjE,+BAA2C;EAC3C,uCAAuD;EAEvD,0BzB8QiD,EAAA;EyB5RnD;IAyBI,0BAA4C,EAAA;EAzBhD;IA6BI,gCAAwD,EAAA;;AAW5D;ECjJE,0BAAyC;EACzC,wBAAyC;E5B8NrC,2BAnE+B;E4BzJnC,kDAAiD,EAAA;;ADkJnD;ECrJE,2BAAyC;EACzC,0BAAyC;E5B8NrC,4BAnE+B;E4BzJnC,kDAAiD,EAAA;;ACnEnD;EVgBM,gCjBsjB2C,EAAA;EiBljB3C;IUpBN;MVqBQ,gBAAgB,EAAA,EUfvB;EAND;IAII,UAAU,EAAA;;AAKd;EAEI,aAAa,EAAA;;AAIjB;EACE,SAAS;EACT,gBAAgB;EVDZ,6BjBwjBwC,EAAA;EiBpjBxC;IULN;MVMQ,gBAAgB,EAAA,EUIvB;EAVD;IAMI,QAAQ;IACR,YAAY;IVNV,4BjByjBuC,EAAA;IiBrjBvC;MULN;QVMQ,gBAAgB,EAAA,EUGrB;;ACvBH;;;;;;EAME,kBAAkB,EAAA;;AL6FG;EKzFrB,mBAAmB,EAAA;ECwBjB;IACE,qBAAqB;IACrB,oB7B6hB0C;I6B5hB1C,uB7B2hB0C;I6B1hB1C,WAAW;IArCf,uBAAwB;IACxB,qCAAsC;IACtC,gBAAgB;IAChB,oCAAqC,EAAA;EA0DnC;IACE,cAAc,EAAA;;ANoCyB;EKhF3C,0BAA6C;EAC7C,8BAAmD;EACnD,0BAAmD;EACnD,+BAAmD;EACnD,8BAA6C;E9BuQzC,6BAnE+B;E8BlMnC,yCAA2C;EAC3C,mCAAqC;EACrC,8DAAyD;EACzD,oDAA2D;EAC3D,kDAAyD;EACzD,yFAAuE;EACvE,4DAAqD;EACrD,sCAAiE;EACjE,8CAAqD;EACrD,8CAAqD;EACrD,oDAAiE;EACjE,kDAA2D;EAC3D,qCAAmE;EACnE,qCAA6D;EAC7D,2DAAuE;EACvE,kCAA6D;EAC7D,qCAA6D;EAC7D,mCAAyD;EACzD,oCAAiE;EACjE,sCAAiE;EAGjE,kBAAkB;EAClB,kCAA0D;EAC1D,aAAa;EACb,uCAAkE;EAClE,kEAAwH;EACxH,SAAS;E9B0OL,uCAnE+B;E8BrKnC,+BAAsD;EACtD,gBAAgB;EAChB,gBAAgB;EAChB,uCAA2D;EAC3D,4BAA4B;EAC5B,6EAAyI;E3BzCvI,+C2B0CoF,EAAA;EA3CxF;IA+CI,SAAS;IACT,OAAO;IACP,qCAA6D,EAAA;;AAwB7D;EACE,oBAAc,EAAA;EADhB;IAII,WAAW;IACX,OAAO,EAAA;;AAIX;EACE,kBAAc,EAAA;EADhB;IAII,QAAQ;IACR,UAAU,EAAA;;ApB1Cd;EoB4BA;IACE,oBAAc,EAAA;IADhB;MAII,WAAW;MACX,OAAO,EAAA;EAIX;IACE,kBAAc,EAAA;IADhB;MAII,QAAQ;MACR,UAAU,EAAA,EACX;;ApB3CH;EoB4BA;IACE,oBAAc,EAAA;IADhB;MAII,WAAW;MACX,OAAO,EAAA;EAIX;IACE,kBAAc,EAAA;IADhB;MAII,QAAQ;MACR,UAAU,EAAA,EACX;;ApB3CH;EoB4BA;IACE,oBAAc,EAAA;IADhB;MAII,WAAW;MACX,OAAO,EAAA;EAIX;IACE,kBAAc,EAAA;IADhB;MAII,QAAQ;MACR,UAAU,EAAA,EACX;;ApB3CH;EoB4BA;IACE,oBAAc,EAAA;IADhB;MAII,WAAW;MACX,OAAO,EAAA;EAIX;IACE,kBAAc,EAAA;IADhB;MAII,QAAQ;MACR,UAAU,EAAA,EACX;;ApB3CH;EoB4BA;IACE,oBAAc,EAAA;IADhB;MAII,WAAW;MACX,OAAO,EAAA;EAIX;IACE,kBAAc,EAAA;IADhB;MAII,QAAQ;MACR,UAAU,EAAA,EACX;;AAQP;EAEI,SAAS;EACT,YAAY;EACZ,aAAa;EACb,wCAAgE,EAAA;;ACpFhE;EACE,qBAAqB;EACrB,oB7B6hB0C;E6B5hB1C,uB7B2hB0C;E6B1hB1C,WAAW;EA9Bf,aAAa;EACb,qCAAsC;EACtC,0BAA2B;EAC3B,oCAAqC,EAAA;;AAmDnC;EACE,cAAc,EAAA;;AD+DpB;EAEI,MAAM;EACN,WAAW;EACX,UAAU;EACV,aAAa;EACb,sCAA8D,EAAA;;AClG9D;EACE,qBAAqB;EACrB,oB7B6hB0C;E6B5hB1C,uB7B2hB0C;E6B1hB1C,WAAW;EAvBf,mCAAoC;EACpC,eAAe;EACf,sCAAuC;EACvC,wBAAyB,EAAA;;AA4CvB;EACE,cAAc,EAAA;;AA7BhB;EDwGE,iBAAiB,EAAA;;AAKvB;EAEI,MAAM;EACN,WAAW;EACX,UAAU;EACV,aAAa;EACb,uCAA+D,EAAA;;ACnH/D;EACE,qBAAqB;EACrB,oB7B6hB0C;E6B5hB1C,uB7B2hB0C;E6B1hB1C,WAAW,EAAA;;AAJb;EAgBI,aAAa,EAAA;;AAGf;EACE,qBAAqB;EACrB,qB7B0gBwC;E6BzgBxC,uB7BwgBwC;E6BvgBxC,WAAW;EAnCjB,mCAAoC;EACpC,yBAA0B;EAC1B,sCAAuC,EAAA;;AAsCrC;EACE,cAAc,EAAA;;AAVd;EDsGA,iBAAiB,EAAA;;AAOvB;EACE,SAAS;EACT,6CAA+E;EAC/E,gBAAgB;EAChB,mDAA+E;EAC/E,UAAU,EAAA;;AAMZ;EACE,cAAc;EACd,WAAW;EACX,4EAA4I;EAC5I,WAAW;EACX,gB5Byb+B;E4Bxb/B,oCAAgE;EAChE,mBAAmB;EACnB,qBAAwD;EACxD,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;E3BtKP,uD2BuKiG,EAAA;EAZrG;IAgBI,0CAA4E;IV1L9E,kDU4LsF,EAAA;EAlBxF;IAuBI,2CAA8E;IAC9E,qBAAqB;IVlMvB,mDUmMwF,EAAA;EAzB1F;IA8BI,6CAAkF;IAClF,oBAAoB;IACpB,6BAA6B,EAAA;;AAMjC;EACE,cAAc,EAAA;;AAIhB;EACE,cAAc;EACd,gFAAoJ;EACpJ,gBAAgB;E9BmEZ,mBAnE+B;E8BEnC,sCAAoE;EACpE,mBAAmB,EAAA;;AAIrB;EACE,cAAc;EACd,4EAA4I;EAC5I,oCAAgE,EAAA;;AAIlE;EAEE,4BAA2C;EAC3C,yBAAqC;EACrC,8DAAyD;EACzD,0BAAqD;EACrD,iCAAqD;EACrD,oCAAiE;EACjE,4DAAqD;EACrD,sDAA2D;EAC3D,qCAAmE;EACnE,qCAA6D;EAC7D,0CAAuE;EACvE,mCAAyD,EAAA;;AEtP3D;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB,EAAA;EAJxB;;IAOI,kBAAkB;IAClB,cAAc,EAAA;EARlB;;;;;;;;;;;;IAmBI,UAAU,EAAA;;AAKd;EACE,aAAa;EACb,eAAe;EACf,2BAA2B,EAAA;EAH7B;IAMI,WAAW,EAAA;;AAIf;E7BhBI,sCD6zBuE,EAAA;E8B7yB3E;;IAMI,8CAA4C,EAAA;EANhD;;;I7BAI,0B6Ba4B;I7BZ5B,6B6BY4B,EAAA;EAbhC;;;I7BcI,yB6BS8B;I7BR9B,4B6BQ8B,EAAA;;AAgBlC;EACE,wBAAmC;EACnC,uBAAkC,EAAA;EAFpC;;;IAOI,cAAc,EAAA;EAGhB;IACE,eAAe,EAAA;;AAInB;EACE,uBAAsC;EACtC,sBAAqC,EAAA;;AAGvC;EACE,sBAAsC;EACtC,qBAAqC,EAAA;;AAoBvC;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB,EAAA;EAHzB;;IAOI,WAAW,EAAA;EAPf;;IAYI,6CAA2C,EAAA;EAZ/C;;I7B1EI,6B6B4F+B;I7B3F/B,4B6B2F+B,EAAA;EAlBnC;;;I7BxFI,yB6BoH4B;I7BnH5B,0B6BmH4B,EAAA;;AC3IhC;EAEE,6BAAmD;EACnD,+BAAmD;EAEnD,2BAAuD;EACvD,yCAA2C;EAC3C,qDAAuD;EACvD,uDAA6D;EAG7D,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,kEAAwH;EjCsQpH,uCAnE+B;EiCjMnC,2CAAwE;EACxE,+BAAsD;EACtD,qBAAwD;EACxD,gBAAgB;EAChB,SAAS;EdfL,uGjB4nCsH,EAAA;EiBxnCtH;IcGN;MdFQ,gBAAgB,EAAA,Ec+BvB;EA7BD;IAaI,qCAAkE,EAAA;EAbtE;IAkBI,UAAU;IACV,kD/BJa,EAAA;E+BfjB;IAyBI,wCAAwE;IACxE,oBAAoB;IACpB,eAAe,EAAA;;AAQnB;EAEE,kDAAyD;EACzD,kDAAyD;EACzD,oDAA2D;EAC3D,2GAA+E;EAC/E,yDAAmE;EACnE,+CAA6D;EAC7D,uGAAiF;EAGjF,oFAAgJ,EAAA;EAXlJ;IAcI,yDAAuF;IACvF,yDAAuF;I9B7CvF,wD8B8C0F;I9B7C1F,yD8B6C0F,EAAA;IAhB9F;MAqBM,kBAAkB;MAClB,wDAAiG,EAAA;EAtBvG;;IA4BI,2CAA8E;IAC9E,mDAAmF;IACnF,yDAAmG,EAAA;EA9BvG;IAmCI,sDAAoF;I9BjEpF,yB8BmE4B;I9BlE5B,0B8BkE4B,EAAA;;AAShC;EAEE,qDAA6D;EAC7D,sCAAqE;EACrE,sCAA+D,EAAA;EAJjE;I9BrFI,gD8B6FwF,EAAA;EAR5F;;IAaI,4CAAgF;IbjHlF,oDakH0F,EAAA;;AAS5F;EAEE,4BAAiD;EACjD,yCAAmE;EACnE,8DAA6E;EAG7E,gCAA0D,EAAA;EAP5D;IAUI,gBAAgB;IAChB,eAAe;IACf,qEAAwG,EAAA;IAZ5G;MAgBM,iCAAiC,EAAA;EAhBvC;;IAsBI,gB/B0d6B;I+Bzd7B,gDAAwF;IACxF,iCAAiC,EAAA;;AASrC;;EAGI,cAAc;EACd,kBAAkB,EAAA;;AAItB;;EAGI,YAAY;EACZ,aAAa;EACb,kBAAkB,EAAA;;AAItB;;EAGI,WAAW,EAAA;;AASf;EAEI,aAAa,EAAA;;AAFjB;EAKI,cAAc,EAAA;;AC7LlB;EAEE,wBAA+C;EAC/C,6BAA+C;EAC/C,2DAAuC;EACvC,gEAAmD;EACnD,mEAAyD;EACzD,+DAAqD;EACrD,sCAA2D;EAC3D,kCAA6D;EAC7D,oCAA2D;EAC3D,8DAAmD;EACnD,oEAA+D;EAC/D,sCAAiE;EACjE,sCAA+D;EAC/D,sCAA+D;EAC/D,sCAA+D;EAC/D,qEAA2D;EAC3D,0EAAqE;EACrE,0DAAuE;EACvE,wCAAmE;EACnE,4DAAiE;EAGjE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,8DAAgH,EAAA;EA7BlH;;IAoCI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B,EAAA;;AAoBlC;EACE,6CAA4E;EAC5E,gDAA+E;EAC/E,+CAA+E;ElC4N3E,2CAnE+B;EkCvJnC,mCAA8D;EAC9D,qBAAwD;EACxD,mBAAmB,EAAA;EAPrB;IAWI,yCAA0E,EAAA;;AAU9E;EAEE,0BAAmD;EACnD,+BAAmD;EAEnD,2BAAuD;EACvD,2CAA2C;EAC3C,uDAAuD;EACvD,6DAA6D;EAG7D,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAA;EAflB;IAoBM,oCAAgE,EAAA;EApBtE;IAyBI,gBAAgB,EAAA;;AASpB;EACE,mBhC8gCuC;EgC7gCvC,sBhC6gCuC;EgC5gCvC,6BAAkD,EAAA;EAHpD;;;IAQI,oCAAgE,EAAA;;AAapE;EACE,YAAY;EACZ,gBAAgB;EAGhB,mBAAmB,EAAA;;AAIrB;EACE,8EAAgJ;ElCyI5I,6CAnE+B;EkCpEnC,cAAc;EACd,6BAAkD;EAClD,6BAA6B;EAC7B,0EAAmI;E/BxIjI,qD+ByIgG;Ef5I9F,+Ce6IqF,EAAA;EfzIrF;IeiIN;MfhIQ,gBAAgB,EAAA,EemJvB;EAnBD;IAWI,qBAAqB,EAAA;EAXzB;IAeI,qBAAqB;IACrB,UAAU;IACV,sDAAyF,EAAA;;AAM7F;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kDAAiF;EACjF,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB,EAAA;;AAGvB;EACE,yCAA+D;EAC/D,gBAAgB,EAAA;;AxB1Hd;EwBsIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,kDAAoF;QACpF,iDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Mf9N9B,gBegO4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AxB7LP;EwBsIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,kDAAoF;QACpF,iDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Mf9N9B,gBegO4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AxB7LP;EwBsIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,kDAAoF;QACpF,iDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Mf9N9B,gBegO4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AxB7LP;EwBsIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,kDAAoF;QACpF,iDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Mf9N9B,gBegO4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AxB7LP;EwBsIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,kDAAoF;QACpF,iDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Mf9N9B,gBegO4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AA7DX;EAQQ,iBAAiB;EACjB,2BAA2B,EAAA;EATnC;IAYU,mBAAmB,EAAA;IAZ7B;MAeY,kBAAkB,EAAA;IAf9B;MAmBY,kDAAoF;MACpF,iDAAmF,EAAA;EApB/F;IAyBU,iBAAiB,EAAA;EAzB3B;IA6BU,wBAAwB;IACxB,gBAAgB,EAAA;EA9B1B;IAkCU,aAAa,EAAA;EAlCvB;IAuCU,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,wCAAwC;IACxC,oBAAoB;IACpB,0BAA0B;If9N9B,gBegO4B,EAAA;IAjDlC;MAqDY,aAAa,EAAA;IArDzB;MAyDY,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB,EAAA;;AAiB/B;;EAGE,4CAAuC;EACvC,kDAAmD;EACnD,qDAAyD;EACzD,8BAAqD;EACrD,6BAAmD;EACnD,mCAA+D;EAC/D,0DAAqE;EACrE,qEAA2D,EAAA;;ApCsqG7D;EoC/pGM,qEAA2D,EAAA;;ACzRjE;EAEE,wBAAyC;EACzC,wBAAyC;EACzC,gCAAqD;EACrD,uBAA+C;EAC/C,0BAAqD;EACrD,8CAAiD;EACjD,0DAAiD;EACjD,gDAAmD;EACnD,sBAA6C;EAC7C,uFAA+D;EAC/D,+BAAmD;EACnD,6BAAmD;EACnD,sDAAqC;EACrC,qBAA2C;EAC3C,kBAAqC;EACrC,iBAAmC;EACnC,+BAA6B;EAC7B,mCAA+D;EAC/D,+BAAiD;EAGjD,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,6BAAiD;EACjD,2BAA8C;EAC9C,qBAAqB;EACrB,mCAAmD;EACnD,2BAA2B;EAC3B,qEAAyH;EhCjBvH,2CgCkB4E,EAAA;EAjChF;IAqCI,eAAe;IACf,cAAc,EAAA;EAtClB;IA0CI,mBAAmB;IACnB,sBAAsB,EAAA;IA3C1B;MA8CM,mBAAmB;MhCtBrB,0DgCuBgG;MhCtBhG,2DgCsBgG,EAAA;IA/CpG;MAmDM,sBAAsB;MhCbxB,8DgCcmG;MhCbnG,6DgCamG,EAAA;EApDvG;;IA4DI,aAAa,EAAA;;AAIjB;EAGE,cAAc;EACd,wDAAoG;EACpG,2BAA8C,EAAA;;AAGhD;EACE,4CAAwE;EACxE,iCAA0D,EAAA;;AAG5D;EACE,qDAAiF;EACjF,gBAAgB;EAChB,oCAAgE,EAAA;;AAGlE;EACE,gBAAgB,EAAA;;AAGlB;EAMI,oCAA0D,EAAA;;AAQ9D;EACE,kEAAwH;EACxH,gBAAgB;EAChB,+BAAsD;EACtD,uCAA2D;EAC3D,4EAAgI,EAAA;EALlI;IhCtFI,wFgC8FkK,EAAA;;AAItK;EACE,kEAAwH;EACxH,+BAAsD;EACtD,uCAA2D;EAC3D,yEAA6H,EAAA;EAJ/H;IhClGI,wFgCyGkK,EAAA;;AAStK;EACE,sDAAiF;EACjF,sDAAiF;EACjF,qDAAgF;EAChF,gBAAgB,EAAA;EAJlB;IAOI,mCAAmD;IACnD,sCAAsD,EAAA;;AAI1D;EACE,sDAAiF;EACjF,qDAAgF,EAAA;;AAIlF;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,2CAA4E;EhC1I1E,iDgC2IwF,EAAA;;AAG5F;;;EAGE,WAAW,EAAA;;AAGb;;EhC3II,0DgC6I4F;EhC5I5F,2DgC4I4F,EAAA;;AAGhG;;EhClII,8DgCoI+F;EhCnI/F,6DgCmI+F,EAAA;;AAQnG;EAII,0CAAoE,EAAA;;AzB3HpE;EyBuHJ;IAQI,aAAa;IACb,mBAAmB,EAAA;IATvB;MAaM,SAAW;MACX,gBAAgB,EAAA;MAdtB;QAiBQ,cAAc;QACd,cAAc,EAAA;MAlBtB;QhCnJI,0BgC2KkC;QhC1KlC,6BgC0KkC,EAAA;QAxBtC;;UA6BY,0BAA0B,EAAA;QA7BtC;;UAkCY,6BAA6B,EAAA;MAlCzC;QhCrII,yBgC4KoC;QhC3KpC,4BgC2KoC,EAAA;QAvCxC;;UA4CY,yBAAyB,EAAA;QA5CrC;;UAiDY,4BAA4B,EAAA,EAC7B;;ACpOX;EAEE,0CAA6C;EAC7C,oCAAuC;EACvC,8KAAuD;EACvD,mDAA2D;EAC3D,mDAA2D;EAC3D,qDAA6D;EAC7D,4FAAyE;EACzE,qCAA6D;EAC7D,kCAA6D;EAC7D,8CAAqD;EACrD,6CAA+C;EAC/C,iEAAmD;EACnD,sCAA+D;EAC/D,kDAAuE;EACvE,8DAAyE;EACzE,wEAAiE;EACjE,2EAA2E;EAC3E,sCAA+D;EAC/D,mCAA+D;EAC/D,4DAA2D;EAC3D,qDAAqD,EAAA;;AAIvD;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,4EAA4I;EpC4PxI,eAnE+B;EoCvLnC,oCAAgE;EAChE,gBAAgB;EAChB,4CAAqE;EACrE,SAAS;EjCrBP,gBiCsBsB;EACxB,qBAAqB;EjB1BjB,0CiB2B2E,EAAA;EjBvB3E;IiBUN;MjBTQ,gBAAgB,EAAA,EiByDvB;EAhDD;IAgBI,uCAAsE;IACtE,+CAA2E;IAC3E,kGAAgK,EAAA;IAlBpK;MAqBM,qDAAuF;MACvF,iDAAsF,EAAA;EAtB5F;IA4BI,cAAc;IACd,yCAA0E;IAC1E,0CAA2E;IAC3E,iBAAiB;IACjB,WAAW;IACX,8CAAyE;IACzE,4BAA4B;IAC5B,mDAAoF;IjBjDlF,mDiBkD+F,EAAA;IjB9C/F;MiBUN;QjBTQ,gBAAgB,EAAA,EiB8CrB;EArCH;IAwCI,UAAU,EAAA;EAxCd;IA4CI,UAAU;IACV,UAAU;IACV,oDAA2F,EAAA;;AAI/F;EACE,gBAAgB,EAAA;;AAGlB;EACE,gCAAwD;EACxD,wCAA6D;EAC7D,+EAA6I,EAAA;EAH/I;IjCxDI,yDiC8D4F;IjC7D5F,0DiC6D4F,EAAA;IANhG;MjCxDI,+DiCiE0G;MjChE1G,gEiCgE0G,EAAA;EAT9G;IAcI,aAAa,EAAA;EAdjB;IjC1CI,6DiC6D+F;IjC5D/F,4DiC4D+F,EAAA;IAnBnG;MjC1CI,mEiCiE+G;MjChE/G,kEiCgE+G,EAAA;IAvBnH;MjC1CI,6DiCsEiG;MjCrEjG,4DiCqEiG,EAAA;;AAKrG;EACE,8EAAgJ,EAAA;;AAQlJ;EAEI,eAAe;EACf,cAAc;EjC9Gd,gBiC+GwB,EAAA;EAJ5B;IAMoB,aAAa,EAAA;EANjC;IAOmB,gBAAgB,EAAA;EAPnC;;;IjC3GI,gBiCwH0B,EAAA;;AtC2jH9B;EsCljHM,iEAAmD;EACnD,wEAAiE,EAAA;;ACrJvE;EAEE,4BAAuD;EACvD,4BAAuD;EACvD,mCAA+D;EAE/D,oBAAyC;EACzC,+BAA+D;EAC/D,wDAA+D;EAC/D,sCAAiE;EACjE,4DAAuE;EAGvE,aAAa;EACb,eAAe;EACf,sEAAgI;EAChI,iDAAkF;ErC+Q9E,yCAnE+B;EqC1MnC,gBAAgB;EAChB,yCAA+D;ElCA7D,iDkCCwF,EAAA;;AAG5F;EAGI,iDAAmF,EAAA;EAHvF;IAMM,WAAW;IACX,kDAAoF;IACpF,yCAA0E;IAC1E,uFAAuN,EAAA;;AAT7N;EAcI,6CAAkF,EAAA;;ACrCtF;EAEE,kCAAuD;EACvD,mCAAuD;EtC4RnD,+BAnE+B;EsCvNnC,2CAA+C;EAC/C,qCAAyC;EACzC,oDAA6D;EAC7D,oDAA6D;EAC7D,sDAA+D;EAC/D,uDAA2D;EAC3D,+CAAqD;EACrD,0DAAyE;EACzE,uDAA2D;EAC3D,gDAAqD;EACrD,wEAAqE;EACrE,kCAA6D;EAC7D,kCAAuD;EACvD,4CAA2E;EAC3E,yDAAiE;EACjE,mDAA2D;EAC3D,6DAA+E;EAG/E,aAAa;EjCpBb,eAAe;EACf,gBAAgB,EAAA;;AiCuBlB;EACE,kBAAkB;EAClB,cAAc;EACd,sEAAgI;EtCgQ5H,yCAnE+B;EsC3LnC,iCAA0D;EAC1D,qBAAwD;EACxD,yCAA+D;EAC/D,iFAAiJ;EnBpB7I,qIjB4xCoJ,EAAA;EiBxxCpJ;ImBQN;MnBPQ,gBAAgB,EAAA,EmBiDvB;EA1CD;IAYI,UAAU;IACV,uCAAsE;IAEtE,+CAA2E;IAC3E,qDAA2F,EAAA;EAhB/F;IAoBI,UAAU;IACV,uCAAsE;IACtE,+CAA2E;IAC3E,UpC2uCiC;IoC1uCjC,iDAAqF,EAAA;EAxBzF;;IA6BI,UAAU;IACV,wCAAwE;IlBtD1E,gDkBuDkF;IAChF,sDAA6F,EAAA;EAhCjG;;IAqCI,0CAA4E;IAC5E,oBAAoB;IACpB,kDAAiF;IACjF,wDAAiG,EAAA;;AAIrG;EAEI,8CpC8sCsE,EAAA;;AoChtC1E;EnCvBI,0DmC+BoG;EnC9BpG,6DmC8BoG,EAAA;;AARxG;EnCrCI,2DmCmDkG;EnClDlG,8DmCkDkG,EAAA;;AAgBtG;EClGE,iCAAuD;EACvD,kCAAuD;EvC0RnD,kCAnE+B;EuCrNnC,yDAA+D,EAAA;;ADmGjE;ECtGE,iCAAuD;EACvD,kCAAuD;EvC0RnD,mCAnE+B;EuCrNnC,yDAA+D,EAAA;;ACFjE;EAEE,4BAA6C;EAC7C,4BAA6C;ExCuRzC,4BAnE+B;EwClNnC,2BAAiD;EACjD,sBAAqC;EACrC,iDAAqD;EAGrD,qBAAqB;EACrB,4DAA4G;ExC+QxG,oCAnE+B;EwC1MnC,wCAAkE;EAClE,cAAc;EACd,4BAAgD;EAChD,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;ErCJtB,4CqCK8E,EAAA;EAnBlF;IAwBI,aAAa,EAAA;;AAKjB;EACE,kBAAkB;EAClB,SAAS,EAAA;;AChCX;EAEE,0BAA+B;EAC/B,0BAA6C;EAC7C,0BAA6C;EAC7C,8BAAqD;EACrD,yBAAqC;EACrC,oCAAmD;EACnD,4EAAuC;EACvC,iDAAqD;EACrD,8BAA+C;EAG/C,kBAAkB;EAClB,4DAA4G;EAC5G,4CAAwE;EACxE,4BAAgD;EAChD,oCAAqD;EACrD,8BAAmD;EtCHjD,4CsCI8E,EAAA;;AAIlF;EAEE,cAAc,EAAA;;AAIhB;EACE,gBvC6kB+B;EuC5kB/B,iCAA0D,EAAA;;AAQ5D;EACE,mBvCs+CkD,EAAA;EuCv+CpD;IAKI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,UvCwZuC;IuCvZvC,qBvCqWS,EAAA;;AuC7VX;EACE,iDAAqC;EACrC,0CAA+B;EAC/B,wDAAmD;EACnD,sDAA+C,EAAA;;AAJjD;EACE,mDAAqC;EACrC,4CAA+B;EAC/B,0DAAmD;EACnD,wDAA+C,EAAA;;AAJjD;EACE,iDAAqC;EACrC,0CAA+B;EAC/B,wDAAmD;EACnD,sDAA+C,EAAA;;AAJjD;EACE,8CAAqC;EACrC,uCAA+B;EAC/B,qDAAmD;EACnD,mDAA+C,EAAA;;AAJjD;EACE,iDAAqC;EACrC,0CAA+B;EAC/B,wDAAmD;EACnD,sDAA+C,EAAA;;AAJjD;EACE,gDAAqC;EACrC,yCAA+B;EAC/B,uDAAmD;EACnD,qDAA+C,EAAA;;AAJjD;EACE,+CAAqC;EACrC,wCAA+B;EAC/B,sDAAmD;EACnD,oDAA+C,EAAA;;AAJjD;EACE,8CAAqC;EACrC,uCAA+B;EAC/B,qDAAmD;EACnD,mDAA+C,EAAA;;AC5DjD;EACE;IAAK,gDAAwE,EAAA,EAAA;;AAKjF;;EAGE,0BAA6C;E1CkRzC,gCAnE+B;E0C7MnC,wCAAqC;EACrC,oDAA2D;EAC3D,oDAAqD;EACrD,6BAAmD;EACnD,6BAA6C;EAC7C,6CAA6D;EAG7D,aAAa;EACb,iCAAyD;EACzD,gBAAgB;E1CsQZ,uCAnE+B;E0CjMnC,uCAA2D;EvCRzD,+CuCSoF,EAAA;;AAIxF;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,mCAA8D;EAC9D,kBAAkB;EAClB,mBAAmB;EACnB,2CAAmE;EvBxB/D,6CuByBiF,EAAA;EvBrBjF;IuBYN;MvBXQ,gBAAgB,EAAA,EuBqBvB;;AAED;EtBAE,qMAA6I;EsBE7I,oEAAoH,EAAA;;AAGtH;EACE,iBAAiB,EAAA;;AAGnB;EACE,WAAW,EAAA;;AAIX;EACE,kDAA8D,EAAA;EAG5D;IAJJ;MAKM,eAAe,EAAA,EAGpB;;AC9DH;EAEE,2CAA+C;EAC/C,qCAAyC;EACzC,oDAA6D;EAC7D,oDAA6D;EAC7D,sDAA+D;EAC/D,oCAAiE;EACjE,sCAAiE;EACjE,uDAA6D;EAC7D,4DAAyE;EACzE,sDAAmE;EACnE,yDAA2E;EAC3E,wDAAqE;EACrE,yDAAiE;EACjE,8CAA2D;EAC3D,kCAA6D;EAC7D,kCAAuD;EACvD,4CAA2E;EAG3E,aAAa;EACb,sBAAsB;EAGtB,eAAe;EACf,gBAAgB;ExCXd,iDwCYwF,EAAA;;AAG5F;EACE,qBAAqB;EACrB,sBAAsB,EAAA;EAFxB;IAMI,oCAAoC;IACpC,0BAA0B,EAAA;;AAQ9B;EACE,kBAAkB;EAClB,cAAc;EACd,gFAAoJ;EACpJ,iCAA0D;EAC1D,qBAAwD;EACxD,yCAA+D;EAC/D,iFAAiJ,EAAA;EAPnJ;IxCrBI,+BwC+BkC;IxC9BlC,gCwC8BkC,EAAA;EAVtC;IxCPI,mCwCqBqC;IxCpBrC,kCwCoBqC,EAAA;EAdzC;IAmBI,0CAA4E;IAC5E,oBAAoB;IACpB,kDAAiF,EAAA;EArBrF;IA0BI,UAAU;IACV,wCAAwE;IACxE,gDAA6E;IAC7E,sDAA6F,EAAA;EA7BjG;IAkCI,mBAAmB,EAAA;IAlCvB;MAqCM,wDAAwF;MACxF,mDAAmF,EAAA;;AAUzF;EACE,WAAW;EACX,wCAAwE;EACxE,mBAAmB,EAAA;EAHrB;IASM,UAAU;IACV,8CAAoF;IACpF,qBAAqB;IACrB,sDAAyF,EAAA;EAZ/F;IAgBM,+CAAsF;IACtF,uDAA2F,EAAA;;AAa7F;EACE,mBAAmB,EAAA;EADrB;IxCrDA,6DwC0D6G;IxCtE7G,0BwCuEsC,EAAA;EANtC;IxCjEA,2DwC2EwG;IxC/DxG,4BwCgE2C,EAAA;EAX3C;IAeM,aAAa,EAAA;EAfnB;IAmBM,mDAAmF;IACnF,oBAAoB,EAAA;IApB1B;MAuBQ,yDAAyF;MACzF,oDAAoF,EAAA;;AjCxF5F;EiCgEA;IACE,mBAAmB,EAAA;IADrB;MxCrDA,6DwC0D6G;MxCtE7G,0BwCuEsC,EAAA;IANtC;MxCjEA,2DwC2EwG;MxC/DxG,4BwCgE2C,EAAA;IAX3C;MAeM,aAAa,EAAA;IAfnB;MAmBM,mDAAmF;MACnF,oBAAoB,EAAA;MApB1B;QAuBQ,yDAAyF;QACzF,oDAAoF,EAAA,EACrF;;AjCzFP;EiCgEA;IACE,mBAAmB,EAAA;IADrB;MxCrDA,6DwC0D6G;MxCtE7G,0BwCuEsC,EAAA;IANtC;MxCjEA,2DwC2EwG;MxC/DxG,4BwCgE2C,EAAA;IAX3C;MAeM,aAAa,EAAA;IAfnB;MAmBM,mDAAmF;MACnF,oBAAoB,EAAA;MApB1B;QAuBQ,yDAAyF;QACzF,oDAAoF,EAAA,EACrF;;AjCzFP;EiCgEA;IACE,mBAAmB,EAAA;IADrB;MxCrDA,6DwC0D6G;MxCtE7G,0BwCuEsC,EAAA;IANtC;MxCjEA,2DwC2EwG;MxC/DxG,4BwCgE2C,EAAA;IAX3C;MAeM,aAAa,EAAA;IAfnB;MAmBM,mDAAmF;MACnF,oBAAoB,EAAA;MApB1B;QAuBQ,yDAAyF;QACzF,oDAAoF,EAAA,EACrF;;AjCzFP;EiCgEA;IACE,mBAAmB,EAAA;IADrB;MxCrDA,6DwC0D6G;MxCtE7G,0BwCuEsC,EAAA;IANtC;MxCjEA,2DwC2EwG;MxC/DxG,4BwCgE2C,EAAA;IAX3C;MAeM,aAAa,EAAA;IAfnB;MAmBM,mDAAmF;MACnF,oBAAoB,EAAA;MApB1B;QAuBQ,yDAAyF;QACzF,oDAAoF,EAAA,EACrF;;AjCzFP;EiCgEA;IACE,mBAAmB,EAAA;IADrB;MxCrDA,6DwC0D6G;MxCtE7G,0BwCuEsC,EAAA;IANtC;MxCjEA,2DwC2EwG;MxC/DxG,4BwCgE2C,EAAA;IAX3C;MAeM,aAAa,EAAA;IAfnB;MAmBM,mDAAmF;MACnF,oBAAoB,EAAA;MApB1B;QAuBQ,yDAAyF;QACzF,oDAAoF,EAAA,EACrF;;AAaX;ExClJI,gBwCmJsB,EAAA;EAD1B;IAII,mDAAmF,EAAA;IAJvF;MAOM,sBAAsB,EAAA;;AAa1B;EACE,sDAA+C;EAC/C,+CAAyC;EACzC,6DAA6D;EAC7D,4DAAyE;EACzE,gEAAmE;EACnE,6DAA2E;EAC3E,iEAAqE;EACrE,yDAA6D;EAC7D,0DAAuD;EACvD,oEAA2E,EAAA;;AAV7E;EACE,wDAA+C;EAC/C,iDAAyC;EACzC,+DAA6D;EAC7D,4DAAyE;EACzE,kEAAmE;EACnE,6DAA2E;EAC3E,mEAAqE;EACrE,2DAA6D;EAC7D,4DAAuD;EACvD,sEAA2E,EAAA;;AAV7E;EACE,sDAA+C;EAC/C,+CAAyC;EACzC,6DAA6D;EAC7D,4DAAyE;EACzE,gEAAmE;EACnE,6DAA2E;EAC3E,iEAAqE;EACrE,yDAA6D;EAC7D,0DAAuD;EACvD,oEAA2E,EAAA;;AAV7E;EACE,mDAA+C;EAC/C,4CAAyC;EACzC,0DAA6D;EAC7D,4DAAyE;EACzE,6DAAmE;EACnE,6DAA2E;EAC3E,8DAAqE;EACrE,sDAA6D;EAC7D,uDAAuD;EACvD,iEAA2E,EAAA;;AAV7E;EACE,sDAA+C;EAC/C,+CAAyC;EACzC,6DAA6D;EAC7D,4DAAyE;EACzE,gEAAmE;EACnE,6DAA2E;EAC3E,iEAAqE;EACrE,yDAA6D;EAC7D,0DAAuD;EACvD,oEAA2E,EAAA;;AAV7E;EACE,qDAA+C;EAC/C,8CAAyC;EACzC,4DAA6D;EAC7D,4DAAyE;EACzE,+DAAmE;EACnE,6DAA2E;EAC3E,gEAAqE;EACrE,wDAA6D;EAC7D,yDAAuD;EACvD,mEAA2E,EAAA;;AAV7E;EACE,oDAA+C;EAC/C,6CAAyC;EACzC,2DAA6D;EAC7D,4DAAyE;EACzE,8DAAmE;EACnE,6DAA2E;EAC3E,+DAAqE;EACrE,uDAA6D;EAC7D,wDAAuD;EACvD,kEAA2E,EAAA;;AAV7E;EACE,mDAA+C;EAC/C,4CAAyC;EACzC,0DAA6D;EAC7D,4DAAyE;EACzE,6DAAmE;EACnE,6DAA2E;EAC3E,8DAAqE;EACrE,sDAA6D;EAC7D,uDAAuD;EACvD,iEAA2E,EAAA;;AC9L/E;EAEE,0BAA6C;EAC7C,2DAAuC;EACvC,2BAAiD;EACjD,kCAA6D;EAC7D,mEAA2D;EAC3D,+BAA6D;EAC7D,qCAAmE;EAGnE,uBAAuB;EACvB,U1CupD8B;E0CtpD9B,W1CspD8B;E0CrpD9B,sB1CupDgC;E0CtpDhC,gCAAwD;EACxD,wEAA4G;EAC5G,kCAA2D;EAC3D,SAAS;EzCJP,uBD+gBiC;E0CzgBnC,oCAA8D,EAAA;EApBhE;IAwBI,gCAAwD;IACxD,qBAAqB;IACrB,0CAA0E,EAAA;EA1B9E;IA8BI,UAAU;IACV,4CAA2E;IAC3E,0CAA0E,EAAA;EAhC9E;IAqCI,oBAAoB;IACpB,yBAAiB;YAAjB,iBAAiB;IACjB,6CAAgF,EAAA;;AAQpF;EAHE,iEAA+C,EAAA;;A7CjDjD;;E6C0DE,uBAA+C,EAAA;;A9CguIjD;E8CzuIE,iEAA+C,EAAA;;ACjDjD;EAEE,uBAAuC;EACvC,6BAA6C;EAC7C,4BAA6C;EAC7C,0BAAyC;EACzC,2BAA6C;E7CyRzC,8BAnE+B;E6CpNnC,kBAAqC;EACrC,gDAA+B;EAC/B,+CAAmD;EACnD,2DAAmD;EACnD,iDAAqD;EACrD,2CAA+C;EAC/C,kDAAmD;EACnD,uDAA6C;EAC7C,kEAAiE;EAGjE,gCAAwD;EACxD,eAAe;E7C2QX,oCAnE+B;E6CtMnC,4BAAgD;EAChD,oBAAoB;EACpB,oCAAqD;EACrD,4BAA4B;EAC5B,uEAA6H;EAC7H,sCAA+D;E1CR7D,4C0CS8E,EAAA;EA5BlF;IA+BI,UAAU,EAAA;EA/Bd;IAmCI,aAAa,EAAA;;AAIjB;EACE,uBAAuC;EAEvC,kBAAkB;EAClB,+BAAoD;EACpD,kBAAkB;EAClB,eAAe;EACf,oBAAoB,EAAA;EAPtB;IAUI,sCAA4D,EAAA;;AAIhE;EACE,aAAa;EACb,mBAAmB;EACnB,4DAA4G;EAC5G,mCAA8D;EAC9D,2CAAmE;EACnE,4BAA4B;EAC5B,qFAAkJ;E1ChChJ,0F0CiCkJ;E1ChClJ,2F0CgCkJ,EAAA;EARtJ;IAWI,mDAA2E;IAC3E,sCAA8D,EAAA;;AAIlE;EACE,kCAA0D;EAC1D,qBAAqB,EAAA;;AC9DvB;EAEE,uBAAuC;EACvC,uBAAqC;EACrC,wBAAyC;EACzC,yBAAuC;EACvC,sCAAqC;EACrC,gCAA+B;EAC/B,2DAAmD;EACnD,+CAAmD;EACnD,oDAAqD;EACrD,8CAA+C;EAC/C,2FAAiE;EACjE,iCAA2D;EAC3D,iCAA2D;EAC3D,oCAAuD;EACvD,sDAAiE;EACjE,sDAAiE;EACjE,iCAA6D;EAC7D,6BAA+C;EAC/C,sBAA6C;EAC7C,sDAAiE;EACjE,sDAAiE;EAGjE,eAAe;EACf,MAAM;EACN,OAAO;EACP,+BAAoD;EACpD,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAGhB,UAAU,EAAA;;AAOZ;EACE,kBAAkB;EAClB,WAAW;EACX,8BAAmD;EAEnD,oBAAoB,EAAA;EAGpB;IACE,8B5Cm8CmD;IiBh/CjD,mCjBk/CoD,EAAA;IiB9+CpD;M2BwCJ;Q3BvCM,gBAAgB,EAAA,E2B0CrB;EACD;IACE,e5Cg8CoC,EAAA;E4C57CtC;IACE,sB5C67C2C,EAAA;;A4Cz7C/C;EACE,+CAAoE,EAAA;EADtE;IAII,gBAAgB;IAChB,gBAAgB,EAAA;EALpB;IASI,gBAAgB,EAAA;;AAIpB;EACE,aAAa;EACb,mBAAmB;EACnB,mDAAwE,EAAA;;AAI1E;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EAEX,4BAAgD;EAChD,oBAAoB;EACpB,oCAAqD;EACrD,4BAA4B;EAC5B,uEAA6H;E3CrF3H,4C2CsF8E;EAGhF,UAAU,EAAA;;AAIZ;EAEE,0BAA6C;EAC7C,sBAAqC;EACrC,0BAA+C;EClH/C,eAAe;EACf,MAAM;EACN,OAAO;EACP,kCDkH2E;ECjH3E,YAAY;EACZ,aAAa;EACb,uCD+GsH,EAAA;EC5GtH;IAAS,UAAU,EAAA;EACnB;IAAS,mCD2GkK,EAAA;;AAK7K;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,uCAAoE;EACpE,4FAAgK;E3CrG9J,2D2CsG8F;E3CrG9F,4D2CqG8F,EAAA;EANlG;IASI,gGAA8J;IAE9J,wDAAuF;IACvF,0DAAyF;IACzF,2DAA0F;IAC1F,iBAAiB,EAAA;;AAKrB;EACE,gBAAgB;EAChB,8CAA8E,EAAA;;AAKhF;EACE,kBAAkB;EAGlB,cAAc;EACd,gCAAsD,EAAA;;AAIxD;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,wEAAuH;EACvH,2CAAmE;EACnE,yFAA6J;E3C7H3J,+D2C8HiG;E3C7HjG,8D2C6HiG,EAAA;EATrG;IAeI,6CAAsE,EAAA;;ApC/GtE;EoCtDJ;IA4KI,0BAAuC;IACvC,2CAA+C,EAAA;EAlInD;IAuII,gCAAoD;IACpD,kBAAkB;IAClB,iBAAiB,EAAA;EAGnB;IACE,uBAAqC,EAAA,EACtC;;ApCnIC;EoCuIF;;IAEE,uBAAqC,EAAA,EACtC;;ApC1IC;EoC8IF;IACE,wBAAqC,EAAA,EACtC;;AASC;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,SAAS,EAAA;EAJX;IAOI,YAAY;IACZ,SAAS;I3C7Mb,gB2C8M4B,EAAA;EAT5B;;I3CrMA,gB2CmN4B,EAAA;EAd5B;IAkBI,gBAAgB,EAAA;;ApC9JpB;EoC4IA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M3C7Mb,gB2C8M4B,EAAA;IAT5B;;M3CrMA,gB2CmN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;ApC/JH;EoC4IA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M3C7Mb,gB2C8M4B,EAAA;IAT5B;;M3CrMA,gB2CmN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;ApC/JH;EoC4IA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M3C7Mb,gB2C8M4B,EAAA;IAT5B;;M3CrMA,gB2CmN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;ApC/JH;EoC4IA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M3C7Mb,gB2C8M4B,EAAA;IAT5B;;M3CrMA,gB2CmN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;ApC/JH;EoC4IA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M3C7Mb,gB2C8M4B,EAAA;IAT5B;;M3CrMA,gB2CmN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;AE1OP;EAEE,yBAA2C;EAC3C,6BAAiD;EACjD,8BAAiD;EACjD,+BAAiD;EACjD,qBAA2C;EhDwRvC,gCAnE+B;EgDnNnC,qCAAyC;EACzC,yCAAmC;EACnC,mDAAyD;EACzD,yBAA6C;EAC7C,gCAAqD;EACrD,iCAAuD;EAGvD,iCAAwD;EACxD,cAAc;EACd,gCAAuD;EClBvD,sC/C+lB6E;E+C7lB7E,kBAAkB;EAClB,gB/CwmB+B;E+CvmB/B,gB/C+mB+B;E+C9mB/B,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EjDgRZ,sCAnE+B;EgDlMnC,qBAAqB;EACrB,UAAU,EAAA;EA1BZ;IA4BW,kCAA0D,EAAA;EA5BrE;IA+BI,cAAc;IACd,oCAAgE;IAChE,sCAAmE,EAAA;IAjCvE;MAoCM,kBAAkB;MAClB,WAAW;MACX,yBAAyB;MACzB,mBAAmB,EAAA;;AAKzB;EACE,iDAA8E,EAAA;EADhF;IAII,SAAS;IACT,uFAAgJ;IAChJ,sCAAyD,EAAA;;AAI7D,qBAAA;AACA;EACE,+CAA4E;EAC5E,qCAAkE;EAClE,qCAAiE,EAAA;EAHnE;IAMI,WAAW;IACX,gIAAqN;IACrN,wCAA2D,EAAA;;AAI/D,mBAAA;AAEA;EACE,8CAA2E,EAAA;EAD7E;IAII,YAAY;IACZ,uFAAgJ;IAChJ,yCAA4D,EAAA;;AAIhE,qBAAA;AACA;EACE,gDAA6E;EAC7E,qCAAkE;EAClE,qCAAiE,EAAA;EAHnE;IAMI,UAAU;IACV,gIAAqN;IACrN,uCAA0D,EAAA;;AAI9D,mBAAA;AAkBA;EACE,sCAAgE;EAChE,gEAAoH;EACpH,8BAAoD;EACpD,kBAAkB;EAClB,sCAAyD;E7CjGvD,8C6CkGkF,EAAA;;AErHtF;EAEE,yBAA2C;EAC3C,6BAAiD;ElD4R7C,gCAnE+B;EkDvNnC,kCAAmC;EACnC,iDAAuD;EACvD,6DAAuD;EACvD,sDAAyD;EACzD,2FAAqE;EACrE,6CAAmD;EACnD,mCAA+D;EAC/D,qCAA+D;ElDmR3D,mCAnE+B;EkD9MnC,kCAAuD;EACvD,8CAAiD;EACjD,iCAA2D;EAC3D,iCAA2D;EAC3D,6CAAmD;EACnD,8BAAqD;EACrD,iCAAuD;EACvD,yDAAuD;EAGvD,iCAAwD;EACxD,cAAc;EACd,sCAAgE;EDzBhE,sC/C+lB6E;E+C7lB7E,kBAAkB;EAClB,gB/CwmB+B;E+CvmB/B,gB/C+mB+B;E+C9mB/B,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EjDgRZ,sCAnE+B;EkD5LnC,qBAAqB;EACrB,sCAAyD;EACzD,4BAA4B;EAC5B,2EAAqI;E/ChBnI,8C+CiBkF,EAAA;EApCtF;IAwCI,cAAc;IACd,oCAAgE;IAChE,sCAAmE,EAAA;IA1CvE;MA8CM,kBAAkB;MAClB,cAAc;MACd,WAAW;MACX,yBAAyB;MACzB,mBAAmB;MACnB,eAAe,EAAA;;AAKrB;EAEI,oFAA8I,EAAA;EAFlJ;IAMM,uFAAgJ,EAAA;EANtJ;IAUM,SAAS;IACT,gDAA6E,EAAA;EAXnF;IAeM,sCAAmE;IACnE,sCAAyD,EAAA;;AAK/D,qBAAA;AACA;EAEI,kFAA4I;EAC5I,qCAAkE;EAClE,qCAAiE,EAAA;EAJrE;IAQM,gIAAqN,EAAA;EAR3N;IAYM,OAAO;IACP,kDAA+E,EAAA;EAbrF;IAiBM,oCAAiE;IACjE,wCAA2D,EAAA;;AAKjE,mBAAA;AAEA;EAEI,iFAA2I,EAAA;EAF/I;IAMM,uFAAgJ,EAAA;EANtJ;IAUM,MAAM;IACN,mDAAgF,EAAA;EAXtF;IAeM,mCAAgE;IAChE,yCAA4D,EAAA;;AAhBlE;EAsBI,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,cAAc;EACd,oCAAgE;EAChE,sDAAkF;EAClF,WAAW;EACX,+EAAsI,EAAA;;AAI1I,qBAAA;AACA;EAEI,mFAA6I;EAC7I,qCAAkE;EAClE,qCAAiE,EAAA;EAJrE;IAQM,gIAAqN,EAAA;EAR3N;IAYM,QAAQ;IACR,iDAA8E,EAAA;EAbpF;IAiBM,qCAAkE;IAClE,uCAA0D,EAAA;;AAKhE,mBAAA;AAkBA;EACE,8EAAgJ;EAChJ,gBAAgB;ElD2GZ,6CAnE+B;EkDtCnC,qCAAkE;EAClE,6CAAuE;EACvE,kFAA4I;E/C5J1I,6D+C6JkG;E/C5JlG,8D+C4JkG,EAAA;EAPtG;IAUI,aAAa,EAAA;;AAIjB;EACE,0EAAwI;EACxI,mCAA8D,EAAA;;ACrLhE;EACE,kBAAkB,EAAA;;AAGpB;EACE,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB,EAAA;ECtBhB;IACE,cAAc;IACd,WAAW;IACX,WAAW,EAAA;;ADuBf;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EhClBvB,sCjB4nDkF,EAAA;EiBxnDlF;IgCQN;MhCPQ,gBAAgB,EAAA,EgCevB;;AAED;;;EAGE,cAAc,EAAA;;AAGhB;;EAEE,2BAA2B,EAAA;;AAG7B;;EAEE,4BAA4B,EAAA;;AAQ9B;EAEI,UAAU;EACV,4BAA4B;EAC5B,eAAe,EAAA;;AAJnB;;;EAUI,UAAU;EACV,UAAU,EAAA;;AAXd;;EAgBI,UAAU;EACV,UAAU;EhC5DR,2BjB2nDkC,EAAA;EiBvnDlC;IgCuCN;;MhCtCQ,gBAAgB,EAAA,EgCyDrB;;AAQH;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EAEV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UjDkhDsC;EiDjhDtC,UAAU;EACV,WjD1Fa;EiD2Fb,kBAAkB;EAClB,gBAAgB;EAChB,8CAAmF;EACnF,SAAS;EACT,YjD4gDqC;EiBnmDjC,8BjBqmDgD,EAAA;EiBjmDhD;IgCkEN;;MhCjEQ,gBAAgB,EAAA,EgC6FvB;EA5BD;;;IAuBI,WjDrGW;IiDsGX,qBAAqB;IACrB,UAAU;IACV,YjDogDmC,EAAA;;AiDjgDvC;EACE,OAAO,EAAA;;AAGT;EACE,QAAQ,EAAA;;AAKV;;EAEE,qBAAqB;EACrB,WjDsgDuC;EiDrgDvC,YjDqgDuC;EiDpgDvC,4BAA4B;EAC5B,wBAAwB;EACxB,0BAA0B,EAAA;;AAG5B;EACE,0TAA4H,EAAA;;AAE9H;EACE,yTAA4H,EAAA;;AAQ9H;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,UAAU;EAEV,iBjDq9CsC;EiDp9CtC,mBAAmB;EACnB,gBjDm9CsC,EAAA;EiD/9CxC;IAeI,uBAAuB;IACvB,cAAc;IACd,WjDo9CqC;IiDn9CrC,WjDo9CoC;IiDn9CpC,UAAU;IACV,iBjDo9CoC;IiDn9CpC,gBjDm9CoC;IiDl9CpC,mBAAmB;IACnB,eAAe;IACf,wDAA6F;IAC7F,4BAA4B;IAC5B,SAAS;IAET,kCAAiE;IACjE,qCAAoE;IACpE,YjD28CmC;IiB5mDjC,6BjB+mD+C,EAAA;IiB3mD/C;MgC+HN;QhC9HQ,gBAAgB,EAAA,EgC8JrB;EAhCH;IAmCI,UjDw8CkC,EAAA;;AiD/7CtC;EACE,kBAAkB;EAClB,UAA4C;EAC5C,ejDk8C0C;EiDj8C1C,SAA2C;EAC3C,oBjD+7C0C;EiD97C1C,uBjD87C0C;EiD77C1C,uCAAsE;EACtE,kBAAkB,EAAA;;AAWpB;EALE,uCAAuE;EACvE,iCAA2D;EAC3D,2DAAuE,EAAA;;ApD/MzE;;EoDwNE,uCAAuE;EACvE,iCAA2D;EAC3D,mCAAuE,EAAA;;ArDyvJzE;EqDtwJE,uCAAuE;EACvE,iCAA2D;EAC3D,2DAAuE,EAAA;;AE3MzE;;EAEE,qBAAqB;EACrB,8BAAoD;EACpD,gCAAuD;EACvD,gDAA+E;EAE/E,kBAAkB;EAClB,6FAA4J,EAAA;;AAI9J;EACE;IAAK,0CAA+C,EAAA,EAAA;;AAItD;EAEE,wBAAyC;EACzC,yBAA2C;EAC3C,qCAA2D;EAC3D,iCAAuD;EACvD,mCAA6D;EAC7D,2CAA2D;EAG3D,yDAAsF;EACtF,+BAA+B,EAAA;;AAGjC;EAEE,wBAAyC;EACzC,yBAA2C;EAC3C,gCAAuD,EAAA;;AASzD;EACE;IACE,mBAAmB,EAAA;EAErB;IACE,UAAU;IACV,eAAe,EAAA,EAAA;;AAKnB;EAEE,wBAAyC;EACzC,yBAA2C;EAC3C,qCAA2D;EAC3D,mCAA6D;EAC7D,yCAA2D;EAG3D,8BAA8B;EAC9B,UAAU,EAAA;;AAGZ;EACE,wBAAyC;EACzC,yBAA2C,EAAA;;AAI3C;EACE;;IAEE,kCAA6D,EAAA,EAC9D;;AChFL;EAEE,2BAA+C;EAC/C,2BAA6C;EAC7C,2BAA+C;EAC/C,8BAAqD;EACrD,8BAAqD;EACrD,0CAA6C;EAC7C,oCAAuC;EACvC,mDAA2D;EAC3D,+DAA2D;EAC3D,kDAAuD;EACvD,qDAAuD;EACvD,qCAAqE,EAAA;;A5C6DnE;E4C5CF;IAEI,eAAe;IACf,SAAS;IACT,mCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAwD;IACxD,kBAAkB;IAClB,wCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;InC5BV,0CmC8B+E,EAAA,EAqElF;EnC/FG;ImCYJ;MnCXM,gBAAgB,EAAA,EmC8FrB;;A5CvCC;I4C5CF;MAiBM,MAAM;MACN,OAAO;MACP,gCAAwD;MACxD,qFAAmJ;MACnJ,4BAA4B,EAAA;IArBlC;MAyBM,MAAM;MACN,QAAQ;MACR,gCAAwD;MACxD,oFAAkJ;MAClJ,2BAA2B,EAAA;IA7BjC;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,sFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,mFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,eAAe,EAAA;IArDrB;MA2DM,mBAAmB,EAAA,EACpB;;A5C7BH;E4C/BF;IAiEM,2BAA+C;IAC/C,8BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;A5CpCL;E4C5CF;IAEI,eAAe;IACf,SAAS;IACT,mCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAwD;IACxD,kBAAkB;IAClB,wCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;InC5BV,0CmC8B+E,EAAA,EAqElF;EnC/FG;ImCYJ;MnCXM,gBAAgB,EAAA,EmC8FrB;;A5CvCC;I4C5CF;MAiBM,MAAM;MACN,OAAO;MACP,gCAAwD;MACxD,qFAAmJ;MACnJ,4BAA4B,EAAA;IArBlC;MAyBM,MAAM;MACN,QAAQ;MACR,gCAAwD;MACxD,oFAAkJ;MAClJ,2BAA2B,EAAA;IA7BjC;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,sFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,mFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,eAAe,EAAA;IArDrB;MA2DM,mBAAmB,EAAA,EACpB;;A5C7BH;E4C/BF;IAiEM,2BAA+C;IAC/C,8BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;A5CpCL;E4C5CF;IAEI,eAAe;IACf,SAAS;IACT,mCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAwD;IACxD,kBAAkB;IAClB,wCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;InC5BV,0CmC8B+E,EAAA,EAqElF;EnC/FG;ImCYJ;MnCXM,gBAAgB,EAAA,EmC8FrB;;A5CvCC;I4C5CF;MAiBM,MAAM;MACN,OAAO;MACP,gCAAwD;MACxD,qFAAmJ;MACnJ,4BAA4B,EAAA;IArBlC;MAyBM,MAAM;MACN,QAAQ;MACR,gCAAwD;MACxD,oFAAkJ;MAClJ,2BAA2B,EAAA;IA7BjC;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,sFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,mFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,eAAe,EAAA;IArDrB;MA2DM,mBAAmB,EAAA,EACpB;;A5C7BH;E4C/BF;IAiEM,2BAA+C;IAC/C,8BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;A5CpCL;E4C5CF;IAEI,eAAe;IACf,SAAS;IACT,mCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAwD;IACxD,kBAAkB;IAClB,wCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;InC5BV,0CmC8B+E,EAAA,EAqElF;EnC/FG;ImCYJ;MnCXM,gBAAgB,EAAA,EmC8FrB;;A5CvCC;I4C5CF;MAiBM,MAAM;MACN,OAAO;MACP,gCAAwD;MACxD,qFAAmJ;MACnJ,4BAA4B,EAAA;IArBlC;MAyBM,MAAM;MACN,QAAQ;MACR,gCAAwD;MACxD,oFAAkJ;MAClJ,2BAA2B,EAAA;IA7BjC;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,sFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,mFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,eAAe,EAAA;IArDrB;MA2DM,mBAAmB,EAAA,EACpB;;A5C7BH;E4C/BF;IAiEM,2BAA+C;IAC/C,8BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;A5CpCL;E4C5CF;IAEI,eAAe;IACf,SAAS;IACT,mCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAwD;IACxD,kBAAkB;IAClB,wCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;InC5BV,0CmC8B+E,EAAA,EAqElF;EnC/FG;ImCYJ;MnCXM,gBAAgB,EAAA,EmC8FrB;;A5CvCC;I4C5CF;MAiBM,MAAM;MACN,OAAO;MACP,gCAAwD;MACxD,qFAAmJ;MACnJ,4BAA4B,EAAA;IArBlC;MAyBM,MAAM;MACN,QAAQ;MACR,gCAAwD;MACxD,oFAAkJ;MAClJ,2BAA2B,EAAA;IA7BjC;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,sFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,mFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,eAAe,EAAA;IArDrB;MA2DM,mBAAmB,EAAA,EACpB;;A5C7BH;E4C/BF;IAiEM,2BAA+C;IAC/C,8BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;AAhFP;EAEI,eAAe;EACf,SAAS;EACT,mCAA4D;EAC5D,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gCAAwD;EACxD,kBAAkB;EAClB,wCAA6D;EAC7D,4BAA4B;EAC5B,UAAU;EnC5BV,0CmC8B+E,EAAA;EnC1B/E;ImCYJ;MnCXM,gBAAgB,EAAA,EmC8FrB;EAnFD;IAiBM,MAAM;IACN,OAAO;IACP,gCAAwD;IACxD,qFAAmJ;IACnJ,4BAA4B,EAAA;EArBlC;IAyBM,MAAM;IACN,QAAQ;IACR,gCAAwD;IACxD,oFAAkJ;IAClJ,2BAA2B,EAAA;EA7BjC;IAiCM,MAAM;IACN,QAAQ;IACR,OAAO;IACP,kCAA2D;IAC3D,gBAAgB;IAChB,sFAAoJ;IACpJ,4BAA4B,EAAA;EAvClC;IA2CM,QAAQ;IACR,OAAO;IACP,kCAA2D;IAC3D,gBAAgB;IAChB,mFAAiJ;IACjJ,2BAA2B,EAAA;EAhDjC;IAqDM,eAAe,EAAA;EArDrB;IA2DM,mBAAmB,EAAA;;AA2B3B;EPpHE,eAAe;EACf,MAAM;EACN,OAAO;EACP,a7C0mCsC;E6CzmCtC,YAAY;EACZ,aAAa;EACb,sB7CUa,EAAA;E6CPb;IAAS,UAAU,EAAA;EACnB;IAAS,Y7Cm+C2B,EAAA;;AoDr3CtC;EACE,aAAa;EACb,mBAAmB;EACnB,oEAA4H,EAAA;EAH9H;IAMI,0FAAkJ;IAElJ,qDAAiF;IACjF,uDAAmF;IACnF,wDAAoF;IACpF,iBAAiB,EAAA;;AAIrB;EACE,gBAAgB;EAChB,kDAAsF,EAAA;;AAGxF;EACE,YAAY;EACZ,oEAA4H;EAC5H,gBAAgB,EAAA;;ACjJlB;EACE,qBAAqB;EACrB,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;EAC9B,YrDgzCoC,EAAA;EqDtzCtC;IASI,qBAAqB;IACrB,WAAW,EAAA;;AAKf;EACE,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB,EAAA;;AAGlB;EACE,iBAAiB,EAAA;;AAInB;EAEI,mDAAmD,EAAA;;AAIvD;EACE;IACE,YrDmxCkC,EAAA,EAAA;;AqD/wCtC;EACE,+EAA8G;EAC9G,oBAAoB;EACpB,8CAA8C,EAAA;;AAGhD;EACE;IACE,uBAAuB,EAAA,EAAA;;AH9CzB;EACE,cAAc;EACd,WAAW;EACX,WAAW,EAAA;;AIHb;EACE,sBAAwE;EACxE,iFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,mFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,iFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,8EAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,iFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,gFAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,+EAAmJ,EAAA;;AAFrJ;EACE,sBAAwE;EACxE,8EAAmJ,EAAA;;ACFrJ;EACE,wEAA4I;EAC5I,kGAAgL,EAAA;EAFlL;IAQM,8DAA+H;IAC/H,wFAAgK,EAAA;;AATtK;EACE,0EAA4I;EAC5I,oGAAgL,EAAA;EAFlL;IAQM,8DAA+H;IAC/H,wFAAgK,EAAA;;AATtK;EACE,wEAA4I;EAC5I,kGAAgL,EAAA;EAFlL;IAQM,8DAA+H;IAC/H,wFAAgK,EAAA;;AATtK;EACE,qEAA4I;EAC5I,+FAAgL,EAAA;EAFlL;IAQM,+DAA+H;IAC/H,yFAAgK,EAAA;;AATtK;EACE,wEAA4I;EAC5I,kGAAgL,EAAA;EAFlL;IAQM,+DAA+H;IAC/H,yFAAgK,EAAA;;AATtK;EACE,uEAA4I;EAC5I,iGAAgL,EAAA;EAFlL;IAQM,8DAA+H;IAC/H,wFAAgK,EAAA;;AATtK;EACE,sEAA4I;EAC5I,gGAAgL,EAAA;EAFlL;IAQM,gEAA+H;IAC/H,0FAAgK,EAAA;;AATtK;EACE,qEAA4I;EAC5I,+FAAgL,EAAA;EAFlL;IAQM,6DAA+H;IAC/H,uFAAgK,EAAA;;AAOxK;EACE,+EAA+J;EAC/J,yGAAmM,EAAA;EAFrM;IAOM,kFAAiK;IACjK,4GAAqM,EAAA;;AC1B3M;EACE,UAAU;EAEV,kJAAsQ,EAAA;;ACHxQ;EACE,oBAAoB;EACpB,azD6cmC;EyD5cnC,mBAAmB;EACnB,kFAA6H;EAC7H,6BzD2ciC;EyD1cjC,2BAA2B,EAAA;EAN7B;IASI,cAAc;IACd,UzDuc6B;IyDtc7B,WzDsc6B;IyDrc7B,kBAAkB;IxCIhB,sCjBkciD,EAAA;IiB9bjD;MwCpBN;QxCqBQ,gBAAgB,EAAA,EwCPrB;;AAGH;EAIM,mEAA+F,EAAA;;ACnBrG;EACE,kBAAkB;EAClB,WAAW,EAAA;EAFb;IAKI,cAAc;IACd,mCAAwD;IACxD,WAAW,EAAA;EAPf;IAWI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY,EAAA;;AAKd;EACE,uBAAuC,EAAA;;AADzC;EACE,qCAAuC,EAAA;;AADzC;EACE,sCAAuC,EAAA;;AADzC;EACE,sCAAuC,EAAA;;ACrB3C;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,a3DumCsC,EAAA;;A2DpmCxC;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,OAAO;EACP,a3D+lCsC,EAAA;;A2DvlCpC;EACE,gBAAgB;EAChB,MAAM;EACN,a3DmlCkC,EAAA;;A2DhlCpC;EACE,gBAAgB;EAChB,SAAS;EACT,a3D6kCkC,EAAA;;AQ9iCpC;EmDxCA;IACE,gBAAgB;IAChB,MAAM;IACN,a3DmlCkC,EAAA;E2DhlCpC;IACE,gBAAgB;IAChB,SAAS;IACT,a3D6kCkC,EAAA,E2D5kCnC;;AnD8BD;EmDxCA;IACE,gBAAgB;IAChB,MAAM;IACN,a3DmlCkC,EAAA;E2DhlCpC;IACE,gBAAgB;IAChB,SAAS;IACT,a3D6kCkC,EAAA,E2D5kCnC;;AnD8BD;EmDxCA;IACE,gBAAgB;IAChB,MAAM;IACN,a3DmlCkC,EAAA;E2DhlCpC;IACE,gBAAgB;IAChB,SAAS;IACT,a3D6kCkC,EAAA,E2D5kCnC;;AnD8BD;EmDxCA;IACE,gBAAgB;IAChB,MAAM;IACN,a3DmlCkC,EAAA;E2DhlCpC;IACE,gBAAgB;IAChB,SAAS;IACT,a3D6kCkC,EAAA,E2D5kCnC;;AnD8BD;EmDxCA;IACE,gBAAgB;IAChB,MAAM;IACN,a3DmlCkC,EAAA;E2DhlCpC;IACE,gBAAgB;IAChB,SAAS;IACT,a3D6kCkC,EAAA,E2D5kCnC;;AChCL;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,mBAAmB,EAAA;;ACRrB;;ECIE,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,8BAA8B;EAC9B,oBAAoB,EAAA;EAGpB;;IACE,6BAA6B,EAAA;EAI/B;;IACE,2BAA2B,EAAA;;ACpB/B;EAEI,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,U/DgcuC;E+D/bvC,WAAW,EAAA;;ACRf;ECAE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;ACNrB;EACE,qBAAqB;EACrB,mBAAmB;EACnB,6BlEisBuE;EkEhsBvE,eAAe;EACf,8BAA8B;EAC9B,alE2rB+B,EAAA;;AmE/nBzB;EAOI,mCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,mCAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,2CAA+D,EAAA;;AAPnE;EAOI,8CAA+D,EAAA;;AAPnE;EAOI,8CAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAjBnE;EACE,gFAAoC,EAAA;;AADtC;EACE,kFAAoC,EAAA;;AADtC;EACE,gFAAoC,EAAA;;AADtC;EACE,6EAAoC,EAAA;;AADtC;EACE,gFAAoC,EAAA;;AADtC;EACE,+EAAoC,EAAA;;AADtC;EACE,8EAAoC,EAAA;;AADtC;EACE,6EAAoC,EAAA;;AAStC;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,iBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,kBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,2CAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,uFAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,2FAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,6FAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,8FAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,4FAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,gFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,6EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAOI,wDAA+D,EAAA;;AAPnE;EAOI,0DAA+D,EAAA;;AAPnE;EAOI,wDAA+D,EAAA;;AAPnE;EAOI,qDAA+D,EAAA;;AAPnE;EAOI,wDAA+D,EAAA;;AAPnE;EAOI,uDAA+D,EAAA;;AAPnE;EAOI,sDAA+D,EAAA;;AAPnE;EAOI,qDAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAjBnE;EACE,wBAAoC,EAAA;;AADtC;EACE,yBAAoC,EAAA;;AADtC;EACE,wBAAoC,EAAA;;AADtC;EACE,yBAAoC,EAAA;;AADtC;EACE,sBAAoC,EAAA;;AAStC;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,yCAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,oCAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,yCAA+D,EAAA;;AAPnE;EAOI,wCAA+D,EAAA;;AAPnE;EAOI,wCAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,oCAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,uCAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,0BAA+D;EAA/D,yBAA+D,EAAA;;AAPnE;EAOI,gCAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,+BAA+D;EAA/D,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D;EAA/D,4BAA+D,EAAA;;AAPnE;EAOI,+BAA+D;EAA/D,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D;EAA/D,4BAA+D,EAAA;;AAPnE;EAOI,6BAA+D;EAA/D,4BAA+D,EAAA;;AAPnE;EAOI,wBAA+D;EAA/D,2BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,iCAA+D,EAAA;;AAPnE;EAOI,6BAA+D;EAA/D,gCAA+D,EAAA;;AAPnE;EAOI,2BAA+D;EAA/D,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D;EAA/D,gCAA+D,EAAA;;AAPnE;EAOI,2BAA+D;EAA/D,8BAA+D,EAAA;;AAPnE;EAOI,2BAA+D;EAA/D,8BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,2BAA+D;EAA/D,0BAA+D,EAAA;;AAPnE;EAOI,iCAA+D;EAA/D,gCAA+D,EAAA;;AAPnE;EAOI,gCAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,6BAA+D,EAAA;;AAPnE;EAOI,gCAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,6BAA+D,EAAA;;AAPnE;EAOI,yBAA+D;EAA/D,4BAA+D,EAAA;;AAPnE;EAOI,+BAA+D;EAA/D,kCAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,iCAA+D,EAAA;;AAPnE;EAOI,4BAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,iCAA+D,EAAA;;AAPnE;EAOI,4BAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,iBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,gDAA+D,EAAA;;AAPnE;EAOI,4CAA+D,EAAA;;AAPnE;EAOI,4CAA+D,EAAA;;AAPnE;EAOI,0CAA+D,EAAA;;AAPnE;EAOI,4CAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,qCAA+D,EAAA;;AAPnE;EAOI,wCAA+D,EAAA;;AAPnE;EAOI,oCAA+D,EAAA;;AAPnE;EAOI,oCAA+D,EAAA;;AAPnE;EAOI,qCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AArBnE,qBAAA;AAcA;EAOI,gCAA+D;EAA/D,iCAA+D,EAAA;;AAmBnE,mBAAA;AA1BA;EAIQ,oBAA4B;EAGhC,qEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,uEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,qEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,kEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,qEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,oEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,mEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,kEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,mEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,mEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,wEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,2CAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,oCAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,0CAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,2CAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,0CAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,0CAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,yBAA+D,EAAA;;AAjBnE;EACE,uBAAoC,EAAA;;AADtC;EACE,sBAAoC,EAAA;;AADtC;EACE,uBAAoC,EAAA;;AADtC;EACE,oBAAoC,EAAA;;AAStC;EAOI,iDAA+D,EAAA;;AAPnE;EAOI,mDAA+D,EAAA;;AAPnE;EAOI,iDAA+D,EAAA;;AAPnE;EAOI,8CAA+D,EAAA;;AAPnE;EAOI,iDAA+D,EAAA;;AAPnE;EAOI,gDAA+D,EAAA;;AAPnE;EAOI,+CAA+D,EAAA;;AAPnE;EAOI,8CAA+D,EAAA;;AAjBnE;EACE,sBAAoC,EAAA;;AAIpC;EACE,sBAAoC,EAAA;;AANxC;EACE,uBAAoC,EAAA;;AAIpC;EACE,uBAAoC,EAAA;;AANxC;EACE,sBAAoC,EAAA;;AAIpC;EACE,sBAAoC,EAAA;;AANxC;EACE,uBAAoC,EAAA;;AAIpC;EACE,uBAAoC,EAAA;;AANxC;EACE,oBAAoC,EAAA;;AAIpC;EACE,oBAAoC,EAAA;;AAIxC;EAOI,yCAA+D,EAAA;;AAKjE;EAOI,yCAA+D,EAAA;;AAnBrE;EAOI,wCAA+D,EAAA;;AAKjE;EAOI,wCAA+D,EAAA;;AAnBrE;EAOI,yCAA+D,EAAA;;AAKjE;EAOI,yCAA+D,EAAA;;AAnBrE;EAIQ,8BAA4B;EAGhC,+FAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,iGAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,+FAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,4FAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,+FAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,8FAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,6FAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,4FAA+D,EAAA;;AAPnE;EAIQ,8BAA4B;EAGhC,qGAA+D,EAAA;;AAjBnE;EACE,8BAAoC,EAAA;;AAIpC;EACE,8BAAoC,EAAA;;AANxC;EACE,gCAAoC,EAAA;;AAIpC;EACE,gCAAoC,EAAA;;AANxC;EACE,iCAAoC,EAAA;;AAIpC;EACE,iCAAoC,EAAA;;AANxC;EACE,gCAAoC,EAAA;;AAIpC;EACE,gCAAoC,EAAA;;AANxC;EACE,iCAAoC,EAAA;;AAIpC;EACE,iCAAoC,EAAA;;AANxC;EACE,8BAAoC,EAAA;;AAIpC;EACE,8BAAoC,EAAA;;AAIxC;EAIQ,kBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,gFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,6EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,wCAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,mFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,kFAA+D,EAAA;;AAjBnE;EACE,oBAAoC,EAAA;;AADtC;EACE,qBAAoC,EAAA;;AADtC;EACE,oBAAoC,EAAA;;AADtC;EACE,qBAAoC,EAAA;;AADtC;EACE,kBAAoC,EAAA;;AAStC;EAOI,wDAA+D,EAAA;;AAPnE;EAOI,0DAA+D,EAAA;;AAPnE;EAOI,wDAA+D,EAAA;;AAPnE;EAOI,qDAA+D,EAAA;;AAPnE;EAOI,wDAA+D,EAAA;;AAPnE;EAOI,uDAA+D,EAAA;;AAPnE;EAOI,sDAA+D,EAAA;;AAPnE;EAOI,qDAA+D,EAAA;;AAPnE;EAOI,+CAA+D,EAAA;;AAPnE;EAOI,mCAA+D;UAA/D,2BAA+D,EAAA;;AAPnE;EAOI,oCAA+D;UAA/D,4BAA+D,EAAA;;AAPnE;EAOI,oCAA+D;UAA/D,4BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,iDAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,oDAA+D,EAAA;;AAPnE;EAOI,iDAA+D,EAAA;;AAPnE;EAOI,oDAA+D,EAAA;;AAPnE;EAOI,oDAA+D,EAAA;;AAPnE;EAOI,qDAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,sDAA+D,EAAA;;AAPnE;EAOI,0DAA+D;EAA/D,2DAA+D,EAAA;;AAPnE;EAOI,oCAA+D;EAA/D,qCAA+D,EAAA;;AAPnE;EAOI,6DAA+D;EAA/D,8DAA+D,EAAA;;AAPnE;EAOI,0DAA+D;EAA/D,2DAA+D,EAAA;;AAPnE;EAOI,6DAA+D;EAA/D,8DAA+D,EAAA;;AAPnE;EAOI,6DAA+D;EAA/D,8DAA+D,EAAA;;AAPnE;EAOI,8DAA+D;EAA/D,+DAA+D,EAAA;;AAPnE;EAOI,sCAA+D;EAA/D,uCAA+D,EAAA;;AAPnE;EAOI,+DAA+D;EAA/D,gEAA+D,EAAA;;AAPnE;EAOI,2DAA+D;EAA/D,8DAA+D,EAAA;;AAPnE;EAOI,qCAA+D;EAA/D,wCAA+D,EAAA;;AAPnE;EAOI,8DAA+D;EAA/D,iEAA+D,EAAA;;AAPnE;EAOI,2DAA+D;EAA/D,8DAA+D,EAAA;;AAPnE;EAOI,8DAA+D;EAA/D,iEAA+D,EAAA;;AAPnE;EAOI,8DAA+D;EAA/D,iEAA+D,EAAA;;AAPnE;EAOI,+DAA+D;EAA/D,kEAA+D,EAAA;;AAPnE;EAOI,uCAA+D;EAA/D,0CAA+D,EAAA;;AAPnE;EAOI,gEAA+D;EAA/D,mEAA+D,EAAA;;AAPnE;EAOI,8DAA+D;EAA/D,6DAA+D,EAAA;;AAPnE;EAOI,wCAA+D;EAA/D,uCAA+D,EAAA;;AAPnE;EAOI,iEAA+D;EAA/D,gEAA+D,EAAA;;AAPnE;EAOI,8DAA+D;EAA/D,6DAA+D,EAAA;;AAPnE;EAOI,iEAA+D;EAA/D,gEAA+D,EAAA;;AAPnE;EAOI,iEAA+D;EAA/D,gEAA+D,EAAA;;AAPnE;EAOI,kEAA+D;EAA/D,iEAA+D,EAAA;;AAPnE;EAOI,0CAA+D;EAA/D,yCAA+D,EAAA;;AAPnE;EAOI,mEAA+D;EAA/D,kEAA+D,EAAA;;AAPnE;EAOI,6DAA+D;EAA/D,0DAA+D,EAAA;;AAPnE;EAOI,uCAA+D;EAA/D,oCAA+D,EAAA;;AAPnE;EAOI,gEAA+D;EAA/D,6DAA+D,EAAA;;AAPnE;EAOI,6DAA+D;EAA/D,0DAA+D,EAAA;;AAPnE;EAOI,gEAA+D;EAA/D,6DAA+D,EAAA;;AAPnE;EAOI,gEAA+D;EAA/D,6DAA+D,EAAA;;AAPnE;EAOI,iEAA+D;EAA/D,8DAA+D,EAAA;;AAPnE;EAOI,yCAA+D;EAA/D,sCAA+D,EAAA;;AAPnE;EAOI,kEAA+D;EAA/D,+DAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;A3DVvE;E2DGI;IAOI,sBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,uCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,0BAA+D;IAA/D,yBAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,wBAA+D;IAA/D,2BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,0BAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,yBAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,iBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA,EAElE;;A3DZL;E2DGI;IAOI,sBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,uCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,0BAA+D;IAA/D,yBAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,wBAA+D;IAA/D,2BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,0BAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,yBAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,iBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA,EAElE;;A3DZL;E2DGI;IAOI,sBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,uCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,0BAA+D;IAA/D,yBAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,wBAA+D;IAA/D,2BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,0BAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,yBAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,iBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA,EAElE;;A3DZL;E2DGI;IAOI,sBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,uCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,0BAA+D;IAA/D,yBAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,wBAA+D;IAA/D,2BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,0BAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,yBAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,iBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA,EAElE;;A3DZL;E2DGI;IAOI,sBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,uCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,0BAA+D;IAA/D,yBAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,wBAA+D;IAA/D,2BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,0BAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,yBAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,iBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA,EAElE;;ACxDT;ED+CQ;IAOI,4BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA,EAElE;;ACrCT;ED4BQ;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA,EAElE;;ApE3BT;EsE7CE,eAAe;EACf,gBCmCsB,EAAA;;AD9BxB;EACE,eAAe,EAAA;;AAGjB;EACE,gBAAgB,EAAA;;AENd;EFUF;IACE,eAAe,EAAA,EAChB;;AENC;EFUF;IACE,eAAe,EAAA,EAChB;;AENC;EFUF;IACE,eAAe,EAAA,EAChB;;AAIH;EACE,gBAAgB,EAAA;;AAGlB;EACE,iBAAiB,EAAA;;AAGnB;EACE,4BAA4B;EAC5B,6CAA4C,EAAA;;AAE9C;EACE,yBAAyB;EACzB,6CAAyC,EAAA;;AAE3C;EACE,2BAA2B;EAC3B,6CAA2C,EAAA;;AAE7C;EACE,0BAA0B;EAC1B,6CAA0C,EAAA;;AAE5C;EACE,yBAAyB;EACzB,6CAAyC,EAAA;;AG9D3C;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,4EACQ;EACR,sBAAsB;EACtB,4BAA4B,EAAA;EAP9B;IAUI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,WxENW,EAAA;IwERf;MAgBM,gBAAgB;MAChB,gBFyBgB;MExBhB,8BAA8B,EAAA;IAlBpC;MAqBM,6BAA6B;MAC7B,gBFiBkB,EAAA;EEvCxB;IA2BI,aAAa;IACb,uBAAuB;IACvB,gBAAgB,EAAA;IA7BpB;MAgCM,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,YAAY;MACZ,aAAa;MACb,oDAAqD;MACrD,4BAA4B;MAC5B,wBAAwB,EAAA;IAvC9B;MA0CM,YAAY;MACZ,aAAa,EAAA;;AC3CnB;EACE,aAAa;EACb,yBHewB;EGdxB,gBAAgB,EAAA;EAHlB;IAMI,WzEEW;IyEDX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB,EAAA;IAVrB;MAaM,gBH0BkB;MGzBlB,6BAA6B,EAAA;IAdnC;MAkBM,yBzELY;MyEMZ,WAAW;MACX,WAAW;MACX,YAAY;MACZ,cAAc;MACd,gBAAgB,EAAA;EAvBtB;IA4BI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,WzEzBW;IyE0BX,2BAA2B;IAC3B,iBAAiB,EAAA;IAnCrB;MAsCM,UAAU,EAAA;IAtChB;MA0CM,kBAAkB;MAClB,4DAA4D;MAC5D,YAAY;MACZ,kBAAkB;MAClB,UAAU,EAAA;EA9ChB;IAmDI,aAAa;IACb,uBAAuB,EAAA;IApD3B;MAsDM,kBAAkB;MAClB,YAAY;MACZ,WAAW;MACX,YAAY;MACZ,WzElDS;MyEmDT,6BAA6B;MAC7B,sBzEpDS;MyEqDT,kBAAkB;MAClB,6BAA6B,EAAA;;AC9DnC;EACE,WAAW;EACX,YAAY,EAAA;EAFd;IAII,mBAAmB,EAAA;EAJvB;IAOI,wBAAwB,EAAA;IAP5B;MASM,WAAW;MACX,aAAa;MACb,kBAAkB;MAClB,yB1EHY;M0EIZ,yB1EDY;M0EEZ,4CAA4C;MAC5C,qBAAqB;MACrB,YAAY;MACZ,cJAoB,EAAA;MIjB1B;QAmBQ,WAAW;QACX,aAAa;QACb,kBAAkB,EAAA;MArB1B;QAwBQ,uBAAuB;QACvB,yB1EXU,EAAA;M0EdlB;QA4BQ,4BAA4B;QAC5B,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,qBAAqB;QACrB,aAAa;QACb,4BAA4B,EAAA;MAlCpC;QAqCQ,kBAAkB;QAClB,eAAe;QACf,yBAAyB;QACzB,gBAAgB;QAChB,oBAAoB;QACpB,qBAAqB;QACrB,aAAa;QACb,4BAA4B,EAAA;;AC5CpC;EACE,aAAa;EACb,YAAY;EACZ,WAAW,EAAA;EAHb;IAKI,aAAa,EAAA;IALjB;MAOM,WAAW;MACX,iBAAiB;MACjB,gC3EGY;M2EFZ,mBAAmB,EAAA;MAVzB;QAYQ,aAAa,EAAA;QAZrB;UAcU,mBAAmB;UACnB,aAAa;UACb,sBAAsB;UACtB,cLAgB;UKChB,eAAe,EAAA;UAlBzB;YAoBY,0BAA0B;YAC1B,gBLqBU,EAAA;UK1CtB;YAwBY,kBAAkB;YAClB,yBAAyB;YACzB,iBAAiB,EAAA;QA1B7B;UA8BU,qBAAqB,EAAA;QA9B/B;UAiCU,iBAAiB,EAAA;;ACjC3B;EACE,aAAa;EACb,YAAY;EACZ,sB5EKa;E4EJb,cNHa,EAAA;EMDf;IAMI,kBAAkB;IAClB,mBAAmB,EAAA;EAPvB;IAUI,aAAa;IACb,6BAA6B;IAC7B,cNeiB,EAAA;;AO3BrB;EAEI,aAAa;EACb,aAAa;EACb,gCAAgC;EAChC,qBAAqB;EACrB,cAAc;EACd,aAAa,EAAA;EAPjB;IAUM,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IAEZ,YAAY;IACZ,6CAAmC,EAAA;IAfzC;MAkBQ,aAAa;MACb,YAAY;MACZ,gBAAgB,EAAA;IApBxB;MAuBQ,gBPkBmB;MOjBnB,8BAA8B;MAC9B,cPEa;MODb,eAAe;MACf,gBAAgB,EAAA;MAChB;QA5BR;UA6BU,eAAe;UACf,kBAAkB,EAAA,EAMrB;MAJC;QAhCR;UAiCU,cAAc;UACd,kBAAkB,EAAA,EAErB;IApCP;MAsCQ,gBPAc;MOCd,2BAA2B;MAC3B,eAAe;MACf,cPda;MOeb,gBAAgB,EAAA;MAEhB;QA5CR;UA6CU,cAAc,EAAA,EAKjB;MAHC;QA/CR;UAgDU,cAAc,EAAA,EAEjB;;AClDP;EACE,aAAa;EACb,YAAY;EACZ,sB9EKa;E8EJb,cRHa;EQIb,oBAAoB,EAAA;EALtB;IAQI,kBAAkB;IAClB,cAAc,EAAA;IATlB;MAaQ,gBR4BmB;MQ3BnB,cRaa;MQZb,8BAA8B;MAC9B,eAAe;MACf,mBAAmB,EAAA;IAjB3B;MAqBQ,gBRiBc;MQhBd,2BAA2B;MAC3B,eAAe;MACf,cRGa,EAAA;IQ3BrB;MA8BQ,eAAe;MACf,eAAe;MACf,YAAY,EAAA;IAhCpB;MAqCM,iBAAiB,EAAA;MArCvB;QAuCQ,yBRZa;QQab,UAAU;QACV,kBAAkB;QAClB,sB9ElCO;Q8EmCP,cRhBa;QQiBb,6BAA6B;QAC7B,aAAa;QACb,eAAe;QACf,YAAY,EAAA;;AC/CpB;EACI,UAAU;EACV,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,yBTe4B;ESd5B,sBAAsB,EAAA;;AAG1B;EACI,UAAU;EACV,iBAAiB;EACjB,yBTKsB;ESJtB,WAAW;EACX,eAAe;EACf,UAAU;EACV,kBAAkB,EAAA;EAClB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAA;EAEvB;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,sB/ElBO;I+EmBP,mBAAmB,EAAA;EAEvB;IACI,WAAW;IACX,2BAA2B;IAC3B,eAAe;IACf,eAAe;IACf,gBAAgB,EAAA;;AAIxB;EACI,wBAAwB;EACxB,WAAW;EACX,WAAW,EAAA;EACX;IACI,4BAA4B;IAC5B,cT3BkB;IS4BlB,eAAe,EAAA;EAEnB;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB,EAAA;EAEtB;IACI,2BAA2B;IAC3B,cTvCkB;ISwClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB,EAAA;EAEvB;IACI,aAAa,EAAA;EAEjB;IACI,YAAY;IACZ,YAAY;IACZ,yBAAgC;IAChC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,kBAAkB,EAAA;IAClB;MACI,yBAAyB,EAAA;IAE7B;MACI,YAAY;MACZ,kBAAkB;MAClB,YAAY;MACZ,wBAAwB;MACxB,6BAA6B,EAAA;IAEjC;MACI,6BAA6B;MAC7B,cTvEK,EAAA;ESuBjB;IAoDQ,YAAY;IACZ,kBAAkB;IAClB,YAAY,EAAA;EAtDpB;IAyDQ,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,yBTxFkB;ISyFlB,kBAAkB,EAAA;EApE1B;IAuEQ,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,yBTlGoB;ISmGpB,YAAY;IACZ,6BAA6B,EAAA;;AAGrC;EACI,yBAAyB;EACzB,WAAW,EAAA;;AtDKb;EuDlIE,yBVgBsB;EUftB,SAAS;EACT,cVCiB;EUAjB,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc,EAAA;EAZlB;IAcQ,yBVGkB;IUFlB,YAAY,EAAA;EAfpB;IAkBQ,oCAA8C;IAC9C,UAAU,EAAA;EAnBlB;IAsBQ,oCAAoC;IACpC,cVTe,EAAA;;AUavB;EACI,cVrBe;EUsBf,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,SAAS;EACT,aAAa,EAAA;;ACzCjB;EACI,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;EAC5B,sBAAsB,EAAA;EAL1B;IAQQ,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;IACnB,mBAAmB;IAEnB,2BAA2B;IAC3B,0CXWoC;IWVpC,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB,EAAA;IAtB9B;MAwBY,cXPc;MWQd,2BAA2B;MAC3B,mBAAmB,EAAA;;AC1B/B;EAEQ,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,cZPO;EYQP,kBAAkB,EAAA;;AAX1B;EAcQ,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,QAAQ;EACR,yBAAyB;EACzB,kBAAkB;EAClB,yBZVe,EAAA;EYdvB;IA2BY,2BAA2B;IAC3B,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,cZ3BS,EAAA;EYRrB;IAsCY,6BAA6B;IAC7B,WAAW;IACX,SAAS;IACT,UAAU,EAAA;IAzCtB;MA2CgB,aAAa;MACb,SAAS,EAAA;IA5CzB;MAgDoB,cZjCH,EAAA;EYfjB;;IAuDY,aAAa,EAAA;EAvDzB;IA2DY,6BAA6B;IAC7B,aAAa;IACb,SAAS;IACT,UAAU,EAAA;EA9DtB;IAiEY,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,2BAA2B;IAC3B,uBAAuB;IACvB,uBAAuB;IACvB,UAAU,EAAA;EAvEtB;IA2EY,YAAY;IACZ,2BAA2B;IAC3B,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,cZzEU,EAAA;;AY6EtB;EACI,aAAa;EACb,2BAA2B,EAAA;EAF/B;IAIQ,gBAAgB;IAChB,cZlFc,EAAA;EY6EtB;IAQQ,eAAe,EAAA;EARvB;IAWQ,2BAA2B;IAC3B,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,cZnGa,EAAA;;AaRrB;EACI,yBAAwB,EAAA;;AAE5B;EACI,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;EACpB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,sBAAsB,EAAA;EAX1B;IAaQ,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,cbfc;IagBd,SAAS,EAAA;EAxBjB;IA2BQ,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,UAAU,EAAA;;AAIlB;EACI,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,cbnDiB,EAAA;EaoCrB;IAkBQ,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,mBAAmB,EAAA;EArB3B;IAwBQ,cbhDU,EAAA;;AaoDlB;EACI,wCAAwC,EAAA;;AAE5C;;EAEI,wBAAwB;EACxB,SAAS,EAAA;;AAGb;EACI,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,yBbhEsB;EaiEtB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,cbvEsB,EAAA;;AcjB1B;EACI,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,SAAS,EAAA;;AAEb;EACI,yBdJiB;EcKjB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,uDAA6C,EAAA;EATjD;IAWQ,yBdUa;IcTb,cdFkB,EAAA;EcV1B;IAeQ,YAAY,EAAA;EAfpB;IAkBQ,+BdKa,EAAA;EcvBrB;IAqBQ,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,cdlBkB;IcmBlB,mBAAmB,EAAA;;AAG3B;EACI,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW,EAAA;EALf;IAOQ,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,SAAS;IACT,UAAU,EAAA;IAZlB;MAcY,cdpCc;McqCd,eAAe;MACf,mBAAmB;MACnB,oBAAoB;MACpB,kBAAkB;MAClB,gBAAgB;MAChB,sBAAsB;MACtB,kBAAkB,EAAA;EArB9B;IAyBQ,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,mBAAmB,EAAA;IA5B3B;MA8BY,qBAAqB;MACrB,cdrDc,EAAA;IcsB1B;;;MAoCY,iBAAiB;MACjB,eAAe;MACf,YAAY;MACZ,6BAA6B;MAC7B,kBAAkB;MAClB,UAAU;MACV,oBAAoB;MACpB,mBAAmB;MACnB,uBAAuB,EAAA;MA5CnC;;;QA8CgB,eAAe,EAAA;IA9C/B;MAkDY,WAAW;MACX,YAAY;MACZ,YAAY;MACZ,aAAa;MACb,sBAAsB;MACtB,2BAA2B;MAC3B,uBAAuB;MACvB,QAAQ;MACR,iBAAiB;MACjB,kBAAkB;MAClB,6BAA6B;MAC7B,yBdnFc,EAAA;McsB1B;QA+DgB,cdlGK,EAAA;IcmCrB;;MAoEY,ad1Fc,EAAA;IcsB1B;MAuEY,wBAA6B,EAAA;;AAIzC;EACI,aAAa;EACb,6BAA6B,EAAA;;AAGjC;;EAEI,SAAS;EACT,UAAU,EAAA;;ArF2Qd;EqFvQI,6BAA6B;EAC7B,WAAW,EAAA;;ArF6Sf;EqFzSI,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,yBd5Ha;Ec6Hb,gBAAgB;EAChB,0DAAkF;EAClF,4BAA4B;EAC5B,yCAAyC;EACzC,eAAe;EACf,cdhIsB;EciItB,6BAA6B,EAAA;;AAEjC;EACI,QAAQ;EACR,sBAAsB,EAAA;;AAE1B;EACI,aAAa,EAAA;;A3DgBjB;E2DZI,qBAAqB;EACrB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,cdjKe,EAAA;;AePnB;EACI,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB,EAAA;EAX1B;IAaQ,yBfuBc;IetBd,cfPW,EAAA;EePnB;IAiBQ,yBfgBW;IefX,cfgBiB,EAAA;EelCzB;IAqBQ,yBfPe;IeQf,cfCoB,EAAA;;AgBvB5B;EAEI,aAAa;EACb,8BAA8B;EAC9B,yBhB0BiB;EgBzBjB,4BAA4B,EAAA;EALhC;IAQM,eAAe;IACf,gBAAgB;IAChB,chBiBe,EAAA;;AgB3BrB;EAgBM,eAAe;EACf,gBhBuBkB;EgBtBlB,2BAA2B;EAC3B,chBQe;EgBPf,mBAAmB,EAAA;;AApBzB;;EAyBM,aAAa,EAAA;;AAzBnB;EA6BM,gBAAgB,EAAA;;AA7BtB;EAkCI,eAAe;EACf,gBhBKoB;EgBJpB,2BAA2B;EAC3B,chBViB;EgBWjB,qBAAqB,EAAA;;AAtCzB;EA0CI,aAAa;EACb,8BAA8B,EAAA;;AA3ClC;EA+CI,eAAe;EACf,gBhBRoB;EgBSpB,2BAA2B;EAC3B,chBvCkB;EgBwClB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB,EAAA;;ACrDxB;EACE,YAAY;EACZ,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,yBjBSqB,EAAA;EiBdvB;IAOI,aAAa;IACb,mBAAmB,EAAA;EARvB;IAWI,eAAe;IACf,eAAe,EAAA;EAZnB;IAeI,cjBJkB,EAAA;EiBXtB;IAkBI,cjBPkB;IiBQlB,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;IAClB,iBAAiB,EAAA;EAtBrB;IAyBI,aAAa,EAAA;EAzBjB;IA4BI,aAAa,EAAA;EA5BjB;IA+BI,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB,EAAA;IAnCvB;MAqCM,WAAW,EAAA;EArCjB;IAyCI,aAAa,EAAA;EAzCjB;IA4CI,YAAY;IACZ,eAAe,EAAA;IA7CnB;MA+CM,YAAY;MACZ,YAAY;MACZ,cjB1Ca;MiB2Cb,aAAa;MACb,8BAA8B;MAC9B,YAAY,EAAA;EApDlB;IAwDI,aAAa;IACb,YAAY;IACZ,gBAAgB,EAAA;IA1DpB;MA4DM,eAAe;MACf,aAAa,EAAA;EA7DnB;IAiEI,aAAa;IACb,gBAAgB,EAAA;IAlEpB;MAoEM,aAAa;MACb,kBAAiB,EAAA;MArEvB;QAuEQ,kBAAkB;QAClB,kBAAkB;QAClB,WAAW,EAAA;QAzEnB;UA2EU,WAAW;UACX,YAAY,EAAA;QA5EtB;UA+EU,yBjB5EK;UiB6EL,oBAAoB;UACpB,WAAW;UACX,YAAY;UACZ,SAAS;UACT,WAAW;UACX,kBAAkB,EAAA;UArF5B;YAwFU,QAAO;YACP,UAAU;YACV,kBAAkB,EAAA;IA1F5B;MAgGM,aAAa,EAAA;MAhGnB;QAoGQ,uBjB3FY;QiB4FZ,kBAAkB;QAClB,eAAe;QACf,WAAW;QACX,YAAY;QACZ,aAAa;QACb,uBAAuB;QACvB,mBAAmB,EAAA;MA3G3B;QA+GQ,qBjBzGO,EAAA;MiBNf;QAmHQ,SAAS;QACT,eAAe;QACf,cjBlGsB,EAAA;;AiBwG9B;EACE,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,cjBjH4B,EAAA;;AiBoH9B;EACE,6BAA6B;EAC7B,WAAW;EACX,SAAS;EACT,UAAU,EAAA;EAJZ;IAMI,aAAa;IACb,SAAS,EAAA;EAPb;IAUI,cjBlIa,EAAA;;AiBqIjB;EACE,cjBrHiB,EAAA;;AiBuHnB;EACE,gBjBzHsB,EAAA;;AiB2HxB;EACE,iBAAiB;EACjB,cjBzJa,EAAA;;AiB4Jf;EACE,UAAU;EACV,iBAAiB;EACjB,YAAY,EAAA;;AAEd;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,YAAY,EAAA;;AAGd;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,yBjBnJoB,EAAA;;AiBsJtB;EACE,UAAU;EACV,aAAa,EAAA;;AAEf;EACE,WAAW;EACX,aAAa;EACb,wBAAwB,EAAA;;AAE1B;EACE,WAAW;EACX,YAAY,EAAA;;AAId;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB,EAAA;;AAEnB;EAEE,cjBvMmB;EiBwMnB,kBAAkB;EAClB,eAAe;EACf,sBjBpMkB;EiBqMlB,mBAAmB;EACnB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,sCAAsC,EAAA;;AAGxC;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,yBjBzM4B;EiB0M5B,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB,EAAA;;AAEnB;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB,EAAA;;AAEpB;EAEE,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa,EAAA;;AAEf;EACE,aAAa,EAAA;;AAEf;EAEE,iBAAiB,EAAA;;ACnPnB;EACI,gBAAgB;EAChB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB,EAAA;EAJvB;IAMQ,yBlBiBoB,EAAA;;AmBvB5B;EACE,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB,EAAA;EACpB;IACE,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,eAAe,EAAA;EAEjB;IACE,yBzFCc;IyFAd,WAAW;IACX,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB,EAAA;;AAItB;EACE,cnBLwB,EAAA;;AmBO1B;EACE,yBnBRwB,EAAA;;AoBjB1B;EACE,aAAa;EACb,yBAAyB;EACzB,cpBcwB;EoBbxB,kBAAkB,EAAA;EAElB;IACE,sB1FCW;I0FAX,4BAA4B;IAC5B,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,eAAe,EAAA;EAGjB;IACE,eAAe;IACf,2BAA2B;IAC3B,mBAAmB,EAAA;EAGrB;IACE,eAAe;IACf,4BAA4B;IAC5B,mBAAmB,EAAA;EAGrB;IAhCF;MAiCI,mBAAmB,EAAA,EAEtB;;ACnCD;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,6BAA6B,EAAA;EAJ/B;IAOI,yBrBuBiB;IqBtBjB,YAAY;IACZ,oBAAoB,EAAA;IATxB;MAYM,YAAY;MACZ,crBce;MqBbf,2BAA2B,EAAA;EAdjC;IAmBI,aAAa,EAAA;IAnBjB;MAsBM,crBKe;MqBJf,oBAAoB,EAAA;IAvB1B;MA2BM,gBAAgB;MAChB,yBAA2B;MAC3B,kBAAkB;MAClB,WAAW;MACX,aAAa;MACb,iBAAiB;MACjB,mBAAmB;MACnB,aAAa;MACb,8BAA8B;MAC9B,sBAAsB,EAAA;MApC5B;QAuCQ,crBpBsB,EAAA;IqBnB9B;MA4CM,gBAAgB;MAChB,yBAA2B;MAC3B,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,iBAAiB;MACjB,mBAAmB;MACnB,aAAa;MACb,8BAA8B;MAC9B,sBAAsB,EAAA;MArD5B;QAwDQ,YAAY;QACZ,eAAe;QACf,gBAAgB;QAChB,gBAAgB;QAChB,crBpDa;QqBqDb,6BAA6B,EAAA;QA7DrC;UAgEU,crBjDO;UqBkDP,eAAe,EAAA;MAjEzB;QAsEQ,SAAS;QACT,YAAY;QACZ,WAAW;QACX,UAAU;QACV,wBAAwB,EAAA;MA1EhC;QA8EQ,crB3DsB,EAAA;MqBnB9B;QAkFQ,crBvEc;QqBwEd,6BAA6B,EAAA;MAnFrC;QAuFQ,YAAY;QACZ,SAAS;QACT,WAAW;QACX,UAAU;QACV,wBAAwB,EAAA;MA3FhC;QA+FQ,crBpFc;QqBqFd,6BAA6B,EAAA;MAhGrC;QAoGQ,crBjFsB,EAAA;MqBnB9B;QAwGQ,8DAA2D;QAC3D,WAAW;QACX,YAAY;QACZ,cAAc,EAAA;MA3GtB;QA+GQ,8DAA2D;QAC3D,WAAW;QACX,YAAY;QACZ,cAAc,EAAA;MAlHtB;QAsHQ,aAAa;QACb,2BAA2B;QAC3B,8BAA8B,EAAA;QAxHtC;UA2HU,crBhHY,EAAA;QqBXtB;UA+HU,crBxHS,EAAA;IqBPnB;MAoIM,yBrBtHiB,EAAA;IqBdvB;MAuIM,crB5HgB,EAAA;IqBXtB;MA0IM,UAAU;MACV,cAAc;MACd,8DAA2D;MAC3D,WAAW;MACX,YAAY,EAAA;IA9IlB;MAkJM,qBAAqB;MACrB,kBAAkB;MAClB,WAAW;MACX,YAAY,EAAA;IArJlB;MAyJM,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,yBrB9IiB;MqB+IjB,crBjJU;MqBkJV,mBAAmB;MACnB,eAAe;MACf,iCAAiC;MACjC,aAAa;MACb,6BAA6B;MAC7B,mBAAmB,EAAA;IAnKzB;MAuKM,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,OAAO;MACP,yBrB5JW;MqB6JX,oBAAoB;MACpB,iDAAiD,EAAA;IA7KvD;MAiLM,aAAa,EAAA;IAjLnB;MAqLM,yBrBtKW;MqBuKX,2BAA2B,EAAA;IAtLjC;MA0LM,aAAa;MACb,W3FnLS;M2FoLT,kBAAkB;MAClB,SAAS;MACT,8BAA8B,EAAA;IA9LpC;MAkMM,aAAa;MACb,W3F3LS;M2F4LT,kBAAkB;MAClB,SAAS;MACT,8BAA8B,EAAA;EAtMpC;IA2MI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,yBrB5L4B;IqB6L5B,+BAA+B;IAC/B,gCAAgC,EAAA;IAlNpC;MAqNM,aAAa;MACb,aAAa,EAAA;MAtNnB;QAyNQ,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,mBAAmB;QACnB,SAAS;QACT,iBAAiB;QACjB,kBAAkB;QAClB,crBxMa,EAAA;MqB3BrB;QAuOQ,YAAY;QACZ,YAAY;QACZ,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,mBAAmB;QACnB,SAAS;QACT,iBAAiB;QACjB,kBAAkB;QAClB,yBrBtNa;QqBuNb,W3F1OO,EAAA;;A2FgPf;EACE,cAAc,EAAA;;A5FgOhB;E4F5NE,YAAY,EAAA;;AC5PZ;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,mBAAmB,EAAA;;AAIvB;EACE,yBtBGwB;EsBFxB,YAAY;EACZ,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,W5FZa,EAAA;;A4Fef;EACE,YAAY;EACZ,8BtBRwB;EsBSxB,WAAW;EACX,UAAU;EACV,YAAY,EAAA;;AAGd;EACE,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB;EAClB,ctBpBwB;EsBqBxB,gBtBEsB;EsBDtB,yBtBtBwB;EsBuBxB,sB5FhCa;E4FiCb,6BAA6B,EAAA;;AAG/B;EACE,YAAY;EACZ,kBAAkB;EAClB,yBtB9BwB;EsB+BxB,YAAY;EACZ,6BAA6B,EAAA;;AAG/B;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,yBtB5CwB;EsB6CxB,kBAAkB;EAClB,YAAY;EACZ,eAAe,EAAA;;AAGjB;EACE,wBAAwB,EAAA;;AAG1B;EACE,YAAY;EACZ,YAAY,EAAA;;AAGd;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,gBtBtCoB;EsBuCpB,8BAA8B;EAC9B,kBAAkB,EAAA;;AAGpB;EACE,2BAA2B,EAAA;;AAG7B;EACE,4BAA4B;EAC5B,eAAe;EACf,SAAO;EACP,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW,EAAA;;AAGb;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,2BAA2B,EAAA;;AAG7B;EACE,aAAa;EACb,WAAW;EACX,aAAa;EACb,qBAAqB,EAAA;;AAGvB;EACE,YAAY;EACZ,wBAAwB;EACxB,cAAc;EACd,iBAAiB;EACjB,kBAAkB,EAAA;;AAGpB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,cAAc,EAAA;EANhB;IASI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc,EAAA;;AAIlB;EACE,aAAa;EACb,c5FnGe,EAAA;;A4FsGjB;;EAEE,6BAA6B,EAAA;;AAI7B;EACE,2BAA2B;EAC3B,eAAe,EAAA;;AAInB;EACE,gBAAgB;EAChB,yBAA2B;EAC3B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,sBAAsB,EAAA;EAVxB;IAaI,0DAAoT;IACpT,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB,EAAA;EAGzB;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,ctBrLW;IsBsLX,6BAA6B,EAAA;EAG/B;IACE,SAAS;IACT,YAAY;IACZ,WAAW;IACX,UAAU;IACV,wBAAwB,EAAA;EAG1B;IACE,ctBhL0B,EAAA;EsBmL5B;IACE,YAAY;IACZ,SAAS;IACT,YAAY;IACZ,WAAW;IACX,UAAU;IACV,wBAAwB,EAAA;EAG1B;IACE,ctB7L0B,EAAA;EsBgM5B;IACE,WAAW;IACX,YAAY;IACZ,yBAAqC;IACrC,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB,EAAA;EA9DpB;IAkEI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yB5FvLa;I4FwLb,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,aAAa,EAAA;;AAIjB;EACE,YAAY,EAAA;;AAGd;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;EAJrB;IAOI,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,yBtBvO0B,EAAA;;AsB2O9B;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW,EAAA;;AAzHb;;EA8HE,6BAA6B,EAAA;;AAG/B;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB,EAAA;;AAG3B;EACE;IACE,UAAU,EAAA;EAGZ;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,gBAAgB,EAAA;EAnQpB;IAuQI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kBAAkB,EAAA;EArPtB;IAyPI,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,yBtBlSsB;IsBmStB,kBAAkB;IAClB,YAAY,EAAA;EAGd;IACE,aAAa;IACb,oBAAoB;IACpB,mBAAmB,EAAA;IAEnB;MACE,kBAAkB,EAAA;IAGpB;MACE,YAAY;MACZ,mBAAmB,EAAA;IAGrB;MACE,gBtB7RgB;MsB8RhB,YAAY;MACZ,gBAAgB;MAChB,oBAAoB;MACpB,qBAAqB;MACrB,4BAAA;MACA,aAAa;MACb,4BAA4B,EAAA;EAIhC;IACE,iBAAiB;IACjB,2BAA2B,EAAA;EAG7B;IACE,8BAA8B;IAC9B,eAAe;IACf,gBAAgB;IAChB,cAAc,EAAA;EAGhB;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU,EAAA;EAGZ;IACE,eAAe,EAAA;EAGjB;IACE,8BAA8B;IAC9B,eAAe;IACf,gBAAgB,EAAA,EACjB;;AC7WH;EACE,qBAAqB;EACrB,eAAe;EACf,W7FKa;E6FJb,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,+BAA+B,EAAA;EAE/B;IACE,aAAa;IACb,mBAAmB;IACnB,cAAc,EAAA;EAGhB;IACE,2BAA2B,EAAA;IAC3B;MAFF;QAGI,eAAe,EAAA,EAElB;EA7BH;IAgCI,kBAAkB,EAAA;IAClB;MAjCJ;QAkCM,iBAAiB;QACjB,iBAAiB,EAAA,EAEpB;EArCH;IAwCI,eAAe,EAAA;EAxCnB;IA4CI,8BAA8B,EAAA;EAGhC;IACE,gBAAgB;IAChB,kBAAkB,EAAA;EAjDtB;IAqDI,4BAA4B;IAC5B,yBAAyB;IACzB,cvBtCsB,EAAA;EuBjB1B;IA2DI,2BAA2B,EAAA;EA3D/B;IA+DI,eAAe,EAAA;;AAInB;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,qBAAqB,EAAA;;AAGvB;EACE,cvBzD4B,EAAA;;AuB4D9B;EACE,iBAAiB;EACjB,yBAAyB;EACzB,aAAa,EAAA;EAHf;IAMI,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,mBAAmB,EAAA;EATvB;IAaI,4BAA4B,EAAA;EAbhC;IAiBI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,WAAW,EAAA;;AAIf;EACE,+BAA+B,EAAA;;ACzGjC;EACI,oCAAoC;EACpC,eAAe;EACf,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;EARvB;IAUQ,WAAW;IACX,YAAY;IACZ,yBxBKkB;IwBJlB,4BxBMsB;IwBLtB,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,sCAAsC,EAAA;;AAG1C;EACI;IACI,uBAAuB,EAAA;EAG3B;IACI,yBAAyB,EAAA,EAAA","sourcesContent":["@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.6 (https://getbootstrap.com/)\n   * Copyright 2011-2025 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n","@import \"~bootstrap/scss/bootstrap\";\n@import \"./styles/common.scss\";\n@import \"./styles/custom.scss\";\n@import \"./styles/pages.scss\";\n@import \"./styles/components.scss\";\n@import \"react-slideshow-image/dist/styles.css\";\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n  @include font-size($legend-font-size);\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.2 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG/#contrast-minimum\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(-1 * #{$pagination-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               var(--#{$prefix}body-color) !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n$carousel-control-icon-filter:       null !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default; // Deprecated in v5.3.4\n$carousel-dark-caption-color:        $black !default; // Deprecated in v5.3.4\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default; // Deprecated in v5.3.4\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-filter:           null !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default; // Deprecated in v5.3.4\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n    @include font-size($font-size);\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0;\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","// Bootstrap functions\n//\n// Utility mixins and functions for evaluating source code across our variables, maps, and mixins.\n\n// Ascending\n// Used to evaluate Sass maps like our grid breakpoints.\n@mixin _assert-ascending($map, $map-name) {\n  $prev-key: null;\n  $prev-num: null;\n  @each $key, $num in $map {\n    @if $prev-num == null or unit($num) == \"%\" or unit($prev-num) == \"%\" {\n      // Do nothing\n    } @else if not comparable($prev-num, $num) {\n      @warn \"Potentially invalid value for #{$map-name}: This map must be in ascending order, but key '#{$key}' has value #{$num} whose unit makes it incomparable to #{$prev-num}, the value of the previous key '#{$prev-key}' !\";\n    } @else if $prev-num >= $num {\n      @warn \"Invalid value for #{$map-name}: This map must be in ascending order, but key '#{$key}' has value #{$num} which isn't greater than #{$prev-num}, the value of the previous key '#{$prev-key}' !\";\n    }\n    $prev-key: $key;\n    $prev-num: $num;\n  }\n}\n\n// Starts at zero\n// Used to ensure the min-width of the lowest breakpoint starts at 0.\n@mixin _assert-starts-at-zero($map, $map-name: \"$grid-breakpoints\") {\n  @if length($map) > 0 {\n    $values: map-values($map);\n    $first-value: nth($values, 1);\n    @if $first-value != 0 {\n      @warn \"First breakpoint in #{$map-name} must start at 0, but starts at #{$first-value}.\";\n    }\n  }\n}\n\n// Colors\n@function to-rgb($value) {\n  @return red($value), green($value), blue($value);\n}\n\n// stylelint-disable scss/dollar-variable-pattern\n@function rgba-css-var($identifier, $target) {\n  @if $identifier == \"body\" and $target == \"bg\" {\n    @return rgba(var(--#{$prefix}#{$identifier}-bg-rgb), var(--#{$prefix}#{$target}-opacity));\n  } @if $identifier == \"body\" and $target == \"text\" {\n    @return rgba(var(--#{$prefix}#{$identifier}-color-rgb), var(--#{$prefix}#{$target}-opacity));\n  } @else {\n    @return rgba(var(--#{$prefix}#{$identifier}-rgb), var(--#{$prefix}#{$target}-opacity));\n  }\n}\n\n@function map-loop($map, $func, $args...) {\n  $_map: ();\n\n  @each $key, $value in $map {\n    // allow to pass the $key and $value of the map as an function argument\n    $_args: ();\n    @each $arg in $args {\n      $_args: append($_args, if($arg == \"$key\", $key, if($arg == \"$value\", $value, $arg)));\n    }\n\n    $_map: map-merge($_map, ($key: call(get-function($func), $_args...)));\n  }\n\n  @return $_map;\n}\n// stylelint-enable scss/dollar-variable-pattern\n\n@function varify($list) {\n  $result: null;\n  @each $entry in $list {\n    $result: append($result, var(--#{$prefix}#{$entry}), space);\n  }\n  @return $result;\n}\n\n// Internal Bootstrap function to turn maps into its negative variant.\n// It prefixes the keys with `n` and makes the value negative.\n@function negativify-map($map) {\n  $result: ();\n  @each $key, $value in $map {\n    @if $key != 0 {\n      $result: map-merge($result, (\"n\" + $key: (-$value)));\n    }\n  }\n  @return $result;\n}\n\n// Get multiple keys from a sass map\n@function map-get-multiple($map, $values) {\n  $result: ();\n  @each $key, $value in $map {\n    @if (index($values, $key) != null) {\n      $result: map-merge($result, ($key: $value));\n    }\n  }\n  @return $result;\n}\n\n// Merge multiple maps\n@function map-merge-multiple($maps...) {\n  $merged-maps: ();\n\n  @each $map in $maps {\n    $merged-maps: map-merge($merged-maps, $map);\n  }\n  @return $merged-maps;\n}\n\n// Replace `$search` with `$replace` in `$string`\n// Used on our SVG icon backgrounds for custom forms.\n//\n// @author Kitty Giraudel\n// @param {String} $string - Initial string\n// @param {String} $search - Substring to replace\n// @param {String} $replace ('') - New value\n// @return {String} - Updated string\n@function str-replace($string, $search, $replace: \"\") {\n  $index: str-index($string, $search);\n\n  @if $index {\n    @return str-slice($string, 1, $index - 1) + $replace + str-replace(str-slice($string, $index + str-length($search)), $search, $replace);\n  }\n\n  @return $string;\n}\n\n// See https://codepen.io/kevinweber/pen/dXWoRw\n//\n// Requires the use of quotes around data URIs.\n\n@function escape-svg($string) {\n  @if str-index($string, \"data:image/svg+xml\") {\n    @each $char, $encoded in $escaped-characters {\n      // Do not escape the url brackets\n      @if str-index($string, \"url(\") == 1 {\n        $string: url(\"#{str-replace(str-slice($string, 6, -3), $char, $encoded)}\");\n      } @else {\n        $string: str-replace($string, $char, $encoded);\n      }\n    }\n  }\n\n  @return $string;\n}\n\n// Color contrast\n// See https://github.com/twbs/bootstrap/pull/30168\n\n// A list of pre-calculated numbers of pow(divide((divide($value, 255) + .055), 1.055), 2.4). (from 0 to 255)\n// stylelint-disable-next-line scss/dollar-variable-default, scss/dollar-variable-pattern\n$_luminance-list: .0008 .001 .0011 .0013 .0015 .0017 .002 .0022 .0025 .0027 .003 .0033 .0037 .004 .0044 .0048 .0052 .0056 .006 .0065 .007 .0075 .008 .0086 .0091 .0097 .0103 .011 .0116 .0123 .013 .0137 .0144 .0152 .016 .0168 .0176 .0185 .0194 .0203 .0212 .0222 .0232 .0242 .0252 .0262 .0273 .0284 .0296 .0307 .0319 .0331 .0343 .0356 .0369 .0382 .0395 .0409 .0423 .0437 .0452 .0467 .0482 .0497 .0513 .0529 .0545 .0561 .0578 .0595 .0612 .063 .0648 .0666 .0685 .0704 .0723 .0742 .0762 .0782 .0802 .0823 .0844 .0865 .0887 .0908 .0931 .0953 .0976 .0999 .1022 .1046 .107 .1095 .1119 .1144 .117 .1195 .1221 .1248 .1274 .1301 .1329 .1356 .1384 .1413 .1441 .147 .15 .1529 .1559 .159 .162 .1651 .1683 .1714 .1746 .1779 .1812 .1845 .1878 .1912 .1946 .1981 .2016 .2051 .2086 .2122 .2159 .2195 .2232 .227 .2307 .2346 .2384 .2423 .2462 .2502 .2542 .2582 .2623 .2664 .2705 .2747 .2789 .2831 .2874 .2918 .2961 .3005 .305 .3095 .314 .3185 .3231 .3278 .3325 .3372 .3419 .3467 .3515 .3564 .3613 .3663 .3712 .3763 .3813 .3864 .3916 .3968 .402 .4072 .4125 .4179 .4233 .4287 .4342 .4397 .4452 .4508 .4564 .4621 .4678 .4735 .4793 .4851 .491 .4969 .5029 .5089 .5149 .521 .5271 .5333 .5395 .5457 .552 .5583 .5647 .5711 .5776 .5841 .5906 .5972 .6038 .6105 .6172 .624 .6308 .6376 .6445 .6514 .6584 .6654 .6724 .6795 .6867 .6939 .7011 .7084 .7157 .7231 .7305 .7379 .7454 .7529 .7605 .7682 .7758 .7835 .7913 .7991 .807 .8148 .8228 .8308 .8388 .8469 .855 .8632 .8714 .8796 .8879 .8963 .9047 .9131 .9216 .9301 .9387 .9473 .956 .9647 .9734 .9823 .9911 1;\n\n@function color-contrast($background, $color-contrast-dark: $color-contrast-dark, $color-contrast-light: $color-contrast-light, $min-contrast-ratio: $min-contrast-ratio) {\n  $foregrounds: $color-contrast-light, $color-contrast-dark, $white, $black;\n  $max-ratio: 0;\n  $max-ratio-color: null;\n\n  @each $color in $foregrounds {\n    $contrast-ratio: contrast-ratio($background, $color);\n    @if $contrast-ratio > $min-contrast-ratio {\n      @return $color;\n    } @else if $contrast-ratio > $max-ratio {\n      $max-ratio: $contrast-ratio;\n      $max-ratio-color: $color;\n    }\n  }\n\n  @warn \"Found no color leading to #{$min-contrast-ratio}:1 contrast ratio against #{$background}...\";\n\n  @return $max-ratio-color;\n}\n\n@function contrast-ratio($background, $foreground: $color-contrast-light) {\n  $l1: luminance($background);\n  $l2: luminance(opaque($background, $foreground));\n\n  @return if($l1 > $l2, divide($l1 + .05, $l2 + .05), divide($l2 + .05, $l1 + .05));\n}\n\n// Return WCAG2.2 relative luminance\n// See https://www.w3.org/TR/WCAG/#dfn-relative-luminance\n// See https://www.w3.org/TR/WCAG/#dfn-contrast-ratio\n@function luminance($color) {\n  $rgb: (\n    \"r\": red($color),\n    \"g\": green($color),\n    \"b\": blue($color)\n  );\n\n  @each $name, $value in $rgb {\n    $value: if(divide($value, 255) < .04045, divide(divide($value, 255), 12.92), nth($_luminance-list, $value + 1));\n    $rgb: map-merge($rgb, ($name: $value));\n  }\n\n  @return (map-get($rgb, \"r\") * .2126) + (map-get($rgb, \"g\") * .7152) + (map-get($rgb, \"b\") * .0722);\n}\n\n// Return opaque color\n// opaque(#fff, rgba(0, 0, 0, .5)) => #808080\n@function opaque($background, $foreground) {\n  @return mix(rgba($foreground, 1), $background, opacity($foreground) * 100%);\n}\n\n// scss-docs-start color-functions\n// Tint a color: mix a color with white\n@function tint-color($color, $weight) {\n  @return mix(white, $color, $weight);\n}\n\n// Shade a color: mix a color with black\n@function shade-color($color, $weight) {\n  @return mix(black, $color, $weight);\n}\n\n// Shade the color if the weight is positive, else tint it\n@function shift-color($color, $weight) {\n  @return if($weight > 0, shade-color($color, $weight), tint-color($color, -$weight));\n}\n// scss-docs-end color-functions\n\n// Return valid calc\n@function add($value1, $value2, $return-calc: true) {\n  @if $value1 == null {\n    @return $value2;\n  }\n\n  @if $value2 == null {\n    @return $value1;\n  }\n\n  @if type-of($value1) == number and type-of($value2) == number and comparable($value1, $value2) {\n    @return $value1 + $value2;\n  }\n\n  @return if($return-calc == true, calc(#{$value1} + #{$value2}), $value1 + unquote(\" + \") + $value2);\n}\n\n@function subtract($value1, $value2, $return-calc: true) {\n  @if $value1 == null and $value2 == null {\n    @return null;\n  }\n\n  @if $value1 == null {\n    @return -$value2;\n  }\n\n  @if $value2 == null {\n    @return $value1;\n  }\n\n  @if type-of($value1) == number and type-of($value2) == number and comparable($value1, $value2) {\n    @return $value1 - $value2;\n  }\n\n  @if type-of($value2) != number {\n    $value2: unquote(\"(\") + $value2 + unquote(\")\");\n  }\n\n  @return if($return-calc == true, calc(#{$value1} - #{$value2}), $value1 + unquote(\" - \") + $value2);\n}\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    max-width: 100%;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n    padding-left: $form-floating-padding-x;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  > textarea:focus,\n  > textarea:not(:placeholder-shown) {\n    ~ label::after {\n      position: absolute;\n      inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n      z-index: -1;\n      height: $form-floating-label-height;\n      content: \"\";\n      background-color: $input-bg;\n      @include border-radius($input-border-radius);\n    }\n  }\n  > textarea:disabled ~ label::after {\n    background-color: $input-disabled-bg;\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(-1 * #{$input-border-width}); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  // The top radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-grow: 1;\n    flex-basis: 0;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-grow: 1;\n  flex-basis: 100%;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      flex: 1 0 0;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-collapse,\n    > .accordion-header .accordion-button,\n    > .accordion-header .accordion-button.collapsed {\n      @include border-radius(0);\n    }\n    // stylelint-enable selector-max-class\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(-1 * #{$pagination-border-width}) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: var(--#{$prefix}progress-height); }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  &:not(.active) {\n    // Hover state\n    &:hover,\n    &:focus {\n      z-index: 1; // Place hover/focus items above their siblings for proper border styling\n      color: var(--#{$prefix}list-group-action-hover-color);\n      text-decoration: none;\n      background-color: var(--#{$prefix}list-group-action-hover-bg);\n    }\n\n    &:active {\n      color: var(--#{$prefix}list-group-action-active-color);\n      background-color: var(--#{$prefix}list-group-action-active-bg);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  filter: var(--#{$prefix}btn-close-filter);\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter-dark};\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include btn-close-white();\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    transform: $modal-fade-transform;\n    @include transition($modal-transition);\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}modal-header-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-left: auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  filter: var(--#{$prefix}carousel-control-icon-filter);\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: var(--#{$prefix}carousel-indicator-active-bg);\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: var(--#{$prefix}carousel-caption-color);\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg-dark};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color-dark};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter-dark};\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include carousel-dark();\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-left: auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n\n  // Fix to prevent overflowing children to become focusable\n  * {\n    overflow: hidden !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/WAI/WCAG22/Techniques/general/G1.html\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","@import \"constants.scss\";\n@import \"custom.scss\";\nbody {\n  font-size: 14px;\n  font-weight: $font-weight-normal;\n}\n\n//--------------MARGIN-----------------\n\n.mt-8px {\n  margin-top: 8px;\n}\n\n.mt-15px {\n  margin-top: 15px;\n}\n\n@include mobile {\n  .mt-sm-8px {\n    margin-top: 8px;\n  }\n}\n\n@include tablet {\n  .mt-md-8px {\n    margin-top: 8px;\n  }\n}\n\n@include desktop {\n  .mt-lg-8px {\n    margin-top: 8px;\n  }\n}\n\n//--------------PADDING-----------------\n.pt-8px {\n  padding-top: 8px;\n}\n\n.pt-15px {\n  padding-top: 15px;\n}\n//--------------FONT--------------------\n@font-face {\n  font-family: Lexend-SemiBold;\n  src: url(../assets/font/Lexend-SemiBold.ttf);\n}\n@font-face {\n  font-family: Lexend-Light;\n  src: url(../assets/font/Lexend-Light.ttf);\n}\n@font-face {\n  font-family: Lexend-Regular;\n  src: url(../assets/font/Lexend-Regular.ttf);\n}\n@font-face {\n  font-family: Lexend-Medium;\n  src: url(../assets/font/Lexend-Medium.ttf);\n}\n@font-face {\n  font-family: Inter-Medium;\n  src: url(../assets/font/Inter-Medium.ttf);\n}\n//--------------LINE HEIGHT-------------\n","//------COLOR-----------\n$black: #000000;\n$grey: #d9d9d9;\n$alert: #ff0000;\n$clear-white: #ffffff;\n$royal-blue: #0056b3;\n$blue0: #2196f3;\n$blue-cola: #0288d1;\n$outer-space: #454c53;\n$quick-silver0: #aaa;\n$quick-silver1: #ccc;\n$quick-silver: #9ea4aa;\n$silver: #c9cdd2;\n$light-silver: #d9d9d9;\n$bright-silver: #e8ebed;\n$emerald: #3b927d;\n$jonquild: #edd720;\n$background_color: #22493b;\n$background_translate: #486a5f;\n$background_color-300: #3b927d;\n$background_color_admin: #e2f1ef;\n$background_add-new: #ed6c02;\n$border_search: #8ac9bb;\n$border_image_color: #72787f;\n$box-shadow: rgba(34, 73, 59, 0.5);\n$box-shadow-signin: rgba(255, 255, 255, 0.1);\n$dark-green: rgba(34, 73, 59, 0.2);\n$dark-green1: #22493b;\n$powder-blue: #b7ded6;\n$powder-blue0: #f7f8f9;\n$bright-gray: #e2f1ef;\n$bright-gray0: #9ea4aaed;\n$dark-gray: #454c53;\n$gainsboro: #d5e5d6;\n$japanese_laurel: #2e7d32;\n\n$signal-white: #cce7f6;\n//------FONT-WEIGHT------\n$font-weight-thin: 300;\n$font-weight-normal: 400;\n$font-weight-medium: 500;\n$font-weight-semi-bold: 600;\n$font-weight-bold: 700;\n$font-weight-extra-bold: 800;\n","$screen-xs-max: 479px;\n$screen-sm-max: 767px;\n$screen-md-max: 1013px;\n$screen-lg-max: 1335px;\n$screen-xl-min: 1336px;\n$screen-xxl-up: 1441px; \n\n@mixin mobile {\n    @media (max-width: #{$screen-sm-max}) {\n        @content;\n    }\n}\n\n@mixin tablet {\n    @media (min-width: #{$screen-sm-max + 1}) and (max-width: #{$screen-md-max}) {\n        @content;\n    }\n}\n\n@mixin desktop {\n    @media (min-width: #{$screen-md-max + 1}) {\n        @content;\n    }\n}\n\n@mixin for-tablet-up {\n    @media (min-width: #{$screen-sm-max + 1}) {\n        @content;\n    }\n}\n\n",".scan-container {\n  height: 100vh;\n  width: 100vw;\n  margin: 0px;\n  background: url(\"../../assets/images/background_scan.png\") no-repeat center\n    center;\n  background-size: cover;\n  background-attachment: fixed;\n\n  .scan-header {\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    height: 100px;\n    color: $white;\n    &__title {\n      margin-top: 20px;\n      font-weight: $font-weight-bold;\n      font-family: \"Lexend-SemiBold\";\n    }\n    &__sub {\n      font-family: \"Lexend-Regular\";\n      font-weight: $font-weight-normal;\n    }\n  }\n\n  .scan-holder {\n    display: flex;\n    justify-content: center;\n    margin-top: 80px;\n\n    &__frame {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 280px;\n      height: 280px;\n      background: url(\"../../assets/images/scan_frame.svg\");\n      background-repeat: no-repeat;\n      background-size: contain;\n    }\n    &__reader {\n      width: 220px;\n      height: 220px;\n    }\n  }\n}\n",".empty-container {\n  height: 100vh;\n  background-color: $background_color;\n  overflow: hidden;\n\n  .empty-header {\n    color: $white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-top: 1rem;\n\n    h5 {\n      font-weight: $font-weight-normal;\n      font-family: \"Lexend-Regular\";\n    }\n\n    &__underline {\n      background-color: $gray-500;\n      width: 5rem;\n      height: 2px;\n      margin: auto;\n      display: block;\n      margin-top: 10px;\n    }\n  }\n\n  .empty-content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding-top: 2rem;\n    font-size: 16px;\n    color: $white;\n    font-family: \"Lexend-Light\";\n    line-height: 24px;\n\n    .empty-icon {\n      z-index: 9;\n    }\n\n    &__shape {\n      position: absolute;\n      background-image: linear-gradient(#006ba1, #e8f0f5, #a7c2bb);\n      opacity: 0.3;\n      border-radius: 50%;\n      left: 35vw;\n    }\n  }\n\n  .empty-footer {\n    display: flex;\n    justify-content: center;\n    &__btn {\n      position: absolute;\n      bottom: 3rem;\n      width: 90vw;\n      height: 4rem;\n      color: $white;\n      background-color: transparent;\n      border: 1px solid $white;\n      border-radius: 8px;\n      font-family: \"Lexend-Regular\";\n    }\n  }\n}",".new-container {\n  width: 100%;\n  height: 100%;\n  .news-header {\n    margin-bottom: 20px;\n  }\n  .news-content {\n    padding: 0 24px 5px 24px;\n    &__list {\n      width: 100%;\n      height: 177px;\n      border-radius: 8px;\n      background-color: $gray-100;\n      border: 1px solid $gray-400;\n      box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n      margin-bottom: 1.5rem;\n      padding: 8px;\n      color: $background_color;\n      .news-image {\n        width: 100%;\n        height: 108px;\n        margin-bottom: 8px;\n      }\n      .news-line {\n        margin: 0 -8px 4px -8px;\n        background-color: $gray-600;\n      }\n      .news-title {\n        font-family: Lexend-SemiBold;\n        font-size: 12px;\n        overflow: hidden;\n        display: -webkit-box;\n        -webkit-line-clamp: 1; \n        line-clamp: 1;\n        -webkit-box-orient: vertical;\n      }\n      .news-name {\n        margin-top: 0.2rem;\n        font-size: 11px;\n        font-family: Lexend-Light;\n        overflow: hidden;\n        display: -webkit-box;\n        -webkit-line-clamp: 1;\n        line-clamp: 1;\n        -webkit-box-orient: vertical;\n      }\n    }\n  }\n}\n",".address-container {\n  height: 100vh;\n  width: 100vw;\n  margin: 0px;\n  .address-content {\n    padding: 1rem;\n    .address-card {\n      width: 100%;\n      min-height: 100px;\n      border-bottom: 1px solid $gray-400;\n      margin-bottom: 1rem;\n      .address-item {\n        display: flex;\n        &__content {\n          margin-left: 0.8rem;\n          display: flex;\n          flex-direction: column;\n          color: $background_color;\n          font-size: 16px;\n          .address-location {\n            font-family: Lexend-Medium;\n            font-weight: $font-weight-bold;\n          }\n          .address-street {\n            margin-top: 0.5rem;\n            font-family: Lexend-Light;\n            line-height: 24px;\n          }\n        }\n        &__left-icon {\n          padding-right: 0.2rem;\n        }\n        &__right-icon {\n          margin-left: auto;\n        }\n      }\n    }\n  }\n}\n",".moreInfo-container {\n  height: 100vh;\n  width: 100vw;\n  background-color: $white;\n  color: $black;\n  .content {\n    padding-left: 45px;\n    padding-right: 25px;\n  }\n  .moreInfo-paragraph {\n    font-size: 16;\n    font-family: \"Lexend-Regular\";\n    color: $dark-green1;\n  }\n}\n",".certificates-container {\n  .certificates-content {\n    padding: 1rem;\n    display: grid;\n    grid-template-columns: auto auto;\n    justify-items: center;\n    grid-gap: 1rem;\n    row-gap: 1rem;\n\n    .certificates-item {\n      border-radius: 1rem;\n      background-color: white;\n      width: 178px;\n      // width: 100%;\n      height: auto;\n      box-shadow: $box-shadow 0px 3px 8px;\n      \n      &__image {\n        height: 131px;\n        width: 131px;\n        object-fit: fill;\n      }\n      &__name {\n        font-weight: $font-weight-semi-bold;\n        font-family: \"Lexend-SemiBold\";\n        color: $dark-green1;\n        font-size: 12px;\n        text-align: left;\n        @media (max-width: 360px) {\n          font-size: 10px;\n          margin-bottom: 1px;\n        }\n        @media (max-width: 280px) {\n          font-size: 8px;\n          margin-bottom: 2px;\n        }\n      }\n      &__year {\n        font-weight: $font-weight-thin;\n        font-family: \"Lexend-Light\";\n        font-size: 10px;\n        color: $dark-green1;\n        text-align: left;\n        \n        @media (max-width: 360px) {\n          font-size: 8px;\n        }\n        @media (max-width: 280px) {\n          font-size: 6px;\n        }\n      }\n    }\n  }\n}\n",".certificatesDetail-container {\n  height: 100vh;\n  width: 100vw;\n  background-color: $white;\n  color: $black;\n  margin-bottom: 163px;\n\n  .certificatesDetail-content {\n    text-align: center;\n    display: block;\n\n    .certificatesDetail-text {\n      .certificatesDetail-txtTitle {\n        font-weight: $font-weight-semi-bold;\n        color: $dark-green1;\n        font-family: \"Lexend-SemiBold\";\n        font-size: 12px;\n        margin-bottom: -4px;\n      }\n\n      .certificatesDetail-txtYear {\n        font-weight: $font-weight-thin;\n        font-family: \"Lexend-Light\";\n        font-size: 10px;\n        color: $dark-green1;\n      }\n    }\n\n    .certificatesDetail-paper {\n      .certificatesDetail-img {\n        padding: 0 24px;\n        max-width: 100%;\n        height: auto;\n      }\n    }\n\n    .certificatesDetail-Download {\n      padding-top: 10px;\n      .certificatesDetail-btnDownload {\n        border: 1px solid $dark-green1;\n        width: 35%;\n        border-radius: 8px;\n        background-color: $white;\n        color: $dark-green1;\n        font-family: \"Lexend-Regular\";\n        font-size: 14;\n        padding: 0 16px;\n        height: 40px;\n      }\n    }\n\n  }\n}",".admin-header {\n    padding: 0;\n    margin: 0;\n    width: 100%;\n    min-height: 100vh;\n    background-color: $background_color_admin;\n    box-sizing: border-box;\n}\n\n.sidebar {\n    width: 16%;\n    min-height: 100vh;\n    background-color: $background_color;\n    float: left;\n    position: fixed;\n    z-index: 1;\n    overflow-x: hidden;\n    &__header {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n    }\n    &__avt {\n        margin-top: 16px;\n        width: 40px;\n        height: 40px;\n        background-color: $white;\n        border-radius: 50px;\n    }\n    &__name {\n        color: #fff;\n        font-family: 'Lexend-Light';\n        font-size: 14px;\n        margin-top: 8px;\n        line-height: 1.2;\n    }\n}\n\n.header {\n    padding: 25px 0 25px 17%;\n    width: 100%;\n    height: 15%;\n    &__title {\n        font-family: 'Lexend-Medium';\n        color: $background_color;\n        font-size: 32px;\n    }\n    &__sub {\n        display: flex;\n        height: 2vh;\n        align-items: center;\n        justify-content: space-between;\n        margin-right: 14px;\n    }\n    &__subTitle {\n        font-family: 'Lexend-Light';\n        color: $background_color;\n        font-size: 18px;\n        margin-top: 16px;\n        height: 2.5rem;\n        display: flex;\n        align-items: center;\n    }\n    &__right {\n        display: flex;\n    }\n    &__search {\n        width: 309px;\n        height: 40px;\n        border: 1px $border_search solid;\n        border-radius: 8px;\n        display: flex;\n        align-items: center;\n        margin-right: 16px;\n        &__icon {\n            margin: 8px 10px 8px 16px;\n        }\n        &__input {\n            height: 40px;\n            border-radius: 8px;\n            border: none;\n            outline: none !important;\n            background-color: transparent;\n        }\n        &__input::placeholder {\n            font-family: 'Lexend-Regular';\n            color: $emerald;\n        }\n    }\n    .header-btn {\n        border: none;\n        border-radius: 8px;\n        height: 40px;\n    }\n    .filter {\n        width: 56px;\n        height: 40px;\n        flex-grow: 0;\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n        align-items: center;\n        gap: 10px;\n        padding: 1px 16px;\n        border-radius: 8px;\n        background-color: $background_color;\n        margin-right: 16px;\n    }\n    .addNew {\n        width: 133px;\n        height: 40px;\n        flex-grow: 0;\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n        align-items: center;\n        gap: 10px;\n        padding: 1px 16px;\n        border-radius: 8px;\n        background-color: $background_add-new;\n        color: white;\n        font-family: 'Lexend-Regular';\n    }\n}\n.children {\n    padding: 25px 1% 25px 17%;\n    width: 100%;\n}\n",".btn-primary {\n    background-color: $background_color;\n    border: 0;\n    color: $clear-white;\n    font-family: Lexend-Regular;\n    font-size: 14px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.5;\n    letter-spacing: normal;\n    text-align: center;\n    padding: 9.5px;\n    &:hover {\n        background-color: $background_color;\n        opacity: 0.9;\n    }\n    &:active {\n        background-color: $background_color !important;\n        opacity: 1;\n    }\n    &:disabled {\n        background-color: $silver !important;\n        color: $bright-silver;\n    }\n}\n\n.btn-text {\n    color: $blue-cola;\n    flex-grow: 0;\n    font-family: Lexend-Regular;\n    font-size: 14px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.5;\n    letter-spacing: normal;\n    text-align: center;\n    padding: 0;\n    margin: 0;\n    border: 0;\n    outline: none;\n}\n",".signin-container {\n    width: 100%;\n    min-height: 100vh;\n    object-fit: contain;\n    background-repeat: no-repeat;\n    background-size: cover;\n\n    .signin-content {\n        max-width: 728px;\n        padding: 25px 119px 57px;\n        object-fit: contain;\n        border-radius: 24px;\n        -webkit-backdrop-filter: blur(15px);\n        backdrop-filter: blur(15px);\n        background-color: $box-shadow-signin;\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-direction: column;\n        > h2 {\n            color: $background_color;\n            font-family: Lexend-Regular;\n            margin-bottom: 16px;\n        }\n    }\n}\n",".validation-input {\n    .error-message {\n        font-family: Lexend-Regular;\n        font-size: 12px;\n        font-weight: normal;\n        font-stretch: normal;\n        font-style: normal;\n        line-height: 1.5;\n        letter-spacing: normal;\n        text-align: left;\n        color: $alert;\n        padding-left: 16px;\n    }\n    .input-atom {\n        height: 62px;\n        align-self: stretch;\n        flex-grow: 0;\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n        align-items: flex-end;\n        gap: 4px;\n        padding: 8px 8px 8px 16px;\n        border-radius: 4px;\n        border: solid 1px $bright-silver;\n\n        label {\n            font-family: Lexend-Regular;\n            font-size: 12px;\n            font-weight: normal;\n            font-stretch: normal;\n            font-style: normal;\n            line-height: 1.5;\n            letter-spacing: normal;\n            text-align: left;\n            color: $outer-space;\n        }\n        input {\n            background-color: transparent;\n            width: 100%;\n            border: 0;\n            padding: 0;\n            &:focus {\n                outline: none;\n                border: 0;\n            }\n            &:focus {\n                ~ label {\n                    color: $emerald;\n                }\n            }\n        }\n\n        input[type='password']::-ms-reveal,\n        input[type='password']::-ms-clear {\n            display: none;\n        }\n\n        button {\n            background-color: transparent;\n            outline: none;\n            border: 0;\n            padding: 0;\n        }\n        .placeholder-group {\n            width: 100%;\n            display: flex;\n            flex-direction: column-reverse;\n            justify-content: flex-start;\n            justify-content: center;\n            align-items: flex-start;\n            padding: 0;\n        }\n\n        > input::placeholder {\n            flex-grow: 1;\n            font-family: Lexend-Regular;\n            font-size: 14px;\n            font-weight: normal;\n            font-stretch: normal;\n            font-style: normal;\n            line-height: 1.5;\n            letter-spacing: normal;\n            text-align: left;\n            color: $quick-silver;\n        }\n    }\n}\n.checkbox-group {\n    display: flex;\n    flex-direction: row-reverse;\n    :nth-child(1) {\n        margin-left: 8px;\n        color: $quick-silver;\n    }\n    :hover {\n        cursor: pointer;\n    }\n    label {\n        font-family: Lexend-Regular;\n        font-size: 14px;\n        font-weight: normal;\n        font-stretch: normal;\n        font-style: normal;\n        line-height: 1.5;\n        letter-spacing: normal;\n        text-align: left;\n        color: $outer-space;\n    }\n}\n",".error-message {\n    color: $alert !important;\n}\n.form-body {\n    width: 490px;\n    height: auto;\n    flex-grow: 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: stretch;\n    gap: 24px;\n    padding: 32px;\n    border-radius: 24px;\n    background-color: #fff;\n    .place-center {\n        align-self: stretch;\n        flex-grow: 0;\n        font-family: Lexend-Light;\n        font-size: 14px;\n        font-weight: normal;\n        font-stretch: normal;\n        font-style: normal;\n        line-height: 1.5;\n        letter-spacing: normal;\n        text-align: center;\n        color: $quick-silver;\n        margin: 0;\n    }\n    .frame {\n        align-self: stretch;\n        flex-grow: 0;\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: flex-start;\n        padding: 0;\n    }\n}\n\n.inner-frame {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 16px;\n    padding: 0;\n    font-family: Lexend-Light;\n    font-size: 16px;\n    font-weight: normal;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.5;\n    letter-spacing: normal;\n    text-align: left;\n    color: $clear-white;\n\n    img {\n        width: 194px;\n        height: 194px;\n        flex-grow: 0;\n        object-fit: contain;\n    }\n    span {\n        color: $jonquild;\n    }\n}\n\n.small-padding {\n    padding: 26px 33px 146px 34px !important;\n}\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\n.verified-code-input {\n    width: 74px !important;\n    height: 74px;\n    border-radius: 12px;\n    border: 1px solid $background_color;\n    font-family: Lexend-Light;\n    font-size: 24px;\n    font-weight: 300;\n    line-height: 1.5;\n    letter-spacing: normal;\n    text-align: center;\n    color: $background_color;\n}\n",".table-all {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: flex-start;\n    gap: 16px;\n}\n.table-atom {\n    background-color: $clear-white;\n    border-radius: 12px;\n    border-spacing: 0;\n    border-collapse: separate;\n    border: 0px;\n    overflow: hidden;\n    width: 100%;\n    font-family: Lexend-Light;\n    filter: drop-shadow(4px 4px 12px $box-shadow);\n    > thead {\n        background-color: $powder-blue;\n        color: $background_color;\n    }\n    td {\n        padding: 8px;\n    }\n    tbody td:not(:last-child) {\n        border-right: 1px solid $bright-gray;\n    }\n    .table-header {\n        font-family: Lexend-Medium;\n        font-size: 14px;\n        font-weight: 500;\n        font-stretch: normal;\n        font-style: normal;\n        line-height: 1.5;\n        letter-spacing: normal;\n        color: $background_color;\n        white-space: nowrap;\n    }\n}\n.pagination-footer {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    .page-item-control {\n        display: flex;\n        flex-direction: row;\n        justify-content: flex-start;\n        align-items: center;\n        gap: 11px;\n        padding: 0;\n        .rowcount-mess {\n            color: $background_color;\n            font-size: 12px;\n            font-weight: normal;\n            font-stretch: normal;\n            font-style: normal;\n            line-height: 1.5;\n            letter-spacing: normal;\n            text-align: center;\n        }\n    }\n    .pagination {\n        display: flex;\n        width: 100%;\n        justify-content: flex-end;\n        align-items: center;\n        .page-links {\n            text-decoration: none;\n            color: $background_color;\n        }\n        .page-items,\n        .next,\n        .previous {\n            margin-left: 12px;\n            min-width: 36px;\n            height: 36px;\n            border: 1px solid transparent;\n            border-radius: 4px;\n            color: red;\n            display: inline-flex;\n            align-items: center;\n            justify-content: center;\n            &:hover {\n                cursor: pointer;\n            }\n        }\n        .selected {\n            width: 40px;\n            height: 40px;\n            flex-grow: 0;\n            display: flex;\n            flex-direction: column;\n            justify-content: flex-start;\n            align-items: flex-start;\n            gap: 8px;\n            padding: 8px 16px;\n            border-radius: 4px;\n            border: solid 1px transparent;\n            background-color: $background_color;\n            > .page-links {\n                color: $clear-white;\n            }\n        }\n        .previous *,\n        .next * {\n            fill: $background_color;\n        }\n        .disabled * {\n            fill: $powder-blue !important;\n        }\n    }\n}\n.justify-content-evenlys {\n    display: flex;\n    justify-content: space-evenly;\n}\n\nul,\nli {\n    margin: 0;\n    padding: 0;\n}\n\nbutton {\n    background-color: transparent;\n    border: 0px;\n}\n\nselect {\n    width: 58px;\n    height: 40px;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    padding: 8px;\n    border-radius: 4px;\n    border: solid 1px $emerald;\n    appearance: none;\n    background-image: url(../../../../assets/icon/keyboard_arrow_down_green_20x20.svg);\n    background-repeat: no-repeat;\n    background-position: right 0.5rem top 50%;\n    font-size: 16px;\n    color: $background_color;\n    background-color: transparent;\n}\n.fit-content {\n    width: 0;\n    min-width: fit-content;\n}\n.button-group {\n    display: flex;\n}\n\n.btn-link {\n    text-decoration: none;\n    height: 24px;\n    flex-grow: 1;\n    font-family: Lexend-Light;\n    font-size: 16px;\n    font-weight: 300;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.5;\n    letter-spacing: normal;\n    text-align: left;\n    color: $blue-cola;\n}\n\n.fit-both {\n}\n",".chip-atom {\n    max-width: 100%;\n    height: 24px;\n    flex-grow: 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 0 8px;\n    border-radius: 8px;\n    white-space: nowrap;\n    min-width: min-content;\n    &.blue {\n        background-color: $signal-white;\n        color: $blue-cola;\n    }\n    &.green {\n        background-color: $gainsboro;\n        color: $japanese_laurel;\n    }\n    &.hidden {\n        background-color: $bright-silver;\n        color: $border_image_color;\n    }\n}\n",".create-product {\n  .create-product-header {\n    display: flex;\n    justify-content: space-between;\n    background-color: $bright-gray;\n    border-radius: 10px 10px 0 0;\n    \n    .create-product-txtHeader {\n      font-size: 16px;\n      font-weight: 500;\n      color: $dark-green1; \n    }\n  }\n\n  .create-product-body {\n    .create-product-txtGeneralInfo {\n      font-size: 14px;\n      font-weight: $font-weight-medium;\n      font-family: Lexend-Regular;\n      color: $dark-green1; \n      margin-bottom: 16px;\n    }\n\n    .create-product-1stInput,\n    .create-product-2ndInput {\n      display: flex;\n    }\n    \n    .create-product-2ndInput {\n      margin-top: 16px;\n    }\n  }\n\n  .txt-detail-info {\n    font-size: 14px;\n    font-weight: $font-weight-medium;\n    font-family: Lexend-Regular;\n    color: $dark-green1; \n    margin: 24px 0 16px 0;\n  }\n\n  .detail-info {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .change-units {\n    font-size: 14px;\n    font-weight: $font-weight-medium;\n    font-family: Lexend-Regular;\n    color: $quick-silver;\n    height: 18px;\n    margin-left: 32%;\n    margin-bottom: -10px;\n  }\n}\n",".product-input {\n  height: 62px;\n  width: 30%;\n  padding: 8px 8px 8px 16px;\n  border-radius: 4px;\n  border: solid 1px $bright-silver;\n  .attachment {\n    display: flex;\n    align-items: center;\n  }\n  .custom-upload-label {\n    font-size: 14px;\n    cursor: pointer;\n  }\n  .custom-datePicker {\n    color: $quick-silver;\n  }\n  .placeholder-text {\n    color: $quick-silver;\n    font-size: 14px;\n    font-family: Lexend Regular;\n    margin-right: 17px;\n    margin-top: 5.5px;\n  }\n  .custom-date {\n    display: none;\n  }\n  .custom-upload-input {\n    display: none;\n  }\n  .change-units {\n    margin-left: 0px;\n    margin-top: 4px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    .input-units {\n      width: 50px;\n    }\n  }\n  .units {\n    display: none;\n  }\n  .qr {\n    height: 21px;\n    margin-top: 4px;\n    .btn-qr {\n      width: 208px;\n      height: 21px;\n      color: $blue-cola;\n      display: flex;\n      justify-content: space-between;\n      padding: 0px;\n    }\n  }\n  .link {\n    display: flex;\n    height: 31px;\n    margin-top: -5px;\n    .link-options {\n      border-width: 0;\n      outline: none;\n    }\n  }\n  .pick-img {\n    display: flex;\n    margin-top: 10px;\n    .preview-container {\n      display: flex;\n      width:fit-content;\n      .preview-item {\n        position: relative;\n        margin-right: 10px;\n        width: 56px;\n        .preview-image {\n          width: 56px;\n          height: 56px;\n        }\n        .close-btn {\n          background-color: $alert;\n          border-radius: 100px;\n          width: 20px;\n          height: 20px;\n          top: -3px;\n          right: -3px;\n          position: absolute;\n        \n          .clear-icon{\n          top:2px;\n          right: 2px;\n          position: absolute;\n          }\n        }\n      }\n    }\n    .dropzone-container {\n      display: flex;\n      \n      \n      .dropzone {\n        border: 2px dashed $quick-silver0;\n        border-radius: 4px;\n        cursor: pointer;\n        width: 56px;\n        height: 56px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n      }\n\n      .dropzone.active {\n        border-color: $blue0;\n      }\n\n      .dropzone p {\n        margin: 0;\n        font-size: 24px;\n        color: $background_color-300;\n      }\n    }\n  }\n}\n\n.product-input > label {\n  font-family: Lexend-Regular;\n  font-size: 12px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  text-align: left;\n  color: $background_color-300;\n}\n\n.product-input input {\n  background-color: transparent;\n  width: 100%;\n  border: 0;\n  padding: 0;\n  &:focus {\n    outline: none;\n    border: 0;\n  }\n  &:focus ~ label {\n    color: $emerald;\n  }\n}\n.product-input .lbl-darkGray {\n  color: $dark-gray;\n}\n.product-input .lbl-darkGray0 {\n  color: $bright-gray0;\n}\n.product-input .label {\n  padding-left: 2px;\n  color: $alert;\n}\n\n.product-name {\n  width: 70%;\n  margin-left: 16px;\n  height: 62px;\n}\n.product-source {\n  width: 33.5%;\n  margin-left: 16px;\n  margin-right: 0;\n  height: 62px;\n\n}\n.product-QR {\n  width: 33.5%;\n  margin-left: 16px;\n  margin-right: 0;\n  height: 62px;\n  background-color: $powder-blue0;\n\n}\n.product-detail-info {\n  width: 49%;\n  height: 100px;\n}\n.product-imgUploading {\n  width: 100%;\n  height: 110px;\n  margin: 16px 16px 16px 0;\n}\n.product-link {\n  width: 100%;\n  height: 62px;\n  \n}\n// toggle swtich\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 61px;\n  height: 24px;\n  margin-left: 20px;\n}\n.toggle-switch .switch {\n  // span\n  color: $clear-white;\n  position: absolute;\n  cursor: pointer;\n  background-color: $quick-silver1;\n  border-radius: 25px;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  transition: background-color 0.2s ease;\n}\n\n.toggle-switch .switch::before {\n  position: absolute;\n  content: \"ml\";\n  width: 32px;\n  height: 24px;\n  background-color: $background_color-300;\n  border-radius: 50%;\n  transition: transform 0.3s ease;\n  padding-left: 5px;\n}\n.toggle-switch .switch::after {\n  position: absolute;\n  content: \"cc\";\n  transition: transform 0.3s ease;\n  margin-left: 40px;\n  border-radius: 50%;\n}\n.toggle-switch input[type=\"checkbox\"]:checked + .switch::before {\n  // within span be checked\n  transform: translateX(25px);\n  padding-left: 10px;\n  content: \"cc\";\n}\n.toggle-switch input[type=\"checkbox\"]:checked + .switch::after {\n  display: none;\n}\n.toggle-switch input[type=\"checkbox\"]:checked + .switch {\n  // left span when input be checked\n  padding-left: 5px;\n}\n",".hidden_box {\n    min-width: 100px;\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    > span > svg > path {\n        background-color: $border_image_color;\n    }\n}\n",".header-container {\n  flex-direction: row;\n  align-items: center;\n  padding-top: 1.5rem;\n  padding-left: 0.5rem;\n  &__title {\n    font-family: \"Lexend-Regular\";\n    text-align: center;\n    color: white;\n    font-size: 20px;\n  }\n  &__underline {\n    background-color: $gray-500;\n    width: 4rem;\n    height: 2px;\n    margin: auto;\n    display: block;\n    margin-top: 0.1rem;\n  }\n}\n\n.header-textGreen {\n  color: $background_color;\n}\n.header-underLineGreen {\n  background-color: $background_color;\n}\n",".footer-container {\n  display: flex;\n  justify-content: flex-end;\n  color: $background_color;\n  text-align: center;\n\n  &__background {\n    background-color: $white;\n    border-top-left-radius: 40px;\n    border-top-right-radius: 40px;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    padding: 10px 24px;\n    position: absolute;\n    bottom: 0px;\n    width: 100%;\n    min-height: 40%;\n  }\n\n  &__title {\n    font-size: 12px;\n    font-family: \"Lexend-Light\";\n    margin: 8px 0 4px 0;\n  }\n\n  &__titleBold {\n    font-size: 16px;\n    font-family: \"Lexend-Medium\";\n    margin: 8px 0 4px 0;\n  }\n\n  @media only screen and (max-width: 600px) {\n    margin: 8px 0 4px 0;\n  }\n}\n",".modal-wrapper {\n  min-width: 727px;\n  min-height: 100px;\n  border-radius: 0;\n  font-family: \"Lexend-Regular\";\n\n  .modal-header {\n    background-color: $bright-gray;\n    height: 56px;\n    padding: 18.5px 16px;\n\n    .header-text {\n      height: 19px;\n      color: $dark-green1;\n      font-family: \"Inter-Medium\";\n    }\n  }\n\n  .modal-children {\n    padding: 16px;\n\n    .sub-header {\n      color: $dark-green1;\n      padding-bottom: 16px;\n    }\n\n    .input-container-area {\n      text-align: left;\n      border: $gray-400 1px solid;\n      border-radius: 4px;\n      width: 100%;\n      height: 100px;\n      padding: 6px 16px;\n      margin-bottom: 16px;\n      display: flex;\n      flex-direction: column-reverse;\n      box-sizing: border-box;\n\n      textarea:focus+label {\n        color: $background_color-300;\n      }\n    }\n\n    .input-container {\n      text-align: left;\n      border: $gray-400 1px solid;\n      border-radius: 4px;\n      width: 100%;\n      height: 62px;\n      padding: 6px 16px;\n      margin-bottom: 16px;\n      display: flex;\n      flex-direction: column-reverse;\n      box-sizing: border-box;\n\n      &__title {\n        height: 18px;\n        font-size: 12px;\n        line-height: 1.5;\n        text-align: left;\n        color: $outer-space;\n        font-family: \"Lexend-Regular\";\n\n        &__green {\n          color: $emerald;\n          font-size: 12px;\n        }\n      }\n\n      &__input {\n        border: 0;\n        height: 24px;\n        width: 101%;\n        padding: 0;\n        outline: none !important;\n      }\n\n      input:focus+label {\n        color: $background_color-300;\n      }\n\n      &__input::placeholder {\n        color: $quick-silver;\n        font-family: \"Lexend-Regular\";\n      }\n\n      &__textarea {\n        resize: none;\n        border: 0;\n        width: 100%;\n        padding: 0;\n        outline: none !important;\n      }\n\n      &__textarea::placeholder {\n        color: $quick-silver;\n        font-family: \"Lexend-Regular\";\n      }\n\n      &__textarea:focus+&__title {\n        color: $background_color-300;\n      }\n\n      .link-icon {\n        background: url(../../assets/icon/attachment.svg) no-repeat;\n        width: 24px;\n        height: 24px;\n        display: block;\n      }\n\n      .date-icon {\n        background: url(../../assets/icon/date_range.svg) no-repeat;\n        width: 24px;\n        height: 24px;\n        display: block;\n      }\n\n      .link-label {\n        display: flex;\n        flex-direction: row-reverse;\n        justify-content: space-between;\n\n        .silver-text {\n          color: $quick-silver;\n        }\n\n        .blue-text {\n          color: $blue-cola;\n        }\n      }\n    }\n    .disable-background{\n      background-color: $bright-silver;\n    }\n    .disable-text{\n      color: $quick-silver;\n    }\n    input[type=\"date\"]::-webkit-calendar-picker-indicator {\n      opacity: 1;\n      display: block;\n      background: url(../../assets/icon/date_range.svg) no-repeat;\n      width: 24px;\n      height: 24px;\n    }\n\n    .toggle-container {\n      display: inline-block;\n      position: relative;\n      width: 61px;\n      height: 24px;\n    }\n\n    .toggle-switch-s {\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      background-color: $bright-silver;\n      color: $silver;\n      border-radius: 15px;\n      cursor: pointer;\n      transition: background-color 0.3s;\n      display: flex;\n      justify-content: space-around;\n      align-items: center;\n    }\n\n    .toggle-handle {\n      position: absolute;\n      width: 32px;\n      height: 22px;\n      left: 0;\n      background-color: $emerald;\n      border-radius: 100px;\n      transition: background-color 0.3s, transform 0.3s;\n    }\n\n    .toggle-input {\n      display: none;\n    }\n\n    .toggle-input:checked+.toggle-switch-s .toggle-handle {\n      background-color: $emerald;\n      transform: translateX(30px);\n    }\n\n    .toggle-input:checked+.toggle-switch-s .toggle-handle::after {\n      content: 'cc';\n      color: $white;\n      position: absolute;\n      left: 50%;\n      transform: translate(-50%, 2%);\n    }\n\n    .toggle-handle::after {\n      content: 'ml';\n      color: $white;\n      position: absolute;\n      left: 50%;\n      transform: translate(-50%, 2%);\n    }\n  }\n\n  .modal-footer {\n    width: 100%;\n    min-height: 72px;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    border: solid 1px $background_color_admin;\n    border-bottom-left-radius: 12px;\n    border-bottom-right-radius: 12px;\n\n    .modal-button {\n      display: flex;\n      padding: 16px;\n\n      &__cancel {\n        width: 60px;\n        height: 40px;\n        flex-grow: 0;\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n        align-items: center;\n        gap: 10px;\n        padding: 1px 16px;\n        border-radius: 8px;\n        color: $dark-green1;\n      }\n\n      &__submit {\n        width: 100px;\n        height: 40px;\n        flex-grow: 0;\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n        align-items: center;\n        gap: 10px;\n        padding: 1px 16px;\n        border-radius: 8px;\n        background-color: $dark-green1;\n        color: $white;\n      }\n    }\n  }\n}\n\n.swal2-container {\n  z-index: 10000;\n}\n\ntextarea {\n  resize: none;\n}",".product-container {\n  &__image {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  &__info {\n    display: flex;\n    align-items: center;\n  }\n}\n\n.background {\n  background-color: $background_color;\n  width: 100vw;\n  height: 100vh;\n  margin: 0;\n  min-height: 100%;\n  position: relative;\n  color: $white;\n}\n\n.product-line {\n  border: none;\n  border-top: 2px dashed $background_color;\n  height: 1px;\n  width: 95%;\n  opacity: 0.8;\n}\n\n.product-btn-div {\n  margin-top: 10px;\n}\n\n.wrong-btn {\n  border-radius: 8px;\n  color: $background_color;\n  font-weight: $font-weight-medium;\n  border: solid 1px $background_color;\n  background-color: $white;\n  font-family: \"Lexend-Regular\";\n}\n\n.correct-btn {\n  border: none;\n  border-radius: 8px;\n  background-color: $background_color;\n  color: white;\n  font-family: \"Lexend-Regular\";\n}\n\n.btn-discover {\n  height: 80px;\n  width: 300px;\n  margin-right: 10px;\n  border: none;\n  padding: 15px 32px;\n  text-align: center;\n  display: inline-block;\n  font-size: 16px;\n  background-color: $background_color;\n  border-radius: 8px;\n  color: white;\n  cursor: pointer;\n}\n\n.slide-container {\n  padding: 5px 25px 0 25px;\n}\n\n.product-info-container {\n  width: 100vw;\n  height: 90vh;\n}\n\n.product-info-title {\n  font-size: 20px;\n  display: flex;\n  justify-content: center;\n  font-weight: $font-weight-bold;\n  font-family: \"Lexend-SemiBold\";\n  text-align: center;\n}\n\n.infoTxt {\n  font-family: \"Lexend-Light\";\n}\n\n.product-info-right {\n  font-family: \"Lexend-Medium\";\n  margin-left: 10;\n  flex: 1;\n  font-weight: 500;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  color: #fff;\n}\n\n.footer-slide {\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n  font-size: 11px;\n  font-family: \"Lexend-Light\";\n}\n\n.slide-div {\n  height: 150px;\n  width: 100%;\n  display: flex;\n  align-content: center;\n}\n\n.slide-image {\n  height: 100%;\n  background-size: contain;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.dot {\n  width: 36px;\n  height: 36px;\n  border-radius: 100%;\n  background-color: #fff;\n  border: 0;\n  padding: 0 6px;\n\n  .dot-icon {\n    text-align: center;\n    align-self: center;\n    margin: 0 auto;\n  }\n}\n\n.required:after {\n  content: \" *\";\n  color: $red;\n}\n\ninput::placeholder,\ntextarea::placeholder {\n  font-family: \"Lexend-Regular\";\n}\n\n.product-incorrect-container {\n  &__subtitle {\n    font-family: \"Lexend-Light\";\n    font-size: 12px;\n  }\n}\n\n.card-container {\n  text-align: left;\n  border: $gray-400 1px solid;\n  border-radius: 4px;\n  width: 100%;\n  height: 60px;\n  padding: 6px 16px;\n  margin-bottom: 16px;\n  display: flex;\n  flex-direction: column-reverse;\n  box-sizing: border-box;\n\n  .upload-box {\n    background-image: url(\"data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='4' ry='4' stroke='%233B927DFF' stroke-width='4' stroke-dasharray='3%2c 11' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e\");\n    border-radius: 4px;\n    width: 45px;\n    height: 45px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  &__title {\n    display: block;\n    height: 24px;\n    width: 100%;\n    color: $black;\n    font-family: \"Lexend-Regular\";\n  }\n\n  &__input {\n    border: 0;\n    height: 24px;\n    width: 100%;\n    padding: 0;\n    outline: none !important;\n  }\n\n  &__input:focus+&__title {\n    color: $background_color-300;\n  }\n\n  &__textarea {\n    resize: none;\n    border: 0;\n    height: 48px;\n    width: 100%;\n    padding: 0;\n    outline: none !important;\n  }\n\n  &__textarea:focus+&__title {\n    color: $background_color-300;\n  }\n\n  &__image-preview {\n    width: 45px;\n    height: 45px;\n    border: $border_image_color 1px solid;\n    border-radius: 4px;\n    margin-right: 10px;\n    box-sizing: border-box;\n    object-fit: fill;\n  }\n\n  .remove-image-btn {\n    width: 15px;\n    height: 15px;\n    border-radius: 50%;\n    background-color: $red;\n    position: absolute;\n    right: 6px;\n    top: -4px;\n    display: flex;\n  }\n}\n\n.resize-height {\n  height: 85px;\n}\n\n.progress-container {\n  margin-top: 5px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .progress-bar {\n    position: relative;\n    overflow: hidden;\n    width: 45px;\n    height: 5px;\n    border-radius: 5px;\n    background-color: $background_translate;\n  }\n}\n\n.product-title {\n  width: 154px;\n  height: 24px;\n  flex-grow: 0;\n  font-family: Lexend;\n  font-size: 16px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.5;\n  letter-spacing: normal;\n  text-align: center;\n  color: #fff;\n}\n\ninput::placeholder,\ntextarea::placeholder {\n  font-family: \"Lexend-Regular\";\n}\n\n.product-otp {\n  padding: 35px 16.5px 35px 17px;\n  border-radius: 12px;\n  border: solid 1px #22493b;\n}\n\n@media only screen and (max-width: 600px) {\n  .image {\n    width: 80%;\n  }\n\n  .product-btn {\n    height: 50px;\n    width: 160px;\n    margin-right: 10px;\n    text-align: center;\n    font-size: 16px;\n    line-height: 5px;\n  }\n\n  .product-btn-div {\n    position: absolute;\n    bottom: 20px;\n    width: 100%;\n    text-align: center;\n  }\n\n  .btn-discover {\n    height: 50px;\n    width: 80%;\n    border: none;\n    text-align: center;\n    display: inline-block;\n    font-size: 16px;\n    background-color: $background_color;\n    border-radius: 8px;\n    color: white;\n  }\n\n  .product-info-content {\n    display: flex;\n    padding-bottom: 10px;\n    align-items: center;\n\n    &__icon {\n      padding-right: 5px;\n    }\n\n    &__name {\n      width: 130px;\n      padding-right: 15px;\n    }\n\n    &__value {\n      font-weight: $font-weight-bold;\n      width: 140px;\n      overflow: hidden;\n      display: -webkit-box;\n      -webkit-line-clamp: 2;\n      /* number of lines to show */\n      line-clamp: 2;\n      -webkit-box-orient: vertical;\n    }\n  }\n\n  .footer-title {\n    margin-left: 10px;\n    font-family: \"Lexend-Light\";\n  }\n\n  .product-name-p {\n    font-family: \"Lexend-SemiBold\";\n    font-size: 20px;\n    font-weight: 800;\n    min-width: 90%;\n  }\n\n  .product-context {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 90%;\n  }\n\n  .product-unit {\n    font-size: 14px;\n  }\n\n  .product-name-info {\n    font-family: \"Lexend-SemiBold\";\n    font-size: 22px;\n    text-align: left;\n  }\n}",".dashboard-item {\n  text-decoration: none;\n  font-size: 14px;\n  color: $white;\n  display: block;\n  border: none;\n  background: none;\n  width: 100%;\n  text-align: left;\n  cursor: pointer;\n  outline: none;\n  font-family: \"Lexend-Light\";\n  line-height: 16.8px;\n  padding: 16px 0 16px 16px;\n  margin: 16px 0 16px 16px;\n  border-top-left-radius: 20px;\n  border-bottom-left-radius: 20px;\n\n  &__header {\n    display: flex;\n    align-items: center;\n    max-width: 90%;\n  }\n\n  &__text {\n    font-family: \"Lexend-Light\";\n    @media (max-width: 1520px) {\n      font-size: 12px;\n    }\n  }\n\n  .icon-left {\n    margin-right: 11px;\n    @media (max-width: 1520px) {\n      margin-left: -5px;\n      margin-right: 5px;\n    }\n  }\n\n  .icon-right {\n    margin-left: 5%;\n  }\n\n  &.drop {\n    border-bottom-left-radius: 0px;\n  }\n\n  &__icon-left {\n    margin-left: 9px;\n    margin-right: 11px;\n  }\n\n  &.active {\n    font-family: \"Lexend-Medium\";\n    background-color: #e2f1ef;\n    color: $background_color;\n  }\n\n  &.active-non {\n    font-family: \"Lexend-Light\";\n  }\n\n  h6 {\n    font-size: 14px;\n  }\n}\n\n.spacing-icon {\n  width: 24px;\n  height: 24px;\n  flex-grow: 0;\n  margin: 0 11px 0 -7px;\n}\n\n.dashboard-item:hover {\n  color: $background_translate;\n}\n\n.dropdown-container {\n  margin-left: 16px;\n  background-color: #e2f1ef;\n  display: none;\n\n  a {\n    color: #22493b;\n    margin-top: 0;\n    margin-bottom: 0;\n    align-items: center;\n  }\n\n  a:active {\n    font-family: \"Lexend-Medium\";\n  }\n\n  .dot-active {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background-color: #ed6c02;\n    position: absolute;\n    right: 40px;\n  }\n}\n\n.dropdown-container:last-of-type {\n  border-bottom-left-radius: 20px;\n}",".bgLoading {\n    background-color: rgba(0, 0, 0, 0.5);\n    position: fixed;\n    z-index: 10;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    .loader {\n        width: 48px;\n        height: 48px;\n        border: 5px solid $background_color;\n        border-bottom-color: $background_color-300;\n        border-radius: 50%;\n        display: inline-block;\n        box-sizing: border-box;\n        animation: rotation 1s linear infinite;\n    }\n\n    @keyframes rotation {\n        0% {\n            transform: rotate(0deg);\n        }\n\n        100% {\n            transform: rotate(360deg);\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
